//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { AxiosPromise } from 'axios';
import { ApiService, AxiosMethod, IAjaxOptions } from '@Services';
export class BaseApiModelClass< T > {
    constructor(data?: T & {}) {
        if (data)
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (< any >this)[property] = (< any >data)[property];
    }
}
export interface IGetForGridParams {
    type?: AgileUnitType
}
export interface IGetByIdParams {
    id: number
}
export interface IDeleteParams {
    id: number
}
export interface ICreateParams {
    body?: AgileUnitCreateModel
}
export interface IUpdateParams {
    body?: AgileUnitUpdateModel
}
export interface IGetCurrencyLookupModelsParams {
}
export interface IGetAgreementChaptersByPrimaryCostAgreementIdParams {
    primaryCostAgreementId?: number
}
export interface ICreate2Params {
    body?: AgreementChapterCreateModel
}
export interface IGetForGrid2Params {
    agreementChapterId?: number
}
export interface ICreate3Params {
    body?: AgreementChapterItemCreateModel
}
export interface IUpdate2Params {
    body?: AgreementChapterItemUpdateModel
}
export interface IDelete2Params {
    id?: number
}
export interface IGetAgreementPGsByServiceAgreementIdParams {
    serviceAgreementId?: number
}
export interface ICreate4Params {
    body?: AgreementPGCreateModel
}
export interface IGetForGrid3Params {
    agreementPGId?: number
}
export interface ICreate5Params {
    body?: AgreementPGItemCreateModel
}
export interface IUpdate3Params {
    body?: AgreementPGItemUpdateModel
}
export interface IDelete3Params {
    id?: number
}
export interface IUploadParams {
    financialYearId: number
    poolingEntityId: number
    file?: FileParameter
}
export interface IUploadInflationRatesParams {
    financialYearId: number
    file?: FileParameter
}
export interface IGetForGrid4Params {
}
export interface IGetYearWithLocationsSidebarParams {
}
export interface IGetForGrid5Params {
}
export interface IGetById2Params {
    id?: number
}
export interface IUpdate4Params {
    body?: AppInputUpdateModel
}
export interface IReadyForApproval1Params {
    appInputId: number
}
export interface IApprove1Params {
    appInputId: number
}
export interface IDeny1Params {
    appInputId: number
}
export interface IReadyForApproval2Params {
    appInputId: number
}
export interface IApprove2Params {
    appInputId: number
}
export interface IDeny2Params {
    appInputId: number
}
export interface IReadyForApproval3Params {
    appInputId: number
}
export interface IApprove3Params {
    appInputId: number
}
export interface IDeny3Params {
    appInputId: number
}
export interface IAppInputCalculationParams {
    financialYearId: number
}
export interface IGetForGrid6Params {
}
export interface IGetAllModelsParams {
}
export interface IUpdate5Params {
    body?: { [key: string]: AppOutflowStatus; }
}
export interface IApproveParams {
    appOutflowId: number
}
export interface ICalculateAppOutflowParams {
    financialYearId: number
}
export interface IGetForGrid7Params {
    objectUniqueId?: string
}
export interface IDownloadParams {
    attachmentId?: number
}
export interface ICreateAttachmentFileParams {
    uploadedFile?: FileParameter
    objectUniqueId?: string
    type?: AttachmentType
    category?: AttachmentCategory
    description?: string
}
export interface ICreateAttachmentLinkParams {
    linkDisplayName?: string
    linkAddress?: string
    objectUniqueId?: string
    type?: AttachmentType
    category?: AttachmentCategory
    description?: string
}
export interface IDelete4Params {
    attachmentId?: number
}
export interface IGetLogParams {
    objectUniqueId?: string
}
export interface IGetForGrid8Params {
    agileUnitId?: number
    agileUnitType?: AgileUnitType
}
export interface IGetById3Params {
    id?: number
}
export interface ICreate6Params {
    body?: ChapterCreateModel
}
export interface IUpdate6Params {
    body?: ChapterUpdateModel
}
export interface IDelete5Params {
    id?: number
}
export interface IGetChapterLookupModelsParams {
}
export interface IGetForGrid9Params {
    chapterId?: number
}
export interface IGetById4Params {
    chapterSplitId?: number
}
export interface ICreate7Params {
    body?: ChapterSplitCreateModel
}
export interface IUpdate7Params {
    body?: ChapterSplitUpdateModel
}
export interface IDelete6Params {
    id?: number
}
export interface IGetAppConfigurationsParams {
}
export interface IGetInformationWidgetModelParams {
}
export interface IUpdateAppConfigurationParams {
    body?: UpdateDbConfigurationModel
}
export interface IGetLookupModelsParams {
}
export interface IGetTasksForCurrentPrincipalParams {
}
export interface IGetAccrualsForReportingPeriodParams {
    reportingPeriodId?: number
}
export interface IGetPrimaryCostReportWidgetModelsParams {
    reportingPeriodQuarterName?: string
}
export interface IGetForWidgetParams {
    financialYearCodeName?: string
}
export interface IPingParams {
}
export interface IGetVersionParams {
}
export interface IGetForGrid10Params {
}
export interface IGenerateEmployeeGapReportParams {
    reportingPeriodId: number
    poolingEntityId: number
}
export interface IGetById5Params {
    id?: number
}
export interface IReadyForConfirmationParams {
    employeeGapReportId: number
}
export interface IGetForGrid11Params {
}
export interface IGetAllItemsForApprovalParams {
}
export interface IGetItemByEmployeeGapReportIdParams {
    employeeGapReportId: number
}
export interface IGetById6Params {
    id?: number
}
export interface IConfirmParams {
    employeeGapReportItemId: number
    comment?: string
}
export interface IDenyParams {
    employeeGapReportItemId: number
    comment?: string
}
export interface IApproveAllParams {
    body?: number[]
}
export interface IGetAllParams {
}
export interface IGetPersonsByEmployeeGapReportItemIdParams {
    employeeGapReportItemId: number
}
export interface IGetById7Params {
    id?: number
}
export interface IExportEmployeeGapReportParams {
    reportingPeriodCodeName: string
}
export interface IGetAttachmentTypeParams {
}
export interface IGetAttachmentCategoryParams {
}
export interface IGetAgileUnitTypesParams {
}
export interface IGetChapterTypesParams {
}
export interface IPostParams {
    body?: ClientErrorModel
}
export interface IGetFinancialYearLookupModelsParams {
}
export interface IPrimaryCostAgreementsParams {
    poolingEntityId?: number
    mgtOrgUnitCodeName?: string
    legalOrgUnitCodeName?: string
    date?: Date
    page?: number
    pageSize?: number
}
export interface IPrimaryCostAccrualsParams {
    poolingEntityCodeName?: string
    localUnitDivisionCodeName?: string
    localUnitCompanyCodeName?: string
    subFunctionCodeName?: string
    functionCodeName?: string
    reportingPeriodCodeName?: string
    budgetCurrency?: string
    budgetCurrencyYear?: number
}
export interface IPrimaryCostReportsParams {
    poolingEntityCodeName?: string
    localUnitDivisionCodeName?: string
    localUnitCompanyCodeName?: string
    subFunctionCodeName?: string
    functionCodeName?: string
    reportingPeriodCodeName?: string
    budgetCurrency?: string
    budgetCurrencyYear?: number
}
export interface IPrimaryCostYTDsParams {
    poolingEntityCodeName?: string
    localUnitDivisionCodeName?: string
    localUnitCompanyCodeName?: string
    subFunctionCodeName?: string
    functionCodeName?: string
    reportingPeriodCodeName?: string
    budgetCurrency?: string
    budgetCurrencyYear?: number
}
export interface IAppInflowsParams {
    poolingEntityCodeName?: string
    localUnitDivisionCodeName?: string
    localUnitCompanyCodeName?: string
    function?: string
    subFunction?: string
    financialYear?: number
}
export interface IListParams {
}
export interface IGetById8Params {
    id: string
}
export interface IStartParams {
    jobName: string
    body?: JobStartModel
}
export interface IParametersGETParams {
    jobName: string
    triggerName?: string
}
export interface IParametersPOSTParams {
    cronExpression: string
}
export interface IParametersPOST2Params {
    triggerName: string
    body?: JobSaveParametersModel
}
export interface ISettingsParams {
    jobName: string
    body?: JobSaveParametersModel
}
export interface ICreate8Params {
    body?: JobSaveParametersModel
}
export interface IDelete7Params {
    triggerId?: string
    jobName?: string
}
export interface IIsTriggerNameUniqueParams {
    triggerName?: string
}
export interface IStopParams {
    jobName: string
    jobExecutionId: string
}
export interface IGetForGrid12Params {
}
export interface IGetLocalUnitLookupModelsParams {
}
export interface IGetPageTitleParams {
    id?: number
}
export interface IGetById9Params {
    id?: number
}
export interface ICreate9Params {
    body?: LocalUnitCreateModel
}
export interface IUpdate8Params {
    body?: LocalUnitUpdateModel
}
export interface IDelete8Params {
    id?: number
}
export interface IGetForGrid13Params {
    localUnitId?: number
}
export interface IGetById10Params {
    id?: number
}
export interface ICreate10Params {
    body?: LocalUnitIsOverheadCreateModel
}
export interface IUpdate9Params {
    body?: LocalUnitIsOverheadUpdateModel
}
export interface IDelete9Params {
    id?: number
}
export interface IGetForGridByLocalUnitIdParams {
    localUnitId?: number
}
export interface IGetById11Params {
    localUnitLocationId?: number
}
export interface ICreate11Params {
    body?: LocalUnitLocationCreateModel
}
export interface IUpdate10Params {
    body?: LocalUnitLocationUpdateModel
}
export interface IDelete10Params {
    id?: number
}
export interface IGetLocalUnitLookupModels2Params {
}
export interface IGetForGrid14Params {
    localUnitLocationId?: number
}
export interface IGetPoolingByIdParams {
    localUnitLocationPGId?: number
}
export interface ICreate12Params {
    body?: LocalUnitLocationPGCreateModel
}
export interface IUpdate11Params {
    body?: LocalUnitLocationPGUpdateModel
}
export interface IDelete11Params {
    id?: number
}
export interface IGetLocalUnitLocationPGsParams {
    localUnitLocationId?: number
}
export interface IGetForGrid15Params {
}
export interface IGetById12Params {
    id?: number
}
export interface ICreate13Params {
    body?: MarkupCreateModel
}
export interface IUpdate12Params {
    body?: MarkupUpdateModel
}
export interface IDelete12Params {
    id?: number
}
export interface IGetListParams {
}
export interface IGetMessageTypesParams {
}
export interface IGetById13Params {
    id?: number
}
export interface IGetForTreeParams {
    parentOrgUnitId?: number
}
export interface IGetForLicensorDivisionParams {
    parentOrgUnitId?: number
}
export interface IGetOrgUnitLookupModelsParams {
    objectType?: string
    includeId?: number
    validFrom?: Date
    validTo?: Date
}
export interface IUpdate13Params {
    body?: OrgUnitUpdateModel
}
export interface IGetForGrid16Params {
    orgUnitId?: number
}
export interface ICreateInflationRateParams {
    body?: OrgUnitInflationRateCreateModel
}
export interface IUpdateInflationRateParams {
    body?: OrgUnitInflationRateUpdateModel
}
export interface IServiceBeneficiaryYTDsParams {
    poolingEntityCodeName?: string
    serviceBeneficiaryUnitDivisionCodeName?: string
    serviceBeneficiaryUnitCompanyCodeName?: string
    pGCodeName?: string
    reportingPeriodCodeName?: string
    budgetCurrency?: string
    budgetCurrencyYear?: number
}
export interface IAppOutflowsParams {
    poolingEntityCodeName?: string
    serviceBeneficiaryUnitDivisionCodeName?: string
    serviceBeneficiaryUnitCompanyCodeName?: string
    pgCodeName?: string
    financialYear?: number
}
export interface IUpload2Params {
    reportingPeriodCodeName: string
    poolingEntityId: number
    file?: FileParameter
}
export interface IGetForGrid17Params {
}
export interface IGetPaymentTermsByIdParams {
    poolingEntityId?: number
}
export interface IGetById14Params {
    id?: number
}
export interface ICreate14Params {
    body?: PoolingEntityCreateModel
}
export interface IUpdate14Params {
    body?: PoolingEntityUpdateModel
}
export interface IDelete13Params {
    id?: number
}
export interface IGetPoolingEntityTargetsParams {
}
export interface IGetPoolingEntityLookupModelsParams {
}
export interface IGetAgreementChaptersByPrimaryCostAgreementId2Params {
    primaryCostAgreementId?: number
    reportingPeriodId?: number
}
export interface IGetAccrualsInflowModelsParams {
}
export interface IGetReportingPeriodWithAccrualsParams {
    primaryCostAgreementId?: number
}
export interface IReadyForApprovalParams {
    primaryCostAccrualId: number
}
export interface IApprove22Params {
    primaryCostAccrualId: number
}
export interface IDeny22Params {
    primaryCostAccrualId: number
}
export interface IDelete14Params {
    id?: number
}
export interface IDownloadAccrualsByPrimaryCostAccrualIdParams {
    primaryCostAccrualId?: number
}
export interface IDownloadAccrualsByReportingPeriodIdParams {
    reportingPeriodCodeName?: string
}
export interface IUploadAccrualsParams {
    file?: FileParameter
}
export interface IReportParams {
    primaryCostAccrualId: number
}
export interface IAccrualCalculationParams {
    reportingPeriodId: number
}
export interface IGetAgreementChaptersByPrimaryCostAgreementId3Params {
    primaryCostAccrualId?: number
}
export interface IUpdate15Params {
    body?: PrimaryCostAccrualItemUpdateModel
}
export interface IImportTemplateParams {
    primaryCostAccrualId: number
}
export interface IUploadAccruals2Params {
    primaryCostAccrualId: number
    file?: FileParameter
}
export interface IGetForGrid18Params {
}
export interface IGetLocalUnitsGroupedByPoolingEntityParams {
}
export interface IGetById15Params {
    id?: number
}
export interface ICreate15Params {
    body?: PrimaryCostAgreementСreateModel
}
export interface IUpdate16Params {
    body?: PrimaryCostAgreementUpdateModel
}
export interface IDelete15Params {
    id?: number
}
export interface IActiveParams {
    primaryCostAgreementId: number
}
export interface IClosedParams {
    primaryCostAgreementId: number
}
export interface IWithdrawnParams {
    primaryCostAgreementId: number
}
export interface IGetForGrid19Params {
    primaryCostAgreementId?: number
}
export interface IDelete16Params {
    id?: number
}
export interface IGetForGrid20Params {
    primaryCostAnnualPlanId?: number
}
export interface IGetModelsForApprovalGridParams {
    primaryCostAnnualPlanId?: number
}
export interface IGetAllModelsForApprovalParams {
}
export interface IGetAllModels2Params {
}
export interface IUpdate17Params {
    body?: { [key: string]: AnnualPlanItemStatus; }
}
export interface IUpdate18Params {
    body?: PrimaryCostAnnualPlanItemUpdateModel
}
export interface IUploadAPPsParams {
    file?: FileParameter
}
export interface IGetInvoiceDetailsParams {
    primaryCostAgreementId?: number
    reportingPeriodQuarterId?: number
}
export interface IGetInvoiceInflowModelsParams {
}
export interface IDelete17Params {
    id?: number
}
export interface IExportInvoicesParams {
    reportingPeriodQuarter?: string
}
export interface IUploadAccruals3Params {
    file?: FileParameter
}
export interface IReport2Params {
    primaryCostInvoiceId: number
}
export interface IDownloadInvoiceAttachmentsParams {
    primaryCostInvoiceId?: number
}
export interface IDownloadAttachmentsParams {
    reportingPeriodQuarterName?: string
}
export interface IGetForGrid21Params {
    primaryCostInvoiceId?: number
}
export interface IGetReportDetailsParams {
    primaryCostAgreementId?: number
    reportingPeriodQuarterId?: number
}
export interface IGetReportsInflowModelsParams {
}
export interface IGetYearWithQuartersParams {
    primaryCostAgreementId?: number
}
export interface IReadyForApproval22Params {
    primaryCostReportId: number
}
export interface IApprove32Params {
    primaryCostReportId: number
}
export interface IDeny32Params {
    primaryCostReportId: number
}
export interface IDelete18Params {
    id?: number
}
export interface IGetForGrid22Params {
    primaryCostReportId?: number
}
export interface IDelete19Params {
    id?: number
}
export interface IUpdate19Params {
    body?: PrimaryCostReportItemUpdateModel
}
export interface IImportTemplate2Params {
    primaryCostReportId: number
}
export interface IUploadReportItemsParams {
    primaryCostReportId: number
    file?: FileParameter
}
export interface IGetPrincipalPickerModelParams {
    page?: number
    size?: number
    term?: string
    useGraph?: boolean
    graphNextLink?: string
}
export interface ISearchPrincipalsParams {
    page?: number
    size?: number
    term?: string
}
export interface IGetById16Params {
    id?: number
}
export interface ICreatePrincipalParams {
    body?: PrincipalCreateModel
}
export interface IGetParams {
    keys?: string
}
export interface IPutParams {
    body?: PrincipalConfigurationModel
}
export interface IGetList2Params {
    periodFrom?: Date
    periodTo?: Date
}
export interface IGetConfigurationParams {
    reportingPeriodIds?: number[]
}
export interface IUpdateScheduleParams {
    body?: ReportingScheduleEventModel
}
export interface IDeleteScheduleParams {
    id?: number
}
export interface IGetLookupModels2Params {
}
export interface IGetReportingPeriodsForDashboardParams {
}
export interface IGetLookupModels3Params {
}
export interface IGetReportingPeriodQuartersForDashboardParams {
}
export interface IGetForGrid23Params {
}
export interface IUploadRevenuesParams {
    file?: FileParameter
}
export interface IGetAppSettingsParams {
}
export interface IGetPrincipalPermissionsParams {
}
export interface ICheckIfPrincipalHasPermissionOnObjectParams {
    objectUniqueId?: string
    permissionId?: number
}
export interface ISearchSecurableObjectParams {
    term?: string
}
export interface ISearchRolesParams {
    term?: string
}
export interface IGetGlobalRolesParams {
}
export interface IGetRolesOnObjectParams {
    objectUniqueId?: string
}
export interface IGetRoleMembersParams {
    objectUniqueId?: string
    roleId?: number
    inheritedFrom?: string
}
export interface IGetUserRolesOnObjectsParams {
    principalId?: number
    objectUniqueId?: string
}
export interface IGetRolesForInactiveUsersParams {
}
export interface IGetUsersInRolesOnObjectParams {
    roleId?: number
    objectUniqueId?: string
}
export interface ICreateRoleMemberParams {
    body?: RoleMemberModel
}
export interface IDeleteRoleMemberParams {
    objectUniqueId?: string
    roleId?: number
    principalId?: number
    principalEmail?: string
    principalDisplayName?: string
    isSystem?: boolean
}
export interface IGetForGrid24Params {
    serviceAgreementId?: number
    reportingPeriodId?: number
}
export interface IGetAccrualsInflowModels2Params {
}
export interface IExportAccrualsOutflowParams {
    reportingPeriodCodeName?: string
}
export interface IGetReportingPeriodWithAccruals2Params {
    serviceAgreementId?: number
}
export interface IDelete20Params {
    id?: number
}
export interface IApproveByReportingPeriodAndPoolingEntityParams {
    poolingEntityId: number
    reportingPeriodId: number
}
export interface IApprove4Params {
    serviceAccrualId: number
}
export interface IDeny4Params {
    serviceAccrualId: number
}
export interface IReport3Params {
    serviceAccrualId: number
}
export interface ICalculateAccrualsParams {
    reportingPeriodCodeName: string
}
export interface IGetServiceAccrualItemsParams {
    serviceAccrualId?: number
}
export interface IGetForGrid25Params {
}
export interface IGetServiceBeneficiaryUnitsGrouppedByPoolingEntityParams {
}
export interface IGetById17Params {
    id?: number
}
export interface ICreate16Params {
    body?: ServiceAgreementCreateModel
}
export interface IUpdate20Params {
    body?: ServiceAgreementUpdateModel
}
export interface IDelete21Params {
    id?: number
}
export interface IActive2Params {
    serviceAgreementId: number
}
export interface IClosed2Params {
    serviceAgreementId: number
}
export interface IWithdrawn2Params {
    serviceAgreementId: number
}
export interface IGetAgreementStatusesParams {
}
export interface IGetForGrid26Params {
    serviceAgreementId?: number
}
export interface IDelete22Params {
    id?: number
}
export interface IGetForGrid27Params {
    serviceAnnualPlanId?: number
}
export interface IGetModelsForApprovalGrid2Params {
    serviceAnnualPlanId?: number
}
export interface IGetAllModelsForApproval2Params {
}
export interface IGetAllModels3Params {
}
export interface IDelete23Params {
    id?: number
}
export interface IUploadAPPs2Params {
    file?: FileParameter
}
export interface IUpdate21Params {
    body?: { [key: string]: AnnualPlanItemStatus; }
}
export interface IUpdate22Params {
    body?: ServiceAnnualPlanItemUpdateModel
}
export interface IGetForGrid28Params {
}
export interface IGetLocalUnitLookupModels3Params {
}
export interface IGetById18Params {
    id?: number
}
export interface ICreate17Params {
    body?: ServiceBeneficiaryUnitCreateModel
}
export interface IUpdate23Params {
    body?: ServiceBeneficiaryUnitUpdateModel
}
export interface IDelete24Params {
    id?: number
}
export interface IGetForGridByServiceBeneficiaryUnitIdParams {
    serviceBeneficiaryUnitId?: number
}
export interface IGetById19Params {
    localUnitLocationId?: number
}
export interface ICreate18Params {
    body?: ServiceBeneficiaryUnitLocationCreateModel
}
export interface IUpdate24Params {
    body?: ServiceBeneficiaryUnitLocationUpdateModel
}
export interface IDelete25Params {
    id?: number
}
export interface IGetServiceBeneficiaryUnitLookupModelsParams {
}
export interface IGetForGrid29Params {
    serviceBeneficiaryUnitLocationId?: number
}
export interface ICreate19Params {
    body?: ServiceBeneficiaryUnitLocationPGCreateModel
}
export interface IUpdate25Params {
    body?: ServiceBeneficiaryUnitLocationPGUpdateModel
}
export interface IDelete26Params {
    id?: number
}
export interface IGetLocalUnitLocationPGs2Params {
    serviceBeneficiaryUnitLocationId?: number
}
export interface IGetForGrid30Params {
    serviceBeneficiaryUnitLocationPGId?: number
}
export interface ICreatePoNumberGAParams {
    body?: ServiceBeneficiaryUnitLocationPgPONumberCreateModel
}
export interface IUpdatePoGANumberParams {
    body?: ServiceBeneficiaryUnitLocationPgPONumberUpdateModel
}
export interface ICreatePoNumberSalesParams {
    body?: ServiceBeneficiaryUnitLocationPgPONumberCreateModel
}
export interface IUpdatePoSalesNumberParams {
    body?: ServiceBeneficiaryUnitLocationPgPONumberUpdateModel
}
export interface ICreatePoNumberCosParams {
    body?: ServiceBeneficiaryUnitLocationPgPONumberCreateModel
}
export interface IUpdatePoNumberCosParams {
    body?: ServiceBeneficiaryUnitLocationPgPONumberUpdateModel
}
export interface IGetForGrid31Params {
    serviceAgreementId?: number
    reportingPeriodQuarterId?: number
}
export interface IGetOutflowModelsParams {
}
export interface IDelete27Params {
    id?: number
}
export interface IGetYearWithQuarters2Params {
    serviceAgreementId?: number
}
export interface ICalculateInvoicesParams {
    reportingPeriodQuarterName: string
}
export interface IApproveByReportingPeriodQuarterAndPoolingEntityParams {
    poolingEntityId: number
    reportingPeriodQuarterId: number
}
export interface IReport4Params {
    serviceInvoiceId: number
}
export interface IExportInvoicesOutflowParams {
    reportingPeriodQuarterName?: string
}
export interface IGetForGrid32Params {
    serviceInvoiceId?: number
}
export class ApiClient {
    private baseUrl: string;
    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    agileUnitGridGet(params?:IGetForGridParams, requestOptions?: IAjaxOptions): AxiosPromise<AgileUnitModel[]> {
        let _url = this.baseUrl + "/api/AgileUnit/grid";

        return ApiService.sendRequest<AgileUnitModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    agileUnitByIdGet(params?:IGetByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<AgileUnitModel> {
        let _url = this.baseUrl + "/api/AgileUnit/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<AgileUnitModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    agileUnitByIdDelete(params?:IDeleteParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AgileUnit/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    agileUnitPost(body: AgileUnitCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgileUnit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    agileUnitPut(body: AgileUnitUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgileUnit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    agileUnitLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/AgileUnit/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    agreementChapterGridGet(params?:IGetAgreementChaptersByPrimaryCostAgreementIdParams, requestOptions?: IAjaxOptions): AxiosPromise<AgreementChapterModel[]> {
        let _url = this.baseUrl + "/api/AgreementChapter/grid";

        return ApiService.sendRequest<AgreementChapterModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    agreementChapterPost(body: AgreementChapterCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgreementChapter";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    agreementChapterItemGridGet(params?:IGetForGrid2Params, requestOptions?: IAjaxOptions): AxiosPromise<AgreementChapterItemModel[]> {
        let _url = this.baseUrl + "/api/AgreementChapterItem/grid";

        return ApiService.sendRequest<AgreementChapterItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    agreementChapterItemPost(body: AgreementChapterItemCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgreementChapterItem";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    agreementChapterItemPut(body: AgreementChapterItemUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgreementChapterItem";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    agreementChapterItemDelete(params?:IDelete2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AgreementChapterItem";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    agreementPGGridGet(params?:IGetAgreementPGsByServiceAgreementIdParams, requestOptions?: IAjaxOptions): AxiosPromise<AgreementPGModel[]> {
        let _url = this.baseUrl + "/api/AgreementPG/grid";

        return ApiService.sendRequest<AgreementPGModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    agreementPGPost(body: AgreementPGCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgreementPG";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    agreementPGItemGridGet(params?:IGetForGrid3Params, requestOptions?: IAjaxOptions): AxiosPromise<AgreementPGItemModel[]> {
        let _url = this.baseUrl + "/api/AgreementPGItem/grid";

        return ApiService.sendRequest<AgreementPGItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    agreementPGItemPost(body: AgreementPGItemCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgreementPGItem";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    agreementPGItemPut(body: AgreementPGItemUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AgreementPGItem";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    agreementPGItemDelete(params?:IDelete3Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AgreementPGItem";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    appCostUploadByFinancialYearIdByPoolingEntityIdPost(financialYearId: number, poolingEntityId: number, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AppCost/upload/{financialYearId}/{poolingEntityId}";
        _url = ApiService.getDynamicUrl(_url, { financialYearId, poolingEntityId, file });
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    appCostUploadInflationRatesByFinancialYearIdPost(financialYearId: number, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AppCost/upload-inflation-rates/{financialYearId}";
        _url = ApiService.getDynamicUrl(_url, { financialYearId, file });
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    appCostGridGet( requestOptions?: IAjaxOptions): AxiosPromise<AppCostModel[]> {
        let _url = this.baseUrl + "/api/AppCost/grid";

        return ApiService.sendRequest<AppCostModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    appInputSidebarGet( requestOptions?: IAjaxOptions): AxiosPromise<YearWithLocationsSidebarModel[]> {
        let _url = this.baseUrl + "/api/AppInput/sidebar";

        return ApiService.sendRequest<YearWithLocationsSidebarModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    appInputGridGet( requestOptions?: IAjaxOptions): AxiosPromise<AppInputModel[]> {
        let _url = this.baseUrl + "/api/AppInput/grid";

        return ApiService.sendRequest<AppInputModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    appInputGet(params?:IGetById2Params, requestOptions?: IAjaxOptions): AxiosPromise<AppInputDetailsModel> {
        let _url = this.baseUrl + "/api/AppInput";

        return ApiService.sendRequest<AppInputDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    appInputPut(body: AppInputUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    appInputSubmit1ByAppInputIdPut(params?:IReadyForApproval1Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/submit1/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputApprove1ByAppInputIdPut(params?:IApprove1Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/approve1/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputDeny1ByAppInputIdPut(params?:IDeny1Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/deny1/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputSubmit2ByAppInputIdPut(params?:IReadyForApproval2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/submit2/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputApprove2ByAppInputIdPut(params?:IApprove2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/approve2/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputDeny2ByAppInputIdPut(params?:IDeny2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/deny2/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputSubmit3ByAppInputIdPut(params?:IReadyForApproval3Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/submit3/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputApprove3ByAppInputIdPut(params?:IApprove3Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/approve3/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputDeny3ByAppInputIdPut(params?:IDeny3Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppInput/deny3/{appInputId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appInputAppInputCalculationDataByFinancialYearIdGet(params?:IAppInputCalculationParams, requestOptions?: IAjaxOptions): AxiosPromise<AppInflowCalculationResult> {
        let _url = this.baseUrl + "/api/AppInput/app-input-calculation-data/{financialYearId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<AppInflowCalculationResult>(AxiosMethod.GET, _url, params, requestOptions);
    }

    appOutflowGridGet( requestOptions?: IAjaxOptions): AxiosPromise<AppOutflowModel[]> {
        let _url = this.baseUrl + "/api/AppOutflow/grid";

        return ApiService.sendRequest<AppOutflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    appOutflowAllItemsGet( requestOptions?: IAjaxOptions): AxiosPromise<AppOutflowModel[]> {
        let _url = this.baseUrl + "/api/AppOutflow/all-items";

        return ApiService.sendRequest<AppOutflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    appOutflowUpdateStatusPut(body: { [key: string]: AppOutflowStatus; }, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppOutflow/update-status";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    appOutflowApproveByAppOutflowIdPut(params?:IApproveParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/AppOutflow/approve/{appOutflowId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    appOutflowCalculateAppsByFinancialYearIdPost(params?:ICalculateAppOutflowParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AppOutflow/calculate-apps/{financialYearId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }

    attachmentGridGet(params?:IGetForGrid7Params, requestOptions?: IAjaxOptions): AxiosPromise<AttachmentModel[]> {
        let _url = this.baseUrl + "/api/Attachment/grid";

        return ApiService.sendRequest<AttachmentModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    attachmentDownloadGet(params?:IDownloadParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Attachment/download";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    attachmentFilePost(uploadedFile: FileParameter, objectUniqueId: string, type: AttachmentType, category: AttachmentCategory, description: string, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Attachment/file";
        const content_ = new FormData();
        if (uploadedFile === null || uploadedFile === undefined)
            throw new Error("The parameter 'uploadedFile' cannot be null.");
        else
            content_.append("UploadedFile", uploadedFile.data, uploadedFile.fileName ? uploadedFile.fileName : "UploadedFile");
        if (objectUniqueId === null || objectUniqueId === undefined)
            throw new Error("The parameter 'objectUniqueId' cannot be null.");
        else
            content_.append("ObjectUniqueId", objectUniqueId.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());
        if (category === null || category === undefined)
            throw new Error("The parameter 'category' cannot be null.");
        else
            content_.append("Category", category.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    attachmentLinkPost(linkDisplayName: string, linkAddress: string, objectUniqueId: string, type: AttachmentType, category: AttachmentCategory, description: string, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Attachment/link";
        const content_ = new FormData();
        if (linkDisplayName === null || linkDisplayName === undefined)
            throw new Error("The parameter 'linkDisplayName' cannot be null.");
        else
            content_.append("LinkDisplayName", linkDisplayName.toString());
        if (linkAddress === null || linkAddress === undefined)
            throw new Error("The parameter 'linkAddress' cannot be null.");
        else
            content_.append("LinkAddress", linkAddress.toString());
        if (objectUniqueId === null || objectUniqueId === undefined)
            throw new Error("The parameter 'objectUniqueId' cannot be null.");
        else
            content_.append("ObjectUniqueId", objectUniqueId.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());
        if (category === null || category === undefined)
            throw new Error("The parameter 'category' cannot be null.");
        else
            content_.append("Category", category.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    attachmentDelete(params?:IDelete4Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Attachment";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    changeLogGet(params?:IGetLogParams, requestOptions?: IAjaxOptions): AxiosPromise<ChangeLogModel[]> {
        let _url = this.baseUrl + "/api/ChangeLog";

        return ApiService.sendRequest<ChangeLogModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    chapterGridGet(params?:IGetForGrid8Params, requestOptions?: IAjaxOptions): AxiosPromise<ChapterModel[]> {
        let _url = this.baseUrl + "/api/Chapter/grid";

        return ApiService.sendRequest<ChapterModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    chapterGet(params?:IGetById3Params, requestOptions?: IAjaxOptions): AxiosPromise<ChapterModel> {
        let _url = this.baseUrl + "/api/Chapter";

        return ApiService.sendRequest<ChapterModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    chapterPost(body: ChapterCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/Chapter";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    chapterPut(body: ChapterUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/Chapter";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    chapterDelete(params?:IDelete5Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Chapter";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    chapterLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/Chapter/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    chapterSplitGridGet(params?:IGetForGrid9Params, requestOptions?: IAjaxOptions): AxiosPromise<ChapterSplitModel[]> {
        let _url = this.baseUrl + "/api/ChapterSplit/grid";

        return ApiService.sendRequest<ChapterSplitModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    chapterSplitGet(params?:IGetById4Params, requestOptions?: IAjaxOptions): AxiosPromise<ChapterSplitModel> {
        let _url = this.baseUrl + "/api/ChapterSplit";

        return ApiService.sendRequest<ChapterSplitModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    chapterSplitPost(body: ChapterSplitCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ChapterSplit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    chapterSplitPut(body: ChapterSplitUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ChapterSplit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    chapterSplitDelete(params?:IDelete6Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ChapterSplit";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    configurationAppConfigurationsGet( requestOptions?: IAjaxOptions): AxiosPromise<DbConfigurationModel[]> {
        let _url = this.baseUrl + "/api/Configuration/app-configurations";

        return ApiService.sendRequest<DbConfigurationModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    configurationInformationWidgetGet( requestOptions?: IAjaxOptions): AxiosPromise<InformationWidgetModel> {
        let _url = this.baseUrl + "/api/Configuration/information-widget";

        return ApiService.sendRequest<InformationWidgetModel>(AxiosMethod.GET, _url, null, requestOptions);
    }

    configurationUpdateAppConfigurationPut(body: UpdateDbConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Configuration/update-app-configuration";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    currencyLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/Currency/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    dashboardTasksGet( requestOptions?: IAjaxOptions): AxiosPromise<TaskModel[]> {
        let _url = this.baseUrl + "/api/Dashboard/tasks";

        return ApiService.sendRequest<TaskModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    dashboardAccrualsGet(params?:IGetAccrualsForReportingPeriodParams, requestOptions?: IAjaxOptions): AxiosPromise<AgreementChapterDashboardModel[]> {
        let _url = this.baseUrl + "/api/Dashboard/accruals";

        return ApiService.sendRequest<AgreementChapterDashboardModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    dashboardReportsGet(params?:IGetPrimaryCostReportWidgetModelsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostReportWidgetModel[]> {
        let _url = this.baseUrl + "/api/Dashboard/reports";

        return ApiService.sendRequest<PrimaryCostReportWidgetModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    dashboardAnnualPlansGet(params?:IGetForWidgetParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAnnualPlanWidgetModel[]> {
        let _url = this.baseUrl + "/api/Dashboard/annual-plans";

        return ApiService.sendRequest<PrimaryCostAnnualPlanWidgetModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    devPingGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Dev/ping";

        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }

    devVersionGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Dev/version";

        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }

    employeeGapReportGridGet( requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportModel[]> {
        let _url = this.baseUrl + "/api/EmployeeGapReport/grid";

        return ApiService.sendRequest<EmployeeGapReportModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    employeeGapReportEmployeeReportByReportingPeriodIdByPoolingEntityIdGet(params?:IGenerateEmployeeGapReportParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/EmployeeGapReport/employee-report/{reportingPeriodId}/{poolingEntityId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    employeeGapReportGet(params?:IGetById5Params, requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportModel> {
        let _url = this.baseUrl + "/api/EmployeeGapReport";

        return ApiService.sendRequest<EmployeeGapReportModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    employeeGapReportReadyForConfirmationByEmployeeGapReportIdPut(params?:IReadyForConfirmationParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/EmployeeGapReport/ready-for-confirmation/{employeeGapReportId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    employeeGapReportItemGridGet( requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemModel[]> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem/grid";

        return ApiService.sendRequest<EmployeeGapReportItemModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    employeeGapReportItemAllItemsForApprovalGet( requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemModel[]> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem/all-items-for-approval";

        return ApiService.sendRequest<EmployeeGapReportItemModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    employeeGapReportItemByEmployeeGapReportIdGet(params?:IGetItemByEmployeeGapReportIdParams, requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemModel> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem/{employeeGapReportId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<EmployeeGapReportItemModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    employeeGapReportItemGet(params?:IGetById6Params, requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemModel> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem";

        return ApiService.sendRequest<EmployeeGapReportItemModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    employeeGapReportItemConfirmByEmployeeGapReportItemIdPut(employeeGapReportItemId: number, comment: string, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem/confirm/{employeeGapReportItemId}";
        _url = ApiService.getDynamicUrl(_url, { employeeGapReportItemId, comment });
        const content_ = new FormData();
        if (comment === null || comment === undefined)
            throw new Error("The parameter 'comment' cannot be null.");
        else
            content_.append("comment", comment.toString());
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    employeeGapReportItemDenyByEmployeeGapReportItemIdPut(employeeGapReportItemId: number, comment: string, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem/deny/{employeeGapReportItemId}";
        _url = ApiService.getDynamicUrl(_url, { employeeGapReportItemId, comment });
        const content_ = new FormData();
        if (comment === null || comment === undefined)
            throw new Error("The parameter 'comment' cannot be null.");
        else
            content_.append("comment", comment.toString());
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    employeeGapReportItemApproveAllPut(body: number[], requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItem/approve-all";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    employeeGapReportItemPersonAllPersonsGet( requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemPersonModel[]> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItemPerson/all-persons";

        return ApiService.sendRequest<EmployeeGapReportItemPersonModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    employeeGapReportItemPersonByEmployeeGapReportItemIdGet(params?:IGetPersonsByEmployeeGapReportItemIdParams, requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemPersonModel[]> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItemPerson/{employeeGapReportItemId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<EmployeeGapReportItemPersonModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    employeeGapReportItemPersonGet(params?:IGetById7Params, requestOptions?: IAjaxOptions): AxiosPromise<EmployeeGapReportItemPersonModel> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItemPerson";

        return ApiService.sendRequest<EmployeeGapReportItemPersonModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    employeeGapReportItemPersonExportEmployeeGapReportByReportingPeriodCodeNameGet(params?:IExportEmployeeGapReportParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/EmployeeGapReportItemPerson/export-employee-gap-report/{reportingPeriodCodeName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    enumAttachmentTypeGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupStringValueModel[]> {
        let _url = this.baseUrl + "/api/Enum/attachment-type";

        return ApiService.sendRequest<LookupStringValueModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    enumAttachmentCategoryGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupStringValueModel[]> {
        let _url = this.baseUrl + "/api/Enum/attachment-category";

        return ApiService.sendRequest<LookupStringValueModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    enumAgileUnitTypeGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupStringValueModel[]> {
        let _url = this.baseUrl + "/api/Enum/agile-unit-type";

        return ApiService.sendRequest<LookupStringValueModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    enumChapterTypeGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupStringValueModel[]> {
        let _url = this.baseUrl + "/api/Enum/chapter-type";

        return ApiService.sendRequest<LookupStringValueModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    errorUiPost(body: ClientErrorModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Error/ui";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    financialYearLookupYearsGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/FinancialYear/lookup-years";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    restInflowReportingPrimaryCostAgreementsGet(params?:IPrimaryCostAgreementsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAgreementRestApiModelPagedResponse> {
        let _url = this.baseUrl + "/rest/InflowReporting/PrimaryCostAgreements";

        return ApiService.sendRequest<PrimaryCostAgreementRestApiModelPagedResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    restInflowReportingAccrualsGet(params?:IPrimaryCostAccrualsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAccrualItemRestApiModel[]> {
        let _url = this.baseUrl + "/rest/InflowReporting/Accruals";

        return ApiService.sendRequest<PrimaryCostAccrualItemRestApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    restInflowReportingReportsGet(params?:IPrimaryCostReportsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostReportItemRestApiModel[]> {
        let _url = this.baseUrl + "/rest/InflowReporting/Reports";

        return ApiService.sendRequest<PrimaryCostReportItemRestApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    restInflowReportingYTDGet(params?:IPrimaryCostYTDsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostYTDRestApiModel[]> {
        let _url = this.baseUrl + "/rest/InflowReporting/YTD";

        return ApiService.sendRequest<PrimaryCostYTDRestApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    restInflowReportingAppInflowGet(params?:IAppInflowsParams, requestOptions?: IAjaxOptions): AxiosPromise<AppInflowRestApiModel[]> {
        let _url = this.baseUrl + "/rest/InflowReporting/AppInflow";

        return ApiService.sendRequest<AppInflowRestApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    jobListGet( requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobList> {
        let _url = this.baseUrl + "/api/Job/list";

        return ApiService.sendRequest<ApiV1JobList>(AxiosMethod.GET, _url, null, requestOptions);
    }

    jobByIdGet(params?:IGetById8Params, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/{id}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.GET, _url, params, requestOptions);
    }

    jobStartByJobNamePost(jobName: string, body: JobStartModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/Job/start/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        const content_ = body;
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobParametersByJobNameGet(params?:IParametersGETParams, requestOptions?: IAjaxOptions): AxiosPromise<JobDetailsModel> {
        let _url = this.baseUrl + "/api/Job/parameters/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<JobDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    jobCronValidationByCronExpressionPost(params?:IParametersPOSTParams, requestOptions?: IAjaxOptions): AxiosPromise<CronValidationResult> {
        let _url = this.baseUrl + "/api/Job/cron/validation/{cronExpression}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<CronValidationResult>(AxiosMethod.POST, _url, params, requestOptions);
    }

    jobParametersByTriggerNamePost(triggerName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/parameters/{triggerName}";
        _url = ApiService.getDynamicUrl(_url, { triggerName, body });
        const content_ = body;
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobSettingsByJobNamePost(jobName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/settings/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobCreatePost(body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/create";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    jobDeleteDelete(params?:IDelete7Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/delete";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    jobCheckTriggerNameGet(params?:IIsTriggerNameUniqueParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/check-trigger-name";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    jobStopByJobNameByJobExecutionIdPost(params?:IStopParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/stop/{jobName}/{jobExecutionId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }

    localUnitGridGet( requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitModel[]> {
        let _url = this.baseUrl + "/api/LocalUnit/grid";

        return ApiService.sendRequest<LocalUnitModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    localUnitLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/LocalUnit/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    localUnitPageTitleGet(params?:IGetPageTitleParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/LocalUnit/page-title";

        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitGet(params?:IGetById9Params, requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitModel> {
        let _url = this.baseUrl + "/api/LocalUnit";

        return ApiService.sendRequest<LocalUnitModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitPost(body: LocalUnitCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/LocalUnit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    localUnitPut(body: LocalUnitUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/LocalUnit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    localUnitDelete(params?:IDelete8Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LocalUnit";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    localUnitIsOverheadGridGet(params?:IGetForGrid13Params, requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitIsOverheadModel[]> {
        let _url = this.baseUrl + "/api/LocalUnitIsOverhead/grid";

        return ApiService.sendRequest<LocalUnitIsOverheadModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitIsOverheadGet(params?:IGetById10Params, requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitIsOverheadModel> {
        let _url = this.baseUrl + "/api/LocalUnitIsOverhead";

        return ApiService.sendRequest<LocalUnitIsOverheadModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitIsOverheadPost(body: LocalUnitIsOverheadCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/LocalUnitIsOverhead";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    localUnitIsOverheadPut(body: LocalUnitIsOverheadUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/LocalUnitIsOverhead";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    localUnitIsOverheadDelete(params?:IDelete9Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LocalUnitIsOverhead";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    localUnitLocationLocationsGet(params?:IGetForGridByLocalUnitIdParams, requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitLocationModel[]> {
        let _url = this.baseUrl + "/api/LocalUnitLocation/locations";

        return ApiService.sendRequest<LocalUnitLocationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitLocationGet(params?:IGetById11Params, requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitLocationModel> {
        let _url = this.baseUrl + "/api/LocalUnitLocation";

        return ApiService.sendRequest<LocalUnitLocationModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitLocationPost(body: LocalUnitLocationCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LocalUnitLocation";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    localUnitLocationPut(body: LocalUnitLocationUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LocalUnitLocation";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    localUnitLocationDelete(params?:IDelete10Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LocalUnitLocation";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    localUnitLocationLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/LocalUnitLocation/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    localUnitLocationPGGridGet(params?:IGetForGrid14Params, requestOptions?: IAjaxOptions): AxiosPromise<LocalUnitLocationPGModel[]> {
        let _url = this.baseUrl + "/api/LocalUnitLocationPG/grid";

        return ApiService.sendRequest<LocalUnitLocationPGModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitLocationPGPoolingGet(params?:IGetPoolingByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/LocalUnitLocationPG/pooling";

        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, params, requestOptions);
    }

    localUnitLocationPGPost(body: LocalUnitLocationPGCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/LocalUnitLocationPG";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    localUnitLocationPGPut(body: LocalUnitLocationPGUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/LocalUnitLocationPG";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    localUnitLocationPGDelete(params?:IDelete11Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LocalUnitLocationPG";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    localUnitLocationPGLookupGet(params?:IGetLocalUnitLocationPGsParams, requestOptions?: IAjaxOptions): AxiosPromise<EnumKeyValue[]> {
        let _url = this.baseUrl + "/api/LocalUnitLocationPG/lookup";

        return ApiService.sendRequest<EnumKeyValue[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    markupGridGet( requestOptions?: IAjaxOptions): AxiosPromise<MarkupModel[]> {
        let _url = this.baseUrl + "/api/Markup/grid";

        return ApiService.sendRequest<MarkupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    markupGet(params?:IGetById12Params, requestOptions?: IAjaxOptions): AxiosPromise<MarkupModel> {
        let _url = this.baseUrl + "/api/Markup";

        return ApiService.sendRequest<MarkupModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    markupPost(body: MarkupCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/Markup";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    markupPut(body: MarkupUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/Markup";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    markupDelete(params?:IDelete12Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Markup";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    messageTypeGet( requestOptions?: IAjaxOptions): AxiosPromise<MessageTypeInfo[]> {
        let _url = this.baseUrl + "/api/MessageType";

        return ApiService.sendRequest<MessageTypeInfo[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    messageTypeLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupStringValueModel[]> {
        let _url = this.baseUrl + "/api/MessageType/lookup";

        return ApiService.sendRequest<LookupStringValueModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    orgUnitGet(params?:IGetById13Params, requestOptions?: IAjaxOptions): AxiosPromise<OrgUnitModel> {
        let _url = this.baseUrl + "/api/OrgUnit";

        return ApiService.sendRequest<OrgUnitModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    orgUnitTreeGet(params?:IGetForTreeParams, requestOptions?: IAjaxOptions): AxiosPromise<OrgUnitModel[]> {
        let _url = this.baseUrl + "/api/OrgUnit/tree";

        return ApiService.sendRequest<OrgUnitModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    orgUnitForLicensorDivisionGet(params?:IGetForLicensorDivisionParams, requestOptions?: IAjaxOptions): AxiosPromise<OrgUnitModel[]> {
        let _url = this.baseUrl + "/api/OrgUnit/for-licensor-division";

        return ApiService.sendRequest<OrgUnitModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    orgUnitLookupGet(params?:IGetOrgUnitLookupModelsParams, requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/OrgUnit/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    orgUnitUpdatePut(body: OrgUnitUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/OrgUnit/update";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    orgUnitInflationRateGridGet(params?:IGetForGrid16Params, requestOptions?: IAjaxOptions): AxiosPromise<OrgUnitInflationRateModel[]> {
        let _url = this.baseUrl + "/api/OrgUnitInflationRate/grid";

        return ApiService.sendRequest<OrgUnitInflationRateModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    orgUnitInflationRateInflationratePost(body: OrgUnitInflationRateCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/OrgUnitInflationRate/inflationrate";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    orgUnitInflationRateInflationratePut(body: OrgUnitInflationRateUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/OrgUnitInflationRate/inflationrate";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    restOutflowReportingYTDGet(params?:IServiceBeneficiaryYTDsParams, requestOptions?: IAjaxOptions): AxiosPromise<ServiceYTDRestApiModel[]> {
        let _url = this.baseUrl + "/rest/OutflowReporting/YTD";

        return ApiService.sendRequest<ServiceYTDRestApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    restOutflowReportingAppOutflowGet(params?:IAppOutflowsParams, requestOptions?: IAjaxOptions): AxiosPromise<AppOutflowRestApiModel[]> {
        let _url = this.baseUrl + "/rest/OutflowReporting/AppOutflow";

        return ApiService.sendRequest<AppOutflowRestApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    peopleVerificationUploadByReportingPeriodCodeNameByPoolingEntityIdPost(reportingPeriodCodeName: string, poolingEntityId: number, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PeopleVerification/upload/{reportingPeriodCodeName}/{poolingEntityId}";
        _url = ApiService.getDynamicUrl(_url, { reportingPeriodCodeName, poolingEntityId, file });
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    poolingEntityGridGet( requestOptions?: IAjaxOptions): AxiosPromise<PoolingEntityModel[]> {
        let _url = this.baseUrl + "/api/PoolingEntity/grid";

        return ApiService.sendRequest<PoolingEntityModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    poolingEntityPaymentTermsGet(params?:IGetPaymentTermsByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PoolingEntity/payment-terms";

        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }

    poolingEntityGet(params?:IGetById14Params, requestOptions?: IAjaxOptions): AxiosPromise<PoolingEntityModel> {
        let _url = this.baseUrl + "/api/PoolingEntity";

        return ApiService.sendRequest<PoolingEntityModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    poolingEntityPost(body: PoolingEntityCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PoolingEntity";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    poolingEntityPut(body: PoolingEntityUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PoolingEntity";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    poolingEntityDelete(params?:IDelete13Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PoolingEntity";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    poolingEntityTargetsGet( requestOptions?: IAjaxOptions): AxiosPromise<EnumKeyValue[]> {
        let _url = this.baseUrl + "/api/PoolingEntity/targets";

        return ApiService.sendRequest<EnumKeyValue[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    poolingEntityLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<EnumKeyValue[]> {
        let _url = this.baseUrl + "/api/PoolingEntity/lookup";

        return ApiService.sendRequest<EnumKeyValue[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostAccrualGridGet(params?:IGetAgreementChaptersByPrimaryCostAgreementId2Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAccrualModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/grid";

        return ApiService.sendRequest<PrimaryCostAccrualModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualAccrualsInflowGet( requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAccrualInflowModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/accruals-inflow";

        return ApiService.sendRequest<PrimaryCostAccrualInflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostAccrualReportingPeriodAccrualsGet(params?:IGetReportingPeriodWithAccrualsParams, requestOptions?: IAjaxOptions): AxiosPromise<ReportingPeriodYearWithAccruals[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/reporting-period-accruals";

        return ApiService.sendRequest<ReportingPeriodYearWithAccruals[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualReadyForApprovalByPrimaryCostAccrualIdPut(params?:IReadyForApprovalParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/ready-for-approval/{primaryCostAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostAccrualApproveByPrimaryCostAccrualIdPut(params?:IApprove22Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/approve/{primaryCostAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostAccrualDenyByPrimaryCostAccrualIdPut(params?:IDeny22Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/deny/{primaryCostAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostAccrualDelete(params?:IDelete14Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    primaryCostAccrualDownloadAccrualsByIdGet(params?:IDownloadAccrualsByPrimaryCostAccrualIdParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/download-accruals-by-id";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualDownloadAccrualsByReportingPeriodGet(params?:IDownloadAccrualsByReportingPeriodIdParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/download-accruals-by-reporting-period";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualUploadAccrualsPost(file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/upload-accruals";
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    primaryCostAccrualReportByPrimaryCostAccrualIdGet(params?:IReportParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/report/{primaryCostAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualAccrualCalculationDataByReportingPeriodIdGet(params?:IAccrualCalculationParams, requestOptions?: IAjaxOptions): AxiosPromise<AccrualCalculationResult> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrual/accrual-calculation-data/{reportingPeriodId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<AccrualCalculationResult>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualItemGridGet(params?:IGetAgreementChaptersByPrimaryCostAgreementId3Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAccrualItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrualItem/grid";

        return ApiService.sendRequest<PrimaryCostAccrualItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualItemPut(body: PrimaryCostAccrualItemUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrualItem";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    primaryCostAccrualItemImportTemplateByPrimaryCostAccrualIdGet(params?:IImportTemplateParams, requestOptions?: IAjaxOptions): AxiosPromise<FileResponse> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrualItem/import-template/{primaryCostAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<FileResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAccrualItemImportAccrualItemsByPrimaryCostAccrualIdPost(primaryCostAccrualId: number, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAccrualItem/import-accrual-items/{primaryCostAccrualId}";
        _url = ApiService.getDynamicUrl(_url, { primaryCostAccrualId, file });
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    primaryCostAgreementGridGet( requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAgreementModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement/grid";

        return ApiService.sendRequest<PrimaryCostAgreementModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostAgreementPoolingentityLocalunitGet( requestOptions?: IAjaxOptions): AxiosPromise<PoolingEntityWithLocalUnitModels[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement/poolingentity-localunit";

        return ApiService.sendRequest<PoolingEntityWithLocalUnitModels[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostAgreementGet(params?:IGetById15Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAgreementModel> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement";

        return ApiService.sendRequest<PrimaryCostAgreementModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAgreementPost(body: PrimaryCostAgreementСreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    primaryCostAgreementPut(body: PrimaryCostAgreementUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    primaryCostAgreementDelete(params?:IDelete15Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    primaryCostAgreementActiveByPrimaryCostAgreementIdPut(params?:IActiveParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement/active/{primaryCostAgreementId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostAgreementClosedByPrimaryCostAgreementIdPut(params?:IClosedParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement/closed/{primaryCostAgreementId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostAgreementWithdrawnByPrimaryCostAgreementIdPut(params?:IWithdrawnParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAgreement/withdrawn/{primaryCostAgreementId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostAnnualPlanGridGet(params?:IGetForGrid19Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAnnualPlanModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlan/grid";

        return ApiService.sendRequest<PrimaryCostAnnualPlanModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAnnualPlanDelete(params?:IDelete16Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlan";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    primaryCostAnnualPlanItemGridGet(params?:IGetForGrid20Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem/grid";

        return ApiService.sendRequest<PrimaryCostAnnualPlanItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAnnualPlanItemItemsForApprovalGet(params?:IGetModelsForApprovalGridParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem/items-for-approval";

        return ApiService.sendRequest<PrimaryCostAnnualPlanItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostAnnualPlanItemAllItemsForApprovalGet( requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem/all-items-for-approval";

        return ApiService.sendRequest<PrimaryCostAnnualPlanItemModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostAnnualPlanItemAllItemsGet( requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem/all-items";

        return ApiService.sendRequest<PrimaryCostAnnualPlanItemModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostAnnualPlanItemUpdateStatusPut(body: { [key: string]: AnnualPlanItemStatus; }, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem/update-status";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    primaryCostAnnualPlanItemPut(body: PrimaryCostAnnualPlanItemUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    primaryCostAnnualPlanItemUploadAppsPost(file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostAnnualPlanItem/upload-apps";
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    primaryCostInvoiceGridGet(params?:IGetInvoiceDetailsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostInvoiceModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/grid";

        return ApiService.sendRequest<PrimaryCostInvoiceModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostInvoiceInvoiceInflowGet( requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostInvoiceInflowModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/invoice-inflow";

        return ApiService.sendRequest<PrimaryCostInvoiceInflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostInvoiceDeleteDelete(params?:IDelete17Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/delete";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    primaryCostInvoiceExportInvoicesGet(params?:IExportInvoicesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/export-invoices";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostInvoiceUploadInvoicesPost(file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/upload-invoices";
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    primaryCostInvoiceReportByPrimaryCostInvoiceIdGet(params?:IReport2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/report/{primaryCostInvoiceId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostInvoiceInvoiceAttachmentsGet(params?:IDownloadInvoiceAttachmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/invoice-attachments";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostInvoiceQuarterAttachmentsGet(params?:IDownloadAttachmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoice/quarter-attachments";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostInvoiceItemGridGet(params?:IGetForGrid21Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostInvoiceItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostInvoiceItem/grid";

        return ApiService.sendRequest<PrimaryCostInvoiceItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostReportGridGet(params?:IGetReportDetailsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostReportModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/grid";

        return ApiService.sendRequest<PrimaryCostReportModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostReportReportsInflowGet( requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostReportInflowModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/reports-inflow";

        return ApiService.sendRequest<PrimaryCostReportInflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    primaryCostReportYearQuartersGet(params?:IGetYearWithQuartersParams, requestOptions?: IAjaxOptions): AxiosPromise<YearWithQuartersModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/year-quarters";

        return ApiService.sendRequest<YearWithQuartersModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostReportReadyForApprovalByPrimaryCostReportIdPut(params?:IReadyForApproval22Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/ready-for-approval/{primaryCostReportId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostReportApproveByPrimaryCostReportIdPut(params?:IApprove32Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/approve/{primaryCostReportId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostReportDenyByPrimaryCostReportIdPut(params?:IDeny32Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/deny/{primaryCostReportId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    primaryCostReportDeleteDelete(params?:IDelete18Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostReport/delete";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    primaryCostReportItemGridGet(params?:IGetForGrid22Params, requestOptions?: IAjaxOptions): AxiosPromise<PrimaryCostReportItemModel[]> {
        let _url = this.baseUrl + "/api/PrimaryCostReportItem/grid";

        return ApiService.sendRequest<PrimaryCostReportItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostReportItemDeleteDelete(params?:IDelete19Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostReportItem/delete";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    primaryCostReportItemUpdatePut(body: PrimaryCostReportItemUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PrimaryCostReportItem/update";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    primaryCostReportItemImportTemplateByPrimaryCostReportIdGet(params?:IImportTemplate2Params, requestOptions?: IAjaxOptions): AxiosPromise<FileResponse> {
        let _url = this.baseUrl + "/api/PrimaryCostReportItem/import-template/{primaryCostReportId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<FileResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }

    primaryCostReportItemImportReportItemsByPrimaryCostReportIdPost(primaryCostReportId: number, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrimaryCostReportItem/import-report-items/{primaryCostReportId}";
        _url = ApiService.getDynamicUrl(_url, { primaryCostReportId, file });
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    principalPickerGet(params?:IGetPrincipalPickerModelParams, requestOptions?: IAjaxOptions): AxiosPromise<PrincipalPickerModel> {
        let _url = this.baseUrl + "/api/Principal/picker";

        return ApiService.sendRequest<PrincipalPickerModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    principalSearchGet(params?:ISearchPrincipalsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrincipalModel[]> {
        let _url = this.baseUrl + "/api/Principal/search";

        return ApiService.sendRequest<PrincipalModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    principalGet(params?:IGetById16Params, requestOptions?: IAjaxOptions): AxiosPromise<PrincipalModel> {
        let _url = this.baseUrl + "/api/Principal";

        return ApiService.sendRequest<PrincipalModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    principalPost(body: PrincipalCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<PrincipalModel> {
        let _url = this.baseUrl + "/api/Principal";
        const content_ = body;
        return ApiService.sendRequest<PrincipalModel>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    principalConfigurationGet(params?:IGetParams, requestOptions?: IAjaxOptions): AxiosPromise<PrincipalConfigurationModel[]> {
        let _url = this.baseUrl + "/api/PrincipalConfiguration";

        return ApiService.sendRequest<PrincipalConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    principalConfigurationPut(body: PrincipalConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PrincipalConfiguration";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    reportingPeriodGet(params?:IGetList2Params, requestOptions?: IAjaxOptions): AxiosPromise<ReportingPeriodModel[]> {
        let _url = this.baseUrl + "/api/ReportingPeriod";

        return ApiService.sendRequest<ReportingPeriodModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    reportingPeriodScheduleGet(params?:IGetConfigurationParams, requestOptions?: IAjaxOptions): AxiosPromise<ReportingScheduleModel[]> {
        let _url = this.baseUrl + "/api/ReportingPeriod/schedule";

        return ApiService.sendRequest<ReportingScheduleModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    reportingPeriodSchedulePut(body: ReportingScheduleEventModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReportingPeriod/schedule";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    reportingPeriodScheduleDelete(params?:IDeleteScheduleParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReportingPeriod/schedule";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    reportingPeriodLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/ReportingPeriod/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    reportingPeriodDashboardGet( requestOptions?: IAjaxOptions): AxiosPromise<ReportingPeriodDashboardModel[]> {
        let _url = this.baseUrl + "/api/ReportingPeriod/dashboard";

        return ApiService.sendRequest<ReportingPeriodDashboardModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    reportingPeriodQuarterLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/ReportingPeriodQuarter/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    reportingPeriodQuarterDashboardGet( requestOptions?: IAjaxOptions): AxiosPromise<ReportingPeriodQuarterDashboardModel[]> {
        let _url = this.baseUrl + "/api/ReportingPeriodQuarter/dashboard";

        return ApiService.sendRequest<ReportingPeriodQuarterDashboardModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    revenuesDataGridGet( requestOptions?: IAjaxOptions): AxiosPromise<RevenueDataModel[]> {
        let _url = this.baseUrl + "/api/RevenuesData/grid";

        return ApiService.sendRequest<RevenueDataModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    revenuesDataUploadRevenuesPost(file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/RevenuesData/upload-revenues";
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    securityAppSettingsGet( requestOptions?: IAjaxOptions): AxiosPromise<AppSecurityModel> {
        let _url = this.baseUrl + "/api/Security/app-settings";

        return ApiService.sendRequest<AppSecurityModel>(AxiosMethod.GET, _url, null, requestOptions);
    }

    securityPrincipalPermissionsGet( requestOptions?: IAjaxOptions): AxiosPromise<EnumKeyValue[]> {
        let _url = this.baseUrl + "/api/Security/principal-permissions";

        return ApiService.sendRequest<EnumKeyValue[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    securityPrincipalHasPermissionGet(params?:ICheckIfPrincipalHasPermissionOnObjectParams, requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Security/principal-has-permission";

        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsSearchSecurableObjectGet(params?:ISearchSecurableObjectParams, requestOptions?: IAjaxOptions): AxiosPromise<LookupStringValueModel[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/search-securable-object";

        return ApiService.sendRequest<LookupStringValueModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsSearchRolesGet(params?:ISearchRolesParams, requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/search-roles";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsGlobalRolesGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/global-roles";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    securityTabsRolesOnObjectGet(params?:IGetRolesOnObjectParams, requestOptions?: IAjaxOptions): AxiosPromise<ObjectRoleInfo[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/roles-on-object";

        return ApiService.sendRequest<ObjectRoleInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsRoleMembersGet(params?:IGetRoleMembersParams, requestOptions?: IAjaxOptions): AxiosPromise<RoleMemberModel[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/role-members";

        return ApiService.sendRequest<RoleMemberModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsUserRolesGet(params?:IGetUserRolesOnObjectsParams, requestOptions?: IAjaxOptions): AxiosPromise<PrincipalRoleItem[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/user-roles";

        return ApiService.sendRequest<PrincipalRoleItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsInactiveUserRolesGet( requestOptions?: IAjaxOptions): AxiosPromise<PrincipalRoleItemExtended[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/inactive-user-roles";

        return ApiService.sendRequest<PrincipalRoleItemExtended[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    securityTabsUsersInRoleGet(params?:IGetUsersInRolesOnObjectParams, requestOptions?: IAjaxOptions): AxiosPromise<ObjectRoleInfo[]> {
        let _url = this.baseUrl + "/api/SecurityTabs/users-in-role";

        return ApiService.sendRequest<ObjectRoleInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    securityTabsRoleMemberPost(body: RoleMemberModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/SecurityTabs/role-member";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    securityTabsRoleMemberDelete(params?:IDeleteRoleMemberParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/SecurityTabs/role-member";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceAccrualGridGet(params?:IGetForGrid24Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceAccrualModel[]> {
        let _url = this.baseUrl + "/api/ServiceAccrual/grid";

        return ApiService.sendRequest<ServiceAccrualModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAccrualAccrualsOutflowGet( requestOptions?: IAjaxOptions): AxiosPromise<ServiceAccrualOutflowModel[]> {
        let _url = this.baseUrl + "/api/ServiceAccrual/accruals-outflow";

        return ApiService.sendRequest<ServiceAccrualOutflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceAccrualExportAccrualsOutflowGet(params?:IExportAccrualsOutflowParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAccrual/export-accruals-outflow";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAccrualReportingPeriodAccrualsGet(params?:IGetReportingPeriodWithAccruals2Params, requestOptions?: IAjaxOptions): AxiosPromise<ReportingPeriodYearWithAccruals[]> {
        let _url = this.baseUrl + "/api/ServiceAccrual/reporting-period-accruals";

        return ApiService.sendRequest<ReportingPeriodYearWithAccruals[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAccrualDelete(params?:IDelete20Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAccrual";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceAccrualApproveByPoolingEntityIdByReportingPeriodIdPut(params?:IApproveByReportingPeriodAndPoolingEntityParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAccrual/approve/{poolingEntityId}/{reportingPeriodId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceAccrualApproveByServiceAccrualIdPut(params?:IApprove4Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAccrual/approve/{serviceAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceAccrualDenyByServiceAccrualIdPut(params?:IDeny4Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAccrual/deny/{serviceAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceAccrualReportByServiceAccrualIdGet(params?:IReport3Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAccrual/report/{serviceAccrualId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAccrualCalculateAccrualsByReportingPeriodCodeNamePost(params?:ICalculateAccrualsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAccrual/calculate-accruals/{reportingPeriodCodeName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }

    serviceAccrualItemGridGet(params?:IGetServiceAccrualItemsParams, requestOptions?: IAjaxOptions): AxiosPromise<ServiceAccrualItemModel[]> {
        let _url = this.baseUrl + "/api/ServiceAccrualItem/grid";

        return ApiService.sendRequest<ServiceAccrualItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAgreementGridGet( requestOptions?: IAjaxOptions): AxiosPromise<ServiceAgreementModel[]> {
        let _url = this.baseUrl + "/api/ServiceAgreement/grid";

        return ApiService.sendRequest<ServiceAgreementModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceAgreementPoolingentityServicebeneficiaryunitGet( requestOptions?: IAjaxOptions): AxiosPromise<PoolingEntityWithServiceBeneficiaryUnitModels[]> {
        let _url = this.baseUrl + "/api/ServiceAgreement/poolingentity-servicebeneficiaryunit";

        return ApiService.sendRequest<PoolingEntityWithServiceBeneficiaryUnitModels[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceAgreementGet(params?:IGetById17Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceAgreementModel> {
        let _url = this.baseUrl + "/api/ServiceAgreement";

        return ApiService.sendRequest<ServiceAgreementModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAgreementPost(body: ServiceAgreementCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAgreement";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceAgreementPut(body: ServiceAgreementUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAgreement";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceAgreementDelete(params?:IDelete21Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAgreement";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceAgreementActiveByServiceAgreementIdPut(params?:IActive2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAgreement/active/{serviceAgreementId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceAgreementClosedByServiceAgreementIdPut(params?:IClosed2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAgreement/closed/{serviceAgreementId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceAgreementWithdrawnByServiceAgreementIdPut(params?:IWithdrawn2Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAgreement/withdrawn/{serviceAgreementId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceAgreementLookupStatusesGet( requestOptions?: IAjaxOptions): AxiosPromise<EnumKeyValue[]> {
        let _url = this.baseUrl + "/api/ServiceAgreement/lookup-statuses";

        return ApiService.sendRequest<EnumKeyValue[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceAnnualPlanGridGet(params?:IGetForGrid26Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceAnnualPlanModel[]> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlan/grid";

        return ApiService.sendRequest<ServiceAnnualPlanModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAnnualPlanDelete(params?:IDelete22Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlan";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceAnnualPlanItemGridGet(params?:IGetForGrid27Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/grid";

        return ApiService.sendRequest<ServiceAnnualPlanItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAnnualPlanItemItemsForApprovalGet(params?:IGetModelsForApprovalGrid2Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/items-for-approval";

        return ApiService.sendRequest<ServiceAnnualPlanItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceAnnualPlanItemAllItemsForApprovalGet( requestOptions?: IAjaxOptions): AxiosPromise<ServiceAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/all-items-for-approval";

        return ApiService.sendRequest<ServiceAnnualPlanItemModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceAnnualPlanItemAllItemsGet( requestOptions?: IAjaxOptions): AxiosPromise<ServiceAnnualPlanItemModel[]> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/all-items";

        return ApiService.sendRequest<ServiceAnnualPlanItemModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceAnnualPlanItemDelete(params?:IDelete23Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceAnnualPlanItemUploadServiceAppsPost(file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/upload-service-apps";
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceAnnualPlanItemUpdateStatusPut(body: { [key: string]: AnnualPlanItemStatus; }, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/update-status";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceAnnualPlanItemUpdatePut(body: ServiceAnnualPlanItemUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceAnnualPlanItem/update";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitGridGet( requestOptions?: IAjaxOptions): AxiosPromise<ServiceBeneficiaryUnitModel[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnit/grid";

        return ApiService.sendRequest<ServiceBeneficiaryUnitModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceBeneficiaryUnitLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnit/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceBeneficiaryUnitGet(params?:IGetById18Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceBeneficiaryUnitModel> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnit";

        return ApiService.sendRequest<ServiceBeneficiaryUnitModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitPost(body: ServiceBeneficiaryUnitCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitPut(body: ServiceBeneficiaryUnitUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnit";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitDelete(params?:IDelete24Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnit";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationLocationsGet(params?:IGetForGridByServiceBeneficiaryUnitIdParams, requestOptions?: IAjaxOptions): AxiosPromise<ServiceBeneficiaryUnitLocationModel[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocation/locations";

        return ApiService.sendRequest<ServiceBeneficiaryUnitLocationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationGet(params?:IGetById19Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceBeneficiaryUnitLocationModel> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocation";

        return ApiService.sendRequest<ServiceBeneficiaryUnitLocationModel>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationPost(body: ServiceBeneficiaryUnitLocationCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocation";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPut(body: ServiceBeneficiaryUnitLocationUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocation";
        const content_ = body;
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationDelete(params?:IDelete25Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocation";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationLookupGet( requestOptions?: IAjaxOptions): AxiosPromise<LookupModel[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocation/lookup";

        return ApiService.sendRequest<LookupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceBeneficiaryUnitLocationPGGridGet(params?:IGetForGrid29Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceBeneficiaryUnitLocationPGModel[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPG/grid";

        return ApiService.sendRequest<ServiceBeneficiaryUnitLocationPGModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationPGPost(body: ServiceBeneficiaryUnitLocationPGCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPG";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPGPut(body: ServiceBeneficiaryUnitLocationPGUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPG";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPGDelete(params?:IDelete26Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPG";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationPGLookupGet(params?:IGetLocalUnitLocationPGs2Params, requestOptions?: IAjaxOptions): AxiosPromise<EnumKeyValue[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPG/lookup";

        return ApiService.sendRequest<EnumKeyValue[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberGridGet(params?:IGetForGrid30Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceBeneficiaryUnitLocationPgPONumberModel[]> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/grid";

        return ApiService.sendRequest<ServiceBeneficiaryUnitLocationPgPONumberModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberPonumbergaPost(body: ServiceBeneficiaryUnitLocationPgPONumberCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/ponumberga";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberPonumbergaPut(body: ServiceBeneficiaryUnitLocationPgPONumberUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/ponumberga";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberPonumbersalesPost(body: ServiceBeneficiaryUnitLocationPgPONumberCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/ponumbersales";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberPonumbersalesPut(body: ServiceBeneficiaryUnitLocationPgPONumberUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/ponumbersales";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberPonumbercosPost(body: ServiceBeneficiaryUnitLocationPgPONumberCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/ponumbercos";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.POST, _url, content_, requestOptions);
    }

    serviceBeneficiaryUnitLocationPgPONumberPonumbercosPut(body: ServiceBeneficiaryUnitLocationPgPONumberUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceBeneficiaryUnitLocationPgPONumber/ponumbercos";
        const content_ = body;
        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, content_, requestOptions);
    }

    serviceInvoiceGridGet(params?:IGetForGrid31Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceInvoiceModel[]> {
        let _url = this.baseUrl + "/api/ServiceInvoice/grid";

        return ApiService.sendRequest<ServiceInvoiceModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceInvoiceInvoicesOutflowGet( requestOptions?: IAjaxOptions): AxiosPromise<ServiceInvoiceOutflowModel[]> {
        let _url = this.baseUrl + "/api/ServiceInvoice/invoices-outflow";

        return ApiService.sendRequest<ServiceInvoiceOutflowModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }

    serviceInvoiceDelete(params?:IDelete27Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceInvoice";

        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }

    serviceInvoiceYearQuartersGet(params?:IGetYearWithQuarters2Params, requestOptions?: IAjaxOptions): AxiosPromise<YearWithQuartersModel[]> {
        let _url = this.baseUrl + "/api/ServiceInvoice/year-quarters";

        return ApiService.sendRequest<YearWithQuartersModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceInvoiceCalculateInvoicesByReportingPeriodQuarterNamePost(params?:ICalculateInvoicesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceInvoice/calculate-invoices/{reportingPeriodQuarterName}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }

    serviceInvoiceApproveByPoolingEntityIdByReportingPeriodQuarterIdPut(params?:IApproveByReportingPeriodQuarterAndPoolingEntityParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceInvoice/approve/{poolingEntityId}/{reportingPeriodQuarterId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.PUT, _url, params, requestOptions);
    }

    serviceInvoiceReportByServiceInvoiceIdGet(params?:IReport4Params, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/ServiceInvoice/report/{serviceInvoiceId}";
        _url = ApiService.getDynamicUrl(_url, params);

        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceInvoiceExportInvoicesOutflowGet(params?:IExportInvoicesOutflowParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ServiceInvoice/export-invoices-outflow";

        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }

    serviceInvoiceItemGridGet(params?:IGetForGrid32Params, requestOptions?: IAjaxOptions): AxiosPromise<ServiceInvoiceItemModel[]> {
        let _url = this.baseUrl + "/api/ServiceInvoiceItem/grid";

        return ApiService.sendRequest<ServiceInvoiceItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }

}
export const apiClient = new ApiClient();

export interface IAccrualCalculationResult {
    
    
    accrualsCalculationExportItems?: AccrualsCalculationExportItemRow[];
    
    
    
    serviceAccrualItems?: ServiceAccrualItemRow[];
    
    
    
    totalDifferencePoolingCurrency?: number;
    
}

export class AccrualCalculationResult extends BaseApiModelClass< IAccrualCalculationResult > implements IAccrualCalculationResult {
    
    
    accrualsCalculationExportItems?: AccrualsCalculationExportItemRow[];
    
    
    
    serviceAccrualItems?: ServiceAccrualItemRow[];
    
    
    
    totalDifferencePoolingCurrency?: number;
    
}

export enum AccrualStatus {
    Draft = "Draft",
    ReadyForApproval = "ReadyForApproval",
    Approved = "Approved",
}

export interface IAccrualsCalculationExportItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    location?: string;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCalcPoolingCurrency?: number;
    
}

export class AccrualsCalculationExportItemRow extends BaseApiModelClass< IAccrualsCalculationExportItemRow > implements IAccrualsCalculationExportItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    location?: string;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCalcPoolingCurrency?: number;
    
}

export interface IAgileUnitCreateModel {
    
    
    leaderPrincipalId?: number;
    
    
    
    controllerPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: AgileUnitType;
    
    
    
    agileUnitControllerDeputyPrincipalIds?: number[];
    
}

export class AgileUnitCreateModel extends BaseApiModelClass< IAgileUnitCreateModel > implements IAgileUnitCreateModel {
    
    
    leaderPrincipalId?: number;
    
    
    
    controllerPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: AgileUnitType;
    
    
    
    agileUnitControllerDeputyPrincipalIds?: number[];
    
}

export interface IAgileUnitModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    displayName?: string;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    leaderPrincipalDisplayName?: string;
    
    
    
    controllerPrincipalId?: number;
    
    
    
    controllerPrincipalDisplayName?: string;
    
    
    
    type?: AgileUnitType;
    
    
    
    agileUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    agileUnitControllerDeputyPrincipalDisplayNames?: string;
    
}

export class AgileUnitModel extends BaseApiModelClass< IAgileUnitModel > implements IAgileUnitModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    displayName?: string;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    leaderPrincipalDisplayName?: string;
    
    
    
    controllerPrincipalId?: number;
    
    
    
    controllerPrincipalDisplayName?: string;
    
    
    
    type?: AgileUnitType;
    
    
    
    agileUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    agileUnitControllerDeputyPrincipalDisplayNames?: string;
    
}

export enum AgileUnitType {
    Div = "Div",
    BL = "BL",
}

export interface IAgileUnitUpdateModel {
    
    
    id?: number;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    controllerPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: AgileUnitType;
    
    
    
    agileUnitControllerDeputyPrincipalIds?: number[];
    
}

export class AgileUnitUpdateModel extends BaseApiModelClass< IAgileUnitUpdateModel > implements IAgileUnitUpdateModel {
    
    
    id?: number;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    controllerPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: AgileUnitType;
    
    
    
    agileUnitControllerDeputyPrincipalIds?: number[];
    
}

export interface IAgileUnitWithChaptersSidebarModel {
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapters?: ChaptersSidebarModel[];
    
}

export class AgileUnitWithChaptersSidebarModel extends BaseApiModelClass< IAgileUnitWithChaptersSidebarModel > implements IAgileUnitWithChaptersSidebarModel {
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapters?: ChaptersSidebarModel[];
    
}

export interface IAgreementChapterCreateModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    currentAgreementChapterId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export class AgreementChapterCreateModel extends BaseApiModelClass< IAgreementChapterCreateModel > implements IAgreementChapterCreateModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    currentAgreementChapterId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export interface IAgreementChapterDashboardModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    numberOfChaptersPooled?: number;
    
    
    
    accrualStatus?: AccrualStatus;
    
    
    
    route?: string;
    
}

export class AgreementChapterDashboardModel extends BaseApiModelClass< IAgreementChapterDashboardModel > implements IAgreementChapterDashboardModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    numberOfChaptersPooled?: number;
    
    
    
    accrualStatus?: AccrualStatus;
    
    
    
    route?: string;
    
}

export interface IAgreementChapterItemCreateModel {
    
    
    localUnitLocationPGId?: number;
    
    
    
    chapterId?: number;
    
    
    
    costCenterOwnerId?: number;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    agreementChapterId?: number;
    
    
    
    pooling?: boolean;
    
}

export class AgreementChapterItemCreateModel extends BaseApiModelClass< IAgreementChapterItemCreateModel > implements IAgreementChapterItemCreateModel {
    
    
    localUnitLocationPGId?: number;
    
    
    
    chapterId?: number;
    
    
    
    costCenterOwnerId?: number;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    agreementChapterId?: number;
    
    
    
    pooling?: boolean;
    
}

export interface IAgreementChapterItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    agreementChapterId?: number;
    
    
    
    chapterId?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    chapterLeaderPrincipalId?: number;
    
    
    
    orgUnitLocalERPId?: number;
    
    
    
    orgUnitLocalERPCodeName?: string;
    
    
    
    orgUnitLocalERPDisplayName?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterLeaderPrincipalDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    costCenterOwnerId?: number;
    
    
    
    costCenterOwnerDisplayName?: string;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    pooling?: boolean;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    costType?: string;
    
    
    
    localGLAccount?: string;
    
    
    
    cfinglAccount?: string;
    
}

export class AgreementChapterItemModel extends BaseApiModelClass< IAgreementChapterItemModel > implements IAgreementChapterItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    agreementChapterId?: number;
    
    
    
    chapterId?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    chapterLeaderPrincipalId?: number;
    
    
    
    orgUnitLocalERPId?: number;
    
    
    
    orgUnitLocalERPCodeName?: string;
    
    
    
    orgUnitLocalERPDisplayName?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterLeaderPrincipalDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    costCenterOwnerId?: number;
    
    
    
    costCenterOwnerDisplayName?: string;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    pooling?: boolean;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    costType?: string;
    
    
    
    localGLAccount?: string;
    
    
    
    cfinglAccount?: string;
    
}

export interface IAgreementChapterItemUpdateModel {
    
    
    id?: number;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    chapterId?: number;
    
    
    
    costCenterOwnerId?: number;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    pooling?: boolean;
    
}

export class AgreementChapterItemUpdateModel extends BaseApiModelClass< IAgreementChapterItemUpdateModel > implements IAgreementChapterItemUpdateModel {
    
    
    id?: number;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    chapterId?: number;
    
    
    
    costCenterOwnerId?: number;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    pooling?: boolean;
    
}

export interface IAgreementChapterModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
}

export class AgreementChapterModel extends BaseApiModelClass< IAgreementChapterModel > implements IAgreementChapterModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
}

export interface IAgreementPGCreateModel {
    
    
    serviceAgreementId?: number;
    
    
    
    currentAgreementPGId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export class AgreementPGCreateModel extends BaseApiModelClass< IAgreementPGCreateModel > implements IAgreementPGCreateModel {
    
    
    serviceAgreementId?: number;
    
    
    
    currentAgreementPGId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export interface IAgreementPGItemCreateModel {
    
    
    agreementPGId?: number;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    costType?: ChapterType;
    
}

export class AgreementPGItemCreateModel extends BaseApiModelClass< IAgreementPGItemCreateModel > implements IAgreementPGItemCreateModel {
    
    
    agreementPGId?: number;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    costType?: ChapterType;
    
}

export interface IAgreementPGItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    agreementPGId?: number;
    
    
    
    serviceAgreementId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    orgUnitPGCodeName?: string;
    
    
    
    orgUnitPGDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
    
    
    localGLAccount?: string;
    
    
    
    cfinglAccount?: string;
    
}

export class AgreementPGItemModel extends BaseApiModelClass< IAgreementPGItemModel > implements IAgreementPGItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    agreementPGId?: number;
    
    
    
    serviceAgreementId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    orgUnitPGCodeName?: string;
    
    
    
    orgUnitPGDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
    
    
    localGLAccount?: string;
    
    
    
    cfinglAccount?: string;
    
}

export interface IAgreementPGItemUpdateModel {
    
    
    id?: number;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    costType?: ChapterType;
    
}

export class AgreementPGItemUpdateModel extends BaseApiModelClass< IAgreementPGItemUpdateModel > implements IAgreementPGItemUpdateModel {
    
    
    id?: number;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    costType?: ChapterType;
    
}

export interface IAgreementPGModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
}

export class AgreementPGModel extends BaseApiModelClass< IAgreementPGModel > implements IAgreementPGModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
}

export enum AnnualPlanItemStatus {
    Draft = "Draft",
    InApproval = "InApproval",
    Approved = "Approved",
}

export interface IApiV1Job {
    
    
    id?: string;
    
    
    
    name?: string;
    
    
    
    description?: string;
    
    
    
    jobType?: string;
    
    
    
    lastRunDateTimeUtc?: Date;
    
    
    
    nextRunDateTimeUtc?: Date;
    
    
    
    lastRunTriggerName?: string;
    
    
    
    nextRunTriggerName?: string;
    
    
    
    lastErrorMessage?: string;
    
    
    
    lastStatus?: JobStatus;
    
    
    
    timestampDateTimeUtc?: Date;
    
    
    
    triggers?: JobTriggerShortInfo[];
    
    
    
    permissionName?: string;
    
    
    
    lastExecutionInfoMessage?: string;
    
}

export class ApiV1Job extends BaseApiModelClass< IApiV1Job > implements IApiV1Job {
    
    
    id?: string;
    
    
    
    name?: string;
    
    
    
    description?: string;
    
    
    
    jobType?: string;
    
    
    
    lastRunDateTimeUtc?: Date;
    
    
    
    nextRunDateTimeUtc?: Date;
    
    
    
    lastRunTriggerName?: string;
    
    
    
    nextRunTriggerName?: string;
    
    
    
    lastErrorMessage?: string;
    
    
    
    lastStatus?: JobStatus;
    
    
    
    timestampDateTimeUtc?: Date;
    
    
    
    triggers?: JobTriggerShortInfo[];
    
    
    
    permissionName?: string;
    
    
    
    lastExecutionInfoMessage?: string;
    
}

export interface IApiV1JobList {
    
    
    jobs?: ApiV1Job[];
    
    
    
    status?: SchedulerStatus;
    
    
    
    startupException?: string;
    
}

export class ApiV1JobList extends BaseApiModelClass< IApiV1JobList > implements IApiV1JobList {
    
    
    jobs?: ApiV1Job[];
    
    
    
    status?: SchedulerStatus;
    
    
    
    startupException?: string;
    
}

export interface IApiV1JobTrigger {
    
    
    executionId?: string;
    
    
    
    id?: string;
    
    
    
    nextRunDateTime?: Date;
    
    
    
    lastRunDateTime?: Date;
    
    
    
    lastErrorMessage?: string;
    
    
    
    status?: JobStatus;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    progressMessage?: string;
    
}

export class ApiV1JobTrigger extends BaseApiModelClass< IApiV1JobTrigger > implements IApiV1JobTrigger {
    
    
    executionId?: string;
    
    
    
    id?: string;
    
    
    
    nextRunDateTime?: Date;
    
    
    
    lastRunDateTime?: Date;
    
    
    
    lastErrorMessage?: string;
    
    
    
    status?: JobStatus;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    progressMessage?: string;
    
}

export interface IAppCostModel {
    
    
    id?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    division?: string;
    
    
    
    company?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    agileUnit?: string;
    
    
    
    chapter?: string;
    
    
    
    location?: string;
    
    
    
    pooling?: boolean;
    
    
    
    ytdCostPexUsd?: number;
    
    
    
    ytdCostTravelUsd?: number;
    
    
    
    ytdCostOtherUsd?: number;
    
    
    
    mtdCostPexUsd?: number;
    
    
    
    mtdCostTravelUsd?: number;
    
    
    
    mtdCostOtherUsd?: number;
    
    
    
    financialYear?: string;
    
    
    
    warningMessage?: string;
    
}

export class AppCostModel extends BaseApiModelClass< IAppCostModel > implements IAppCostModel {
    
    
    id?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    division?: string;
    
    
    
    company?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    agileUnit?: string;
    
    
    
    chapter?: string;
    
    
    
    location?: string;
    
    
    
    pooling?: boolean;
    
    
    
    ytdCostPexUsd?: number;
    
    
    
    ytdCostTravelUsd?: number;
    
    
    
    ytdCostOtherUsd?: number;
    
    
    
    mtdCostPexUsd?: number;
    
    
    
    mtdCostTravelUsd?: number;
    
    
    
    mtdCostOtherUsd?: number;
    
    
    
    financialYear?: string;
    
    
    
    warningMessage?: string;
    
}

export interface IAppInflowCalculationExportItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    location?: string;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    cfinCostCenter?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCostCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
}

export class AppInflowCalculationExportItemRow extends BaseApiModelClass< IAppInflowCalculationExportItemRow > implements IAppInflowCalculationExportItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    location?: string;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    cfinCostCenter?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCostCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
}

export interface IAppInflowCalculationResult {
    
    
    appsCalculationExportItems?: AppInflowCalculationExportItemRow[];
    
    
    
    appOutflowItems?: AppOutflowItemRow[];
    
    
    
    totalCostCalcDifference?: number;
    
    
    
    totalPrimaryCostPrevFinalCalcDifference?: number;
    
}

export class AppInflowCalculationResult extends BaseApiModelClass< IAppInflowCalculationResult > implements IAppInflowCalculationResult {
    
    
    appsCalculationExportItems?: AppInflowCalculationExportItemRow[];
    
    
    
    appOutflowItems?: AppOutflowItemRow[];
    
    
    
    totalCostCalcDifference?: number;
    
    
    
    totalPrimaryCostPrevFinalCalcDifference?: number;
    
}

export interface IAppInflowRestApiModel {
    
    
    financial_Year: number;
    
    
    
    status: string;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    pooling: string;
    
    
    
    fTE_June_PY: number;
    
    
    
    fTE_Q3_PY: number;
    
    
    
    fTE_Q4_PY: number;
    
    
    
    pEX_PY_Precalculated: number;
    
    
    
    other_PY_Precalculated: number;
    
    
    
    travel_PY_Precalculated: number;
    
    
    
    total_Primary_Cost_PY_Precalculated: number;
    
    
    
    pEX_PY: number;
    
    
    
    other_PY: number;
    
    
    
    travel_PY: number;
    
    
    
    total_Primary_Cost_PY: number;
    
    
    
    iS_Overhead_PY: number;
    
    
    
    markup_PY: number;
    
    
    
    vAT_PY: number;
    
    
    
    total_Final_Cost_PY: number;
    
    
    
    fTE_Q1: number;
    
    
    
    fTE_Q2: number;
    
    
    
    fTE_Q3: number;
    
    
    
    fTE_Q4: number;
    
    
    
    pEX_Precalculated: number;
    
    
    
    other_Precalculated: number;
    
    
    
    travel_Precalculated: number;
    
    
    
    total_Primary_Cost_Precalculated: number;
    
    
    
    pEX: number;
    
    
    
    other: number;
    
    
    
    travel: number;
    
    
    
    total_Primary_Cost: number;
    
    
    
    iS_Overhead: number;
    
    
    
    markup: number;
    
    
    
    vAT: number;
    
    
    
    total_Final_Cost: number;
    
}

export class AppInflowRestApiModel extends BaseApiModelClass< IAppInflowRestApiModel > implements IAppInflowRestApiModel {
    
    
    financial_Year: number;
    
    
    
    status: string;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    pooling: string;
    
    
    
    fTE_June_PY: number;
    
    
    
    fTE_Q3_PY: number;
    
    
    
    fTE_Q4_PY: number;
    
    
    
    pEX_PY_Precalculated: number;
    
    
    
    other_PY_Precalculated: number;
    
    
    
    travel_PY_Precalculated: number;
    
    
    
    total_Primary_Cost_PY_Precalculated: number;
    
    
    
    pEX_PY: number;
    
    
    
    other_PY: number;
    
    
    
    travel_PY: number;
    
    
    
    total_Primary_Cost_PY: number;
    
    
    
    iS_Overhead_PY: number;
    
    
    
    markup_PY: number;
    
    
    
    vAT_PY: number;
    
    
    
    total_Final_Cost_PY: number;
    
    
    
    fTE_Q1: number;
    
    
    
    fTE_Q2: number;
    
    
    
    fTE_Q3: number;
    
    
    
    fTE_Q4: number;
    
    
    
    pEX_Precalculated: number;
    
    
    
    other_Precalculated: number;
    
    
    
    travel_Precalculated: number;
    
    
    
    total_Primary_Cost_Precalculated: number;
    
    
    
    pEX: number;
    
    
    
    other: number;
    
    
    
    travel: number;
    
    
    
    total_Primary_Cost: number;
    
    
    
    iS_Overhead: number;
    
    
    
    markup: number;
    
    
    
    vAT: number;
    
    
    
    total_Final_Cost: number;
    
}

export interface IAppInputDetailsModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    year?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    chapterId?: number;
    
    
    
    appCostImportId?: number;
    
    
    
    divisionCodeName?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    location?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
    
    
    currency?: string;
    
    
    
    chapterLeader?: string;
    
    
    
    ytdPex?: number;
    
    
    
    ytdTravel?: number;
    
    
    
    ytdOther?: number;
    
    
    
    mtdPex?: number;
    
    
    
    mtdTravel?: number;
    
    
    
    mtdOther?: number;
    
    
    
    fteJunePrev?: number;
    
    
    
    fteQ3PrevIn?: number;
    
    
    
    fteQ4PrevIn?: number;
    
    
    
    pexQ3PrevCalc?: number;
    
    
    
    otherQ3PrevCalc?: number;
    
    
    
    travelQ3PrevCalc?: number;
    
    
    
    pexQ4PrevCalc?: number;
    
    
    
    otherQ4PrevCalc?: number;
    
    
    
    travelQ4PrevCalc?: number;
    
    
    
    pexTotalPrevCalc?: number;
    
    
    
    otherTotalPrevCalc?: number;
    
    
    
    travelTotalPrevCalc?: number;
    
    
    
    primaryCostPrevCalc?: number;
    
    
    
    pexTotalPrevIn?: number;
    
    
    
    otherTotalPrevIn?: number;
    
    
    
    travelTotalPrevIn?: number;
    
    
    
    primaryCostPrevFinalCalc?: number;
    
    
    
    isOverheadPrevCalc?: number;
    
    
    
    markupPrevCalc?: number;
    
    
    
    vatPrevCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
    
    
    fteQ1In?: number;
    
    
    
    fteQ2In?: number;
    
    
    
    fteQ3In?: number;
    
    
    
    fteQ4In?: number;
    
    
    
    fteQ1Stage1In?: number;
    
    
    
    fteQ2Stage1In?: number;
    
    
    
    fteQ3Stage1In?: number;
    
    
    
    fteQ4Stage1In?: number;
    
    
    
    fteQ1Stage2In?: number;
    
    
    
    fteQ2Stage2In?: number;
    
    
    
    fteQ3Stage2In?: number;
    
    
    
    fteQ4Stage2In?: number;
    
    
    
    pexQ1Calc?: number;
    
    
    
    otherQ1Calc?: number;
    
    
    
    travelQ1Calc?: number;
    
    
    
    pexQ2Calc?: number;
    
    
    
    otherQ2Calc?: number;
    
    
    
    travelQ2Calc?: number;
    
    
    
    pexQ3Calc?: number;
    
    
    
    otherQ3Calc?: number;
    
    
    
    travelQ3Calc?: number;
    
    
    
    pexQ4Calc?: number;
    
    
    
    otherQ4Calc?: number;
    
    
    
    travelQ4Calc?: number;
    
    
    
    pexTotalPreCalc?: number;
    
    
    
    otherTotalPreCalc?: number;
    
    
    
    travelTotalPreCalc?: number;
    
    
    
    primaryCostPreCalc?: number;
    
    
    
    pexTotalIn?: number;
    
    
    
    otherTotalIn?: number;
    
    
    
    travelTotalIn?: number;
    
    
    
    pexTotalStage1In?: number;
    
    
    
    otherTotalStage1In?: number;
    
    
    
    travelTotalStage1In?: number;
    
    
    
    pexTotalStage2In?: number;
    
    
    
    otherTotalStage2In?: number;
    
    
    
    travelTotalStage2In?: number;
    
    
    
    primaryCostCalc?: number;
    
    
    
    primaryCostStage1Calc?: number;
    
    
    
    primaryCostStage2Calc?: number;
    
    
    
    isOverheadCalc?: number;
    
    
    
    markupCalc?: number;
    
    
    
    vatCalc?: number;
    
    
    
    totalCostCalc?: number;
    
    
    
    inflationRate?: number;
    
    
    
    inflationRateStage1?: number;
    
    
    
    inflationRateStage2?: number;
    
    
    
    appValidationThreshold?: number;
    
    
    
    chapterLeaderPrincipalId?: number;
    
    
    
    agileUnitLeaderPrincipalId?: number;
    
    
    
    agileUnitControllerPrincipalId?: number;
    
    
    
    isEditableByCurrentUser?: boolean;
    
    
    
    comment?: string;
    
    
    
    commentStage1?: string;
    
    
    
    commentStage2?: string;
    
}

export class AppInputDetailsModel extends BaseApiModelClass< IAppInputDetailsModel > implements IAppInputDetailsModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    year?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    chapterId?: number;
    
    
    
    appCostImportId?: number;
    
    
    
    divisionCodeName?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    location?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
    
    
    currency?: string;
    
    
    
    chapterLeader?: string;
    
    
    
    ytdPex?: number;
    
    
    
    ytdTravel?: number;
    
    
    
    ytdOther?: number;
    
    
    
    mtdPex?: number;
    
    
    
    mtdTravel?: number;
    
    
    
    mtdOther?: number;
    
    
    
    fteJunePrev?: number;
    
    
    
    fteQ3PrevIn?: number;
    
    
    
    fteQ4PrevIn?: number;
    
    
    
    pexQ3PrevCalc?: number;
    
    
    
    otherQ3PrevCalc?: number;
    
    
    
    travelQ3PrevCalc?: number;
    
    
    
    pexQ4PrevCalc?: number;
    
    
    
    otherQ4PrevCalc?: number;
    
    
    
    travelQ4PrevCalc?: number;
    
    
    
    pexTotalPrevCalc?: number;
    
    
    
    otherTotalPrevCalc?: number;
    
    
    
    travelTotalPrevCalc?: number;
    
    
    
    primaryCostPrevCalc?: number;
    
    
    
    pexTotalPrevIn?: number;
    
    
    
    otherTotalPrevIn?: number;
    
    
    
    travelTotalPrevIn?: number;
    
    
    
    primaryCostPrevFinalCalc?: number;
    
    
    
    isOverheadPrevCalc?: number;
    
    
    
    markupPrevCalc?: number;
    
    
    
    vatPrevCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
    
    
    fteQ1In?: number;
    
    
    
    fteQ2In?: number;
    
    
    
    fteQ3In?: number;
    
    
    
    fteQ4In?: number;
    
    
    
    fteQ1Stage1In?: number;
    
    
    
    fteQ2Stage1In?: number;
    
    
    
    fteQ3Stage1In?: number;
    
    
    
    fteQ4Stage1In?: number;
    
    
    
    fteQ1Stage2In?: number;
    
    
    
    fteQ2Stage2In?: number;
    
    
    
    fteQ3Stage2In?: number;
    
    
    
    fteQ4Stage2In?: number;
    
    
    
    pexQ1Calc?: number;
    
    
    
    otherQ1Calc?: number;
    
    
    
    travelQ1Calc?: number;
    
    
    
    pexQ2Calc?: number;
    
    
    
    otherQ2Calc?: number;
    
    
    
    travelQ2Calc?: number;
    
    
    
    pexQ3Calc?: number;
    
    
    
    otherQ3Calc?: number;
    
    
    
    travelQ3Calc?: number;
    
    
    
    pexQ4Calc?: number;
    
    
    
    otherQ4Calc?: number;
    
    
    
    travelQ4Calc?: number;
    
    
    
    pexTotalPreCalc?: number;
    
    
    
    otherTotalPreCalc?: number;
    
    
    
    travelTotalPreCalc?: number;
    
    
    
    primaryCostPreCalc?: number;
    
    
    
    pexTotalIn?: number;
    
    
    
    otherTotalIn?: number;
    
    
    
    travelTotalIn?: number;
    
    
    
    pexTotalStage1In?: number;
    
    
    
    otherTotalStage1In?: number;
    
    
    
    travelTotalStage1In?: number;
    
    
    
    pexTotalStage2In?: number;
    
    
    
    otherTotalStage2In?: number;
    
    
    
    travelTotalStage2In?: number;
    
    
    
    primaryCostCalc?: number;
    
    
    
    primaryCostStage1Calc?: number;
    
    
    
    primaryCostStage2Calc?: number;
    
    
    
    isOverheadCalc?: number;
    
    
    
    markupCalc?: number;
    
    
    
    vatCalc?: number;
    
    
    
    totalCostCalc?: number;
    
    
    
    inflationRate?: number;
    
    
    
    inflationRateStage1?: number;
    
    
    
    inflationRateStage2?: number;
    
    
    
    appValidationThreshold?: number;
    
    
    
    chapterLeaderPrincipalId?: number;
    
    
    
    agileUnitLeaderPrincipalId?: number;
    
    
    
    agileUnitControllerPrincipalId?: number;
    
    
    
    isEditableByCurrentUser?: boolean;
    
    
    
    comment?: string;
    
    
    
    commentStage1?: string;
    
    
    
    commentStage2?: string;
    
}

export interface IAppInputModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    year?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    chapterId?: number;
    
    
    
    costType?: ChapterType;
    
    
    
    appCostImportId?: number;
    
    
    
    divisionCodeName?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    location?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
    
    
    primaryCostPrevCalc?: number;
    
    
    
    primaryCostPrevFinalCalc?: number;
    
    
    
    inflationRate?: number;
    
    
    
    primaryCostPreCalc?: number;
    
    
    
    primaryCostCalc?: number;
    
    
    
    primaryCostStage1Calc?: number;
    
    
    
    primaryCostStage2Calc?: number;
    
    
    
    totalCostCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
}

export class AppInputModel extends BaseApiModelClass< IAppInputModel > implements IAppInputModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    year?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    chapterId?: number;
    
    
    
    costType?: ChapterType;
    
    
    
    appCostImportId?: number;
    
    
    
    divisionCodeName?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    location?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
    
    
    primaryCostPrevCalc?: number;
    
    
    
    primaryCostPrevFinalCalc?: number;
    
    
    
    inflationRate?: number;
    
    
    
    primaryCostPreCalc?: number;
    
    
    
    primaryCostCalc?: number;
    
    
    
    primaryCostStage1Calc?: number;
    
    
    
    primaryCostStage2Calc?: number;
    
    
    
    totalCostCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
}

export interface IAppInputUpdateModel {
    
    
    id?: number;
    
    
    
    fteQ3PrevIn?: number;
    
    
    
    fteQ4PrevIn?: number;
    
    
    
    pexTotalPrevIn?: number;
    
    
    
    otherTotalPrevIn?: number;
    
    
    
    travelTotalPrevIn?: number;
    
    
    
    fteQ1In?: number;
    
    
    
    fteQ2In?: number;
    
    
    
    fteQ3In?: number;
    
    
    
    fteQ4In?: number;
    
    
    
    pexTotalIn?: number;
    
    
    
    otherTotalIn?: number;
    
    
    
    travelTotalIn?: number;
    
    
    
    comment?: string;
    
}

export class AppInputUpdateModel extends BaseApiModelClass< IAppInputUpdateModel > implements IAppInputUpdateModel {
    
    
    id?: number;
    
    
    
    fteQ3PrevIn?: number;
    
    
    
    fteQ4PrevIn?: number;
    
    
    
    pexTotalPrevIn?: number;
    
    
    
    otherTotalPrevIn?: number;
    
    
    
    travelTotalPrevIn?: number;
    
    
    
    fteQ1In?: number;
    
    
    
    fteQ2In?: number;
    
    
    
    fteQ3In?: number;
    
    
    
    fteQ4In?: number;
    
    
    
    pexTotalIn?: number;
    
    
    
    otherTotalIn?: number;
    
    
    
    travelTotalIn?: number;
    
    
    
    comment?: string;
    
}

export interface IAppOutflowItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    pgId?: number;
    
    
    
    serviceAgreementId?: number;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    agreementPGItemId?: number;
    
    
    
    pgDisplayName?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    location?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCostCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
}

export class AppOutflowItemRow extends BaseApiModelClass< IAppOutflowItemRow > implements IAppOutflowItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    pgId?: number;
    
    
    
    serviceAgreementId?: number;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    agreementPGItemId?: number;
    
    
    
    pgDisplayName?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    location?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCostCalc?: number;
    
    
    
    totalCostPrevCalc?: number;
    
}

export interface IAppOutflowModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    year?: string;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    divisionCodeName?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    costTypeDisplayName?: string;
    
    
    
    valueUsd?: number;
    
    
    
    valueLoc?: number;
    
    
    
    valuePrevUsd?: number;
    
    
    
    valuePrevLoc?: number;
    
    
    
    value5QRFUsd?: number;
    
    
    
    value5QRFLoc?: number;
    
    
    
    value5QRFPrevUsd?: number;
    
    
    
    value5QRFPrevLoc?: number;
    
    
    
    valueApp1Usd?: number;
    
    
    
    valueApp1Loc?: number;
    
    
    
    valueApp1PrevUsd?: number;
    
    
    
    valueApp1PrevLoc?: number;
    
    
    
    valueAppFinalUsd?: number;
    
    
    
    valueAppFinalLoc?: number;
    
    
    
    valueAppFinalPrevUsd?: number;
    
    
    
    valueAppFinalPrevLoc?: number;
    
    
    
    approvedByControllerPrincipalDisplayName?: string;
    
    
    
    approvedByManagerPrincipalDisplayName?: string;
    
}

export class AppOutflowModel extends BaseApiModelClass< IAppOutflowModel > implements IAppOutflowModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    year?: string;
    
    
    
    serviceBeneficiaryUnitLocationPGId?: number;
    
    
    
    divisionCodeName?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    costTypeDisplayName?: string;
    
    
    
    valueUsd?: number;
    
    
    
    valueLoc?: number;
    
    
    
    valuePrevUsd?: number;
    
    
    
    valuePrevLoc?: number;
    
    
    
    value5QRFUsd?: number;
    
    
    
    value5QRFLoc?: number;
    
    
    
    value5QRFPrevUsd?: number;
    
    
    
    value5QRFPrevLoc?: number;
    
    
    
    valueApp1Usd?: number;
    
    
    
    valueApp1Loc?: number;
    
    
    
    valueApp1PrevUsd?: number;
    
    
    
    valueApp1PrevLoc?: number;
    
    
    
    valueAppFinalUsd?: number;
    
    
    
    valueAppFinalLoc?: number;
    
    
    
    valueAppFinalPrevUsd?: number;
    
    
    
    valueAppFinalPrevLoc?: number;
    
    
    
    approvedByControllerPrincipalDisplayName?: string;
    
    
    
    approvedByManagerPrincipalDisplayName?: string;
    
}

export interface IAppOutflowRestApiModel {
    
    
    financial_Year: number;
    
    
    
    status: string;
    
    
    
    pooling_Entity: string;
    
    
    
    service_Beneficiary_Unit_Division: string;
    
    
    
    service_Beneficiary_Unit_Company: string;
    
    
    
    service_Beneficiary_Unit_Location: string;
    
    
    
    cost_Type: string;
    
    
    
    pG: string;
    
    
    
    aPP: number;
    
    
    
    aPP_PY: number;
    
}

export class AppOutflowRestApiModel extends BaseApiModelClass< IAppOutflowRestApiModel > implements IAppOutflowRestApiModel {
    
    
    financial_Year: number;
    
    
    
    status: string;
    
    
    
    pooling_Entity: string;
    
    
    
    service_Beneficiary_Unit_Division: string;
    
    
    
    service_Beneficiary_Unit_Company: string;
    
    
    
    service_Beneficiary_Unit_Location: string;
    
    
    
    cost_Type: string;
    
    
    
    pG: string;
    
    
    
    aPP: number;
    
    
    
    aPP_PY: number;
    
}

export enum AppOutflowStatus {
    Draft = "Draft",
    InApproval = "InApproval",
    Approved = "Approved",
}

export interface IAppSecurityModel {
    
    
    hasPrincipalAnyPermission?: boolean;
    
    
    
    hasPrincipalApplicationAdministration?: boolean;
    
    
    
    hasPrincipalApplicationAdministrationRead?: boolean;
    
    
    
    hasPrincipalAnyMetadataRead?: boolean;
    
}

export class AppSecurityModel extends BaseApiModelClass< IAppSecurityModel > implements IAppSecurityModel {
    
    
    hasPrincipalAnyPermission?: boolean;
    
    
    
    hasPrincipalApplicationAdministration?: boolean;
    
    
    
    hasPrincipalApplicationAdministrationRead?: boolean;
    
    
    
    hasPrincipalAnyMetadataRead?: boolean;
    
}

export enum AttachmentCategory {
    Others = "Others",
    InvoicePrimaryCost = "InvoicePrimaryCost",
}

export interface IAttachmentModel {
    
    
    id?: number;
    
    
    
    objectUniqueId?: string;
    
    
    
    name?: string;
    
    
    
    linkAddress?: string;
    
    
    
    createdAt?: Date;
    
    
    
    createdByPrincipalId?: number;
    
    
    
    createdByPrincipalDisplayName?: string;
    
    
    
    type?: AttachmentType;
    
    
    
    category?: AttachmentCategory;
    
    
    
    description?: string;
    
}

export class AttachmentModel extends BaseApiModelClass< IAttachmentModel > implements IAttachmentModel {
    
    
    id?: number;
    
    
    
    objectUniqueId?: string;
    
    
    
    name?: string;
    
    
    
    linkAddress?: string;
    
    
    
    createdAt?: Date;
    
    
    
    createdByPrincipalId?: number;
    
    
    
    createdByPrincipalDisplayName?: string;
    
    
    
    type?: AttachmentType;
    
    
    
    category?: AttachmentCategory;
    
    
    
    description?: string;
    
}

export enum AttachmentType {
    File = "File",
    Link = "Link",
}

export enum ChangeAction {
    Added = "Added",
    Modified = "Modified",
    Deleted = "Deleted",
}

export interface IChangeLogModel {
    
    
    fieldDisplayName?: string;
    
    
    
    changeAction?: ChangeAction;
    
    
    
    dateTime?: Date;
    
    
    
    modifiedByPrincipalId?: number;
    
    
    
    modifiedByPrincipalDisplayName?: string;
    
    
    
    oldValue?: string;
    
    
    
    newValue?: string;
    
    
    
    changeDetails?: string;
    
    
    
    groupTitle?: string;
    
}

export class ChangeLogModel extends BaseApiModelClass< IChangeLogModel > implements IChangeLogModel {
    
    
    fieldDisplayName?: string;
    
    
    
    changeAction?: ChangeAction;
    
    
    
    dateTime?: Date;
    
    
    
    modifiedByPrincipalId?: number;
    
    
    
    modifiedByPrincipalDisplayName?: string;
    
    
    
    oldValue?: string;
    
    
    
    newValue?: string;
    
    
    
    changeDetails?: string;
    
    
    
    readonly groupTitle?: string;
    
}

export interface IChapterCreateModel {
    
    
    agileUnitId?: number;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: ChapterType;
    
}

export class ChapterCreateModel extends BaseApiModelClass< IChapterCreateModel > implements IChapterCreateModel {
    
    
    agileUnitId?: number;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: ChapterType;
    
}

export interface IChapterModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    leaderPrincipalDisplayName?: string;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitIdDisplayName?: string;
    
    
    
    type?: ChapterType;
    
}

export class ChapterModel extends BaseApiModelClass< IChapterModel > implements IChapterModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    leaderPrincipalDisplayName?: string;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitIdDisplayName?: string;
    
    
    
    type?: ChapterType;
    
}

export interface IChapterSplitCreateModel {
    
    
    chapterId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    split?: number;
    
}

export class ChapterSplitCreateModel extends BaseApiModelClass< IChapterSplitCreateModel > implements IChapterSplitCreateModel {
    
    
    chapterId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    split?: number;
    
}

export interface IChapterSplitModel {
    
    
    id?: number;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    orgUnitId?: number;
    
    
    
    orgUnitDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    financialYearDisplayName?: string;
    
    
    
    split?: number;
    
}

export class ChapterSplitModel extends BaseApiModelClass< IChapterSplitModel > implements IChapterSplitModel {
    
    
    id?: number;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    orgUnitId?: number;
    
    
    
    orgUnitDisplayName?: string;
    
    
    
    financialYearId?: number;
    
    
    
    financialYearDisplayName?: string;
    
    
    
    split?: number;
    
}

export interface IChapterSplitUpdateModel {
    
    
    id?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    split?: number;
    
}

export class ChapterSplitUpdateModel extends BaseApiModelClass< IChapterSplitUpdateModel > implements IChapterSplitUpdateModel {
    
    
    id?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    split?: number;
    
}

export enum ChapterType {
    GA = "GA",
    Sales = "Sales",
    COS = "COS",
}

export interface IChapterUpdateModel {
    
    
    id?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: ChapterType;
    
}

export class ChapterUpdateModel extends BaseApiModelClass< IChapterUpdateModel > implements IChapterUpdateModel {
    
    
    id?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    leaderPrincipalId?: number;
    
    
    
    displayName?: string;
    
    
    
    type?: ChapterType;
    
}

export interface IChaptersSidebarModel {
    
    
    appInputId?: number;
    
    
    
    chapterDisplayName?: string;
    
}

export class ChaptersSidebarModel extends BaseApiModelClass< IChaptersSidebarModel > implements IChaptersSidebarModel {
    
    
    appInputId?: number;
    
    
    
    chapterDisplayName?: string;
    
}

export interface IClientErrorModel {
    
    
    message?: string;
    
    
    
    source?: string;
    
    
    
    url?: string;
    
    
    
    navigatorUserAgent?: string;
    
    
    
    navigatorVendor?: string;
    
    
    
    screenSize?: string;
    
}

export class ClientErrorModel extends BaseApiModelClass< IClientErrorModel > implements IClientErrorModel {
    
    
    message?: string;
    
    
    
    source?: string;
    
    
    
    url?: string;
    
    
    
    navigatorUserAgent?: string;
    
    
    
    navigatorVendor?: string;
    
    
    
    screenSize?: string;
    
}

export interface ICronValidationResult {
    
    
    isValid?: boolean;
    
    
    
    validationErrorMessage?: string;
    
    
    
    expressionSummary?: string;
    
    
    
    nextInvalidTime?: Date;
    
}

export class CronValidationResult extends BaseApiModelClass< ICronValidationResult > implements ICronValidationResult {
    
    
    isValid?: boolean;
    
    
    
    validationErrorMessage?: string;
    
    
    
    expressionSummary?: string;
    
    
    
    nextInvalidTime?: Date;
    
}

export interface IDbConfigurationModel {
    
    
    key?: string;
    
    
    
    value?: string;
    
    
    
    description?: string;
    
    
    
    group?: string;
    
}

export class DbConfigurationModel extends BaseApiModelClass< IDbConfigurationModel > implements IDbConfigurationModel {
    
    
    key?: string;
    
    
    
    value?: string;
    
    
    
    description?: string;
    
    
    
    group?: string;
    
}

export interface IEmployeeGapReportItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: EmployeeGapReportItemStatus;
    
    
    
    employeeGapReportId?: number;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    chapterLeaderPrincipalDisplayName?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    costCenter?: string;
    
    
    
    pgCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    location?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    companyDisplayName?: string;
    
    
    
    divisionCodeName?: string;
    
    
    
    divisionDisplayName?: string;
    
    
    
    comment?: string;
    
    
    
    commentedByPrincipal?: string;
    
    
    
    commentedAt?: Date;
    
    
    
    reportingPeriodACodeName?: string;
    
    
    
    reportingPeriodBCodeName?: string;
    
    
    
    reportingPeriodACount?: number;
    
    
    
    reportingPeriodBCount?: number;
    
    
    
    changeCount?: number;
    
    
    
    hasChange?: boolean;
    
    
    
    employeeGapReportItemPersons?: EmployeeGapReportItemPersonModel[];
    
}

export class EmployeeGapReportItemModel extends BaseApiModelClass< IEmployeeGapReportItemModel > implements IEmployeeGapReportItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: EmployeeGapReportItemStatus;
    
    
    
    employeeGapReportId?: number;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    chapterLeaderPrincipalDisplayName?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    costCenter?: string;
    
    
    
    pgCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    location?: string;
    
    
    
    companyCodeName?: string;
    
    
    
    companyDisplayName?: string;
    
    
    
    divisionCodeName?: string;
    
    
    
    divisionDisplayName?: string;
    
    
    
    comment?: string;
    
    
    
    commentedByPrincipal?: string;
    
    
    
    commentedAt?: Date;
    
    
    
    reportingPeriodACodeName?: string;
    
    
    
    reportingPeriodBCodeName?: string;
    
    
    
    reportingPeriodACount?: number;
    
    
    
    reportingPeriodBCount?: number;
    
    
    
    changeCount?: number;
    
    
    
    hasChange?: boolean;
    
    
    
    employeeGapReportItemPersons?: EmployeeGapReportItemPersonModel[];
    
}

export interface IEmployeeGapReportItemPersonModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    employeeGapReportItemId?: number;
    
    
    
    principalId?: number;
    
    
    
    principalEmail?: string;
    
    
    
    principalCodeName?: string;
    
    
    
    principalDisplayName?: string;
    
    
    
    isInReportingPeriodA?: boolean;
    
    
    
    isInReportingPeriodB?: boolean;
    
    
    
    employeeCountPeriodA?: number;
    
    
    
    employeeCountPeriodB?: number;
    
    
    
    isUnknown?: boolean;
    
    
    
    changeType?: string;
    
    
    
    excludeFromApp?: boolean;
    
}

export class EmployeeGapReportItemPersonModel extends BaseApiModelClass< IEmployeeGapReportItemPersonModel > implements IEmployeeGapReportItemPersonModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    employeeGapReportItemId?: number;
    
    
    
    principalId?: number;
    
    
    
    principalEmail?: string;
    
    
    
    principalCodeName?: string;
    
    
    
    principalDisplayName?: string;
    
    
    
    isInReportingPeriodA?: boolean;
    
    
    
    isInReportingPeriodB?: boolean;
    
    
    
    employeeCountPeriodA?: number;
    
    
    
    employeeCountPeriodB?: number;
    
    
    
    isUnknown?: boolean;
    
    
    
    changeType?: string;
    
    
    
    excludeFromApp?: boolean;
    
}

export enum EmployeeGapReportItemStatus {
    Draft = "Draft",
    Confirmed = "Confirmed",
    Denied = "Denied",
}

export interface IEmployeeGapReportModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityCodeName?: string;
    
    
    
    reportingPeriodAId?: number;
    
    
    
    reportingPeriodACodeName?: string;
    
    
    
    reportingPeriodBId?: number;
    
    
    
    reportingPeriodBCodeName?: string;
    
    
    
    errorMessage?: string;
    
}

export class EmployeeGapReportModel extends BaseApiModelClass< IEmployeeGapReportModel > implements IEmployeeGapReportModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityCodeName?: string;
    
    
    
    reportingPeriodAId?: number;
    
    
    
    reportingPeriodACodeName?: string;
    
    
    
    reportingPeriodBId?: number;
    
    
    
    reportingPeriodBCodeName?: string;
    
    
    
    errorMessage?: string;
    
}

export interface IEnumKeyValue {
    
    
    value?: number;
    
    
    
    label?: string;
    
}

export class EnumKeyValue extends BaseApiModelClass< IEnumKeyValue > implements IEnumKeyValue {
    
    
    value?: number;
    
    
    
    label?: string;
    
}

export interface IInformationWidgetModel {
    
    
    title?: string;
    
    
    
    content?: string;
    
}

export class InformationWidgetModel extends BaseApiModelClass< IInformationWidgetModel > implements IInformationWidgetModel {
    
    
    title?: string;
    
    
    
    content?: string;
    
}

export interface IJobDetailsModel {
    
    
    name?: string;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    dateTimeSchedule?: Date;
    
    
    
    parameters?: JobParameterDescriptionModel[];
    
}

export class JobDetailsModel extends BaseApiModelClass< IJobDetailsModel > implements IJobDetailsModel {
    
    
    name?: string;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    dateTimeSchedule?: Date;
    
    
    
    parameters?: JobParameterDescriptionModel[];
    
}

export interface IJobEnumModel {
    
    
    label?: string;
    
    
    
    value?: string;
    
}

export class JobEnumModel extends BaseApiModelClass< IJobEnumModel > implements IJobEnumModel {
    
    
    label?: string;
    
    
    
    value?: string;
    
}

export interface IJobParameterDescriptionModel {
    
    
    name?: string;
    
    
    
    valueRaw?: string;
    
    
    
    jobValueRaw?: string;
    
    
    
    displayName?: string;
    
    
    
    description?: string;
    
    
    
    type?: JobParameterType;
    
    
    
    isRequired?: boolean;
    
    
    
    enumValues?: JobEnumModel[];
    
    
    
    permissionName?: string;
    
}

export class JobParameterDescriptionModel extends BaseApiModelClass< IJobParameterDescriptionModel > implements IJobParameterDescriptionModel {
    
    
    name?: string;
    
    
    
    valueRaw?: string;
    
    
    
    jobValueRaw?: string;
    
    
    
    displayName?: string;
    
    
    
    description?: string;
    
    
    
    type?: JobParameterType;
    
    
    
    isRequired?: boolean;
    
    
    
    enumValues?: JobEnumModel[];
    
    
    
    permissionName?: string;
    
}

export interface IJobParameterModel {
    
    
    name?: string;
    
    
    
    value?: string;
    
}

export class JobParameterModel extends BaseApiModelClass< IJobParameterModel > implements IJobParameterModel {
    
    
    name?: string;
    
    
    
    value?: string;
    
}

export enum JobParameterType {
    String = "String",
    Multiline = "Multiline",
    Integer = "Integer",
    Boolean = "Boolean",
    Enum = "Enum",
    Date = "Date",
    DateTime = "DateTime",
}

export interface IJobSaveParametersModel {
    
    
    jobName?: string;
    
    
    
    triggerName?: string;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    dateTimeSchedule?: Date;
    
    
    
    parameters?: JobParameterModel[];
    
    
    
    useZrhTimeZone?: boolean;
    
    
    
    isJobSettings?: boolean;
    
}

export class JobSaveParametersModel extends BaseApiModelClass< IJobSaveParametersModel > implements IJobSaveParametersModel {
    
    
    jobName?: string;
    
    
    
    triggerName?: string;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    dateTimeSchedule?: Date;
    
    
    
    parameters?: JobParameterModel[];
    
    
    
    useZrhTimeZone?: boolean;
    
    
    
    isJobSettings?: boolean;
    
}

export interface IJobSaveParametersResult {
    
    
    errors?: string[];
    
    
    
    hasErrors?: boolean;
    
}

export class JobSaveParametersResult extends BaseApiModelClass< IJobSaveParametersResult > implements IJobSaveParametersResult {
    
    
    errors?: string[];
    
    
    
    readonly hasErrors?: boolean;
    
}

export interface IJobStartModel {
    
    
    parameters?: JobParameterModel[];
    
}

export class JobStartModel extends BaseApiModelClass< IJobStartModel > implements IJobStartModel {
    
    
    parameters?: JobParameterModel[];
    
}

export enum JobStatus {
    Pending = "Pending",
    Success = "Success",
    Fail = "Fail",
}

export interface IJobTriggerShortInfo {
    
    
    name?: string;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    nextRunDateTime?: Date;
    
    
    
    lastRunDateTime?: Date;
    
    
    
    status?: JobStatus;
    
    
    
    progressMax?: number;
    
    
    
    progressCurrent?: number;
    
    
    
    currentMessage?: string;
    
    
    
    dateTimeSchedule?: Date;
    
    
    
    useZrhTimeZone?: boolean;
    
}

export class JobTriggerShortInfo extends BaseApiModelClass< IJobTriggerShortInfo > implements IJobTriggerShortInfo {
    
    
    name?: string;
    
    
    
    isActive?: boolean;
    
    
    
    cronSchedule?: string;
    
    
    
    nextRunDateTime?: Date;
    
    
    
    lastRunDateTime?: Date;
    
    
    
    status?: JobStatus;
    
    
    
    progressMax?: number;
    
    
    
    progressCurrent?: number;
    
    
    
    currentMessage?: string;
    
    
    
    dateTimeSchedule?: Date;
    
    
    
    useZrhTimeZone?: boolean;
    
}

export interface ILocalUnitCreateModel {
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    isOverhead?: number;
    
    
    
    isOverheadApp?: number;
    
}

export class LocalUnitCreateModel extends BaseApiModelClass< ILocalUnitCreateModel > implements ILocalUnitCreateModel {
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    isOverhead?: number;
    
    
    
    isOverheadApp?: number;
    
}

export interface ILocalUnitIsOverheadCreateModel {
    
    
    localUnitId?: number;
    
    
    
    isOverheadPercentage?: number;
    
    
    
    isOverheadAppPercentage?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export class LocalUnitIsOverheadCreateModel extends BaseApiModelClass< ILocalUnitIsOverheadCreateModel > implements ILocalUnitIsOverheadCreateModel {
    
    
    localUnitId?: number;
    
    
    
    isOverheadPercentage?: number;
    
    
    
    isOverheadAppPercentage?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export interface ILocalUnitIsOverheadModel {
    
    
    id?: number;
    
    
    
    localUnitId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    isOverheadPercentage?: number;
    
    
    
    isOverheadAppPercentage?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    totalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
    
    
    totalIsOverheadAppPerFte?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export class LocalUnitIsOverheadModel extends BaseApiModelClass< ILocalUnitIsOverheadModel > implements ILocalUnitIsOverheadModel {
    
    
    id?: number;
    
    
    
    localUnitId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    isOverheadPercentage?: number;
    
    
    
    isOverheadAppPercentage?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    totalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
    
    
    totalIsOverheadAppPerFte?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export interface ILocalUnitIsOverheadUpdateModel {
    
    
    id?: number;
    
    
    
    localUnitId?: number;
    
    
    
    isOverheadPercentage?: number;
    
    
    
    isOverheadAppPercentage?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export class LocalUnitIsOverheadUpdateModel extends BaseApiModelClass< ILocalUnitIsOverheadUpdateModel > implements ILocalUnitIsOverheadUpdateModel {
    
    
    id?: number;
    
    
    
    localUnitId?: number;
    
    
    
    isOverheadPercentage?: number;
    
    
    
    isOverheadAppPercentage?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
}

export interface ILocalUnitLocationCreateModel {
    
    
    localUnitId?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    localControllerPrincipalId?: number;
    
    
    
    localCostInputProviderPrincipalId?: number;
    
    
    
    localControllerDeputyPrincipalIds?: number[];
    
    
    
    localCostInputProviderDeputyPrincipalIds?: number[];
    
    
    
    faoContactPrincipalIds?: number[];
    
}

export class LocalUnitLocationCreateModel extends BaseApiModelClass< ILocalUnitLocationCreateModel > implements ILocalUnitLocationCreateModel {
    
    
    localUnitId?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    localControllerPrincipalId?: number;
    
    
    
    localCostInputProviderPrincipalId?: number;
    
    
    
    localControllerDeputyPrincipalIds?: number[];
    
    
    
    localCostInputProviderDeputyPrincipalIds?: number[];
    
    
    
    faoContactPrincipalIds?: number[];
    
}

export interface ILocalUnitLocationModel {
    
    
    id?: number;
    
    
    
    localUnitId?: number;
    
    
    
    location?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    vatNumber?: string;
    
    
    
    localControllerPrincipalId?: number;
    
    
    
    localControllerPrincipalDisplayName?: string;
    
    
    
    localCostInputProviderPrincipalId?: number;
    
    
    
    localCostInputProviderPrincipalDisplayName?: string;
    
    
    
    localControllerDeputyPrincipalIds?: number[];
    
    
    
    localControllerDeputyPrincipalDisplayNames?: string;
    
    
    
    localCostInputProviderDeputyPrincipalIds?: number[];
    
    
    
    localCostInputProviderDeputyPrincipalDisplayNames?: string;
    
    
    
    faoContactPrincipalIds?: number[];
    
    
    
    faoContactPrincipalDisplayNames?: string;
    
}

export class LocalUnitLocationModel extends BaseApiModelClass< ILocalUnitLocationModel > implements ILocalUnitLocationModel {
    
    
    id?: number;
    
    
    
    localUnitId?: number;
    
    
    
    location?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    vatNumber?: string;
    
    
    
    localControllerPrincipalId?: number;
    
    
    
    localControllerPrincipalDisplayName?: string;
    
    
    
    localCostInputProviderPrincipalId?: number;
    
    
    
    localCostInputProviderPrincipalDisplayName?: string;
    
    
    
    localControllerDeputyPrincipalIds?: number[];
    
    
    
    localControllerDeputyPrincipalDisplayNames?: string;
    
    
    
    localCostInputProviderDeputyPrincipalIds?: number[];
    
    
    
    localCostInputProviderDeputyPrincipalDisplayNames?: string;
    
    
    
    faoContactPrincipalIds?: number[];
    
    
    
    faoContactPrincipalDisplayNames?: string;
    
}

export interface ILocalUnitLocationPGCreateModel {
    
    
    localUnitLocationId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
}

export class LocalUnitLocationPGCreateModel extends BaseApiModelClass< ILocalUnitLocationPGCreateModel > implements ILocalUnitLocationPGCreateModel {
    
    
    localUnitLocationId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
}

export interface ILocalUnitLocationPGModel {
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    orgUnitDisplayName?: string;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
}

export class LocalUnitLocationPGModel extends BaseApiModelClass< ILocalUnitLocationPGModel > implements ILocalUnitLocationPGModel {
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitLocationPGId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    orgUnitDisplayName?: string;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
}

export interface ILocalUnitLocationPGUpdateModel {
    
    
    localUnitLocationPGId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
}

export class LocalUnitLocationPGUpdateModel extends BaseApiModelClass< ILocalUnitLocationPGUpdateModel > implements ILocalUnitLocationPGUpdateModel {
    
    
    localUnitLocationPGId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    cfinProfitCenter?: string;
    
    
    
    pooling?: boolean;
    
}

export interface ILocalUnitLocationUpdateModel {
    
    
    id?: number;
    
    
    
    location?: string;
    
    
    
    tcd?: string;
    
    
    
    vatNumber?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    localControllerPrincipalId?: number;
    
    
    
    localCostInputProviderPrincipalId?: number;
    
    
    
    localControllerDeputyPrincipalIds?: number[];
    
    
    
    localCostInputProviderDeputyPrincipalIds?: number[];
    
    
    
    faoContactPrincipalIds?: number[];
    
}

export class LocalUnitLocationUpdateModel extends BaseApiModelClass< ILocalUnitLocationUpdateModel > implements ILocalUnitLocationUpdateModel {
    
    
    id?: number;
    
    
    
    location?: string;
    
    
    
    tcd?: string;
    
    
    
    vatNumber?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    localControllerPrincipalId?: number;
    
    
    
    localCostInputProviderPrincipalId?: number;
    
    
    
    localControllerDeputyPrincipalIds?: number[];
    
    
    
    localCostInputProviderDeputyPrincipalIds?: number[];
    
    
    
    faoContactPrincipalIds?: number[];
    
}

export interface ILocalUnitModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    legalOrgUnitFullName?: string;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    mgtOrgUnitCodeName?: string;
    
    
    
    mgtOrgUnitFullName?: string;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    reportingCurrencyCodeName?: string;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    invoicingCurrencyCodeName?: string;
    
    
    
    isOverhead?: number;
    
    
    
    isOverheadApp?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
}

export class LocalUnitModel extends BaseApiModelClass< ILocalUnitModel > implements ILocalUnitModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    legalOrgUnitFullName?: string;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    mgtOrgUnitCodeName?: string;
    
    
    
    mgtOrgUnitFullName?: string;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    reportingCurrencyCodeName?: string;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    invoicingCurrencyCodeName?: string;
    
    
    
    isOverhead?: number;
    
    
    
    isOverheadApp?: number;
    
    
    
    localIsOverheadPerFte?: number;
    
    
    
    globalIsOverheadPerFte?: number;
    
    
    
    localIsOverheadAppPerFte?: number;
    
    
    
    globalIsOverheadAppPerFte?: number;
    
}

export interface ILocalUnitUpdateModel {
    
    
    id?: number;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
}

export class LocalUnitUpdateModel extends BaseApiModelClass< ILocalUnitUpdateModel > implements ILocalUnitUpdateModel {
    
    
    id?: number;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
}

export interface ILocalUnitWithPrimaryCostAgreementStatusModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    primaryCostAgreementStatus?: PrimaryCostAgreementStatus;
    
}

export class LocalUnitWithPrimaryCostAgreementStatusModel extends BaseApiModelClass< ILocalUnitWithPrimaryCostAgreementStatusModel > implements ILocalUnitWithPrimaryCostAgreementStatusModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    primaryCostAgreementStatus?: PrimaryCostAgreementStatus;
    
}

export interface ILocationsWithAgileUnitsSidebarModel {
    
    
    localUnitLocationDisplayName?: string;
    
    
    
    agileUnits?: AgileUnitWithChaptersSidebarModel[];
    
}

export class LocationsWithAgileUnitsSidebarModel extends BaseApiModelClass< ILocationsWithAgileUnitsSidebarModel > implements ILocationsWithAgileUnitsSidebarModel {
    
    
    localUnitLocationDisplayName?: string;
    
    
    
    agileUnits?: AgileUnitWithChaptersSidebarModel[];
    
}

export interface ILookupModel {
    
    
    value?: number;
    
    
    
    label?: string;
    
}

export class LookupModel extends BaseApiModelClass< ILookupModel > implements ILookupModel {
    
    
    value?: number;
    
    
    
    label?: string;
    
}

export interface ILookupStringValueModel {
    
    
    value?: string;
    
    
    
    label?: string;
    
}

export class LookupStringValueModel extends BaseApiModelClass< ILookupStringValueModel > implements ILookupStringValueModel {
    
    
    value?: string;
    
    
    
    label?: string;
    
}

export interface IMarkupCreateModel {
    
    
    countryId?: number;
    
    
    
    markup?: number;
    
    
    
    isOverhead?: number;
    
    
    
    vat?: number;
    
    
    
    yearFrom?: number;
    
}

export class MarkupCreateModel extends BaseApiModelClass< IMarkupCreateModel > implements IMarkupCreateModel {
    
    
    countryId?: number;
    
    
    
    markup?: number;
    
    
    
    isOverhead?: number;
    
    
    
    vat?: number;
    
    
    
    yearFrom?: number;
    
}

export interface IMarkupModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    countryId?: number;
    
    
    
    markup?: number;
    
    
    
    vat?: number;
    
    
    
    yearFrom?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    displayName?: string;
    
}

export class MarkupModel extends BaseApiModelClass< IMarkupModel > implements IMarkupModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    countryId?: number;
    
    
    
    markup?: number;
    
    
    
    vat?: number;
    
    
    
    yearFrom?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    displayName?: string;
    
}

export interface IMarkupUpdateModel {
    
    
    id?: number;
    
    
    
    markup?: number;
    
    
    
    isOverhead?: number;
    
    
    
    vat?: number;
    
}

export class MarkupUpdateModel extends BaseApiModelClass< IMarkupUpdateModel > implements IMarkupUpdateModel {
    
    
    id?: number;
    
    
    
    markup?: number;
    
    
    
    isOverhead?: number;
    
    
    
    vat?: number;
    
}

export enum MessageTypeEnum {
    None = "None",
    AccrualRequestIn = "AccrualRequestIn",
    AccrualApproval = "AccrualApproval",
    AccrualFileToErp = "AccrualFileToErp",
    AccrualBookedInErp = "AccrualBookedInErp",
    AccrualToMgs = "AccrualToMgs",
    CalculateAccrual = "CalculateAccrual",
    AccrualRequestOut = "AccrualRequestOut",
    AccrualToErp = "AccrualToErp",
    AccrualReview = "AccrualReview",
    AccrualApproved = "AccrualApproved",
    ServiceAccrualApproved = "ServiceAccrualApproved",
    PrimaryCostAnualPlanApprovalAgileUnitLeader = "PrimaryCostAnualPlanApprovalAgileUnitLeader",
    PrimaryCostAnualPlanApprovalLocalUnitController = "PrimaryCostAnualPlanApprovalLocalUnitController",
    ServiceAnualPlanApprovalPGManager = "ServiceAnualPlanApprovalPGManager",
    ServiceAnualPlanApprovalPGController = "ServiceAnualPlanApprovalPGController",
    ActualInvoicingRequest = "ActualInvoicingRequest",
    ActualInvoicingApproval = "ActualInvoicingApproval",
    IssueInvoiceInErpAndSendPdfToPoolingEntity = "IssueInvoiceInErpAndSendPdfToPoolingEntity",
    UploadIssuedInvoiceToMgs = "UploadIssuedInvoiceToMgs",
    InvoicesBookedInErp = "InvoicesBookedInErp",
    InvoicedAmountsToMgs = "InvoicedAmountsToMgs",
    CalculateInvoice = "CalculateInvoice",
    InvoiceFile = "InvoiceFile",
    InvoiceConfirmation = "InvoiceConfirmation",
    InvoiceIssuedInPoolingErpAndSendPdfToServiceRecipient = "InvoiceIssuedInPoolingErpAndSendPdfToServiceRecipient",
    ActualInvoicingReview = "ActualInvoicingReview",
    CreateFileFromHrGroupTool = "CreateFileFromHrGroupTool",
    PrepareUploadFileAndVerifyDataQuality = "PrepareUploadFileAndVerifyDataQuality",
    UploadPeopleFileToMgs = "UploadPeopleFileToMgs",
    PrepareGapAnalysisVsPreviousUpload = "PrepareGapAnalysisVsPreviousUpload",
    VerificationRequest = "VerificationRequest",
    InformHrAboutGapFeedbacks = "InformHrAboutGapFeedbacks",
    Input5QRF = "Input5QRF",
    Review5QRF = "Review5QRF",
    Approval5QRFByAULeader = "Approval5QRFByAULeader",
    Approval5QRFByAUController = "Approval5QRFByAUController",
    InputApp1 = "InputApp1",
    ReviewApp1 = "ReviewApp1",
    ApprovalApp1ByAULeader = "ApprovalApp1ByAULeader",
    ApprovalApp1ByAUController = "ApprovalApp1ByAUController",
    InputAppFinal = "InputAppFinal",
    ReviewAppFinal = "ReviewAppFinal",
    ApprovalAppFinalByAULeader = "ApprovalAppFinalByAULeader",
    ApprovalAppFinalByAUController = "ApprovalAppFinalByAUController",
}

export interface IMessageTypeInfo {
    
    
    id?: number;
    
    
    
    codeName?: string;
    
    
    
    displayName?: string;
    
}

export class MessageTypeInfo extends BaseApiModelClass< IMessageTypeInfo > implements IMessageTypeInfo {
    
    
    id?: number;
    
    
    
    codeName?: string;
    
    
    
    displayName?: string;
    
}

export interface IObjectRoleInfo {
    
    
    objectUniqueId?: string;
    
    
    
    originObjectUniqueId?: string;
    
    
    
    originObjectType?: string;
    
    
    
    originObjectTypeDisplayName?: string;
    
    
    
    originObjectTypeGroupName?: string;
    
    
    
    roleId?: number;
    
    
    
    roleCodeName?: string;
    
    
    
    roleDisplayName?: string;
    
    
    
    roleMembersCount?: number;
    
    
    
    sort?: number;
    
    
    
    modalInfoBoxLink?: string;
    
    
    
    uniqueKey?: string;
    
}

export class ObjectRoleInfo extends BaseApiModelClass< IObjectRoleInfo > implements IObjectRoleInfo {
    
    
    objectUniqueId?: string;
    
    
    
    originObjectUniqueId?: string;
    
    
    
    originObjectType?: string;
    
    
    
    originObjectTypeDisplayName?: string;
    
    
    
    originObjectTypeGroupName?: string;
    
    
    
    roleId?: number;
    
    
    
    roleCodeName?: string;
    
    
    
    roleDisplayName?: string;
    
    
    
    roleMembersCount?: number;
    
    
    
    sort?: number;
    
    
    
    modalInfoBoxLink?: string;
    
    
    
    readonly uniqueKey?: string;
    
}

export interface IOrgUnitInflationRateCreateModel {
    
    
    orgUnitId?: number;
    
    
    
    value?: number;
    
}

export class OrgUnitInflationRateCreateModel extends BaseApiModelClass< IOrgUnitInflationRateCreateModel > implements IOrgUnitInflationRateCreateModel {
    
    
    orgUnitId?: number;
    
    
    
    value?: number;
    
}

export interface IOrgUnitInflationRateModel {
    
    
    id?: number;
    
    
    
    financialYearId?: number;
    
    
    
    financialYearDisplayName?: string;
    
    
    
    value?: number;
    
}

export class OrgUnitInflationRateModel extends BaseApiModelClass< IOrgUnitInflationRateModel > implements IOrgUnitInflationRateModel {
    
    
    id?: number;
    
    
    
    financialYearId?: number;
    
    
    
    financialYearDisplayName?: string;
    
    
    
    value?: number;
    
}

export interface IOrgUnitInflationRateUpdateModel {
    
    
    id?: number;
    
    
    
    value?: number;
    
}

export class OrgUnitInflationRateUpdateModel extends BaseApiModelClass< IOrgUnitInflationRateUpdateModel > implements IOrgUnitInflationRateUpdateModel {
    
    
    id?: number;
    
    
    
    value?: number;
    
}

export interface IOrgUnitModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
    
    
    codeName?: string;
    
    
    
    objectType?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    parentOrgUnitId?: number;
    
    
    
    sortOrder?: number;
    
    
    
    orgUnitManagerId?: number;
    
    
    
    orgUnitManagerDisplayName?: string;
    
    
    
    orgUnitControllerId?: number;
    
    
    
    orgUnitControllerDisplayName?: string;
    
    
    
    taxResponsibleId?: number;
    
    
    
    taxResponsibleDisplayName?: string;
    
    
    
    orgUnitReaderPrincipalIds?: number[];
    
    
    
    orgUnitReaderPrincipalDisplayNames?: string;
    
    
    
    childrenCount?: number;
    
    
    
    inflationRateId?: number;
    
    
    
    inflationRate?: number;
    
}

export class OrgUnitModel extends BaseApiModelClass< IOrgUnitModel > implements IOrgUnitModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
    
    
    codeName?: string;
    
    
    
    objectType?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    parentOrgUnitId?: number;
    
    
    
    sortOrder?: number;
    
    
    
    orgUnitManagerId?: number;
    
    
    
    orgUnitManagerDisplayName?: string;
    
    
    
    orgUnitControllerId?: number;
    
    
    
    orgUnitControllerDisplayName?: string;
    
    
    
    taxResponsibleId?: number;
    
    
    
    taxResponsibleDisplayName?: string;
    
    
    
    orgUnitReaderPrincipalIds?: number[];
    
    
    
    orgUnitReaderPrincipalDisplayNames?: string;
    
    
    
    childrenCount?: number;
    
    
    
    inflationRateId?: number;
    
    
    
    inflationRate?: number;
    
}

export interface IOrgUnitUpdateModel {
    
    
    id?: number;
    
    
    
    pgManagerPrincipalId?: number;
    
    
    
    pgControllerPrincipalId?: number;
    
    
    
    taxResponsiblePrincipalId?: number;
    
    
    
    orgUnitReaderPrincipalIds?: number[];
    
}

export class OrgUnitUpdateModel extends BaseApiModelClass< IOrgUnitUpdateModel > implements IOrgUnitUpdateModel {
    
    
    id?: number;
    
    
    
    pgManagerPrincipalId?: number;
    
    
    
    pgControllerPrincipalId?: number;
    
    
    
    taxResponsiblePrincipalId?: number;
    
    
    
    orgUnitReaderPrincipalIds?: number[];
    
}

export interface IPoolingEntityCreateModel {
    
    
    companyId?: number;
    
    
    
    divisionId?: number;
    
    
    
    booksToPGId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    targetId?: number;
    
    
    
    divisionResponsiblePrincipalId?: number;
    
    
    
    divisionResponsibleDeputiesIds?: number[];
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    accountCustomer?: string;
    
    
    
    accountVendor?: string;
    
    
    
    accountSalesCustomer?: string;
    
    
    
    accountSalesVendor?: string;
    
    
    
    accountCustomerGA?: string;
    
    
    
    accountCustomerCos?: string;
    
    
    
    accountVendorGA?: string;
    
    
    
    accountVendorCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    managementUnit?: string;
    
}

export class PoolingEntityCreateModel extends BaseApiModelClass< IPoolingEntityCreateModel > implements IPoolingEntityCreateModel {
    
    
    companyId?: number;
    
    
    
    divisionId?: number;
    
    
    
    booksToPGId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    targetId?: number;
    
    
    
    divisionResponsiblePrincipalId?: number;
    
    
    
    divisionResponsibleDeputiesIds?: number[];
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    accountCustomer?: string;
    
    
    
    accountVendor?: string;
    
    
    
    accountSalesCustomer?: string;
    
    
    
    accountSalesVendor?: string;
    
    
    
    accountCustomerGA?: string;
    
    
    
    accountCustomerCos?: string;
    
    
    
    accountVendorGA?: string;
    
    
    
    accountVendorCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    managementUnit?: string;
    
}

export interface IPoolingEntityModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    division?: string;
    
    
    
    company?: string;
    
    
    
    booksToPG?: string;
    
    
    
    target?: PoolingEntityTarget;
    
    
    
    reportingCurrency?: string;
    
    
    
    invoicingCurrency?: string;
    
    
    
    divisionResponsible?: string;
    
    
    
    divisionResponsibleDeputies?: string;
    
    
    
    divisionId?: number;
    
    
    
    companyId?: number;
    
    
    
    booksToPGId?: number;
    
    
    
    targetId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    divisionResponsibleId?: number;
    
    
    
    divisionResponsibleDeputiesIds?: number[];
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    accountCustomer?: string;
    
    
    
    accountVendor?: string;
    
    
    
    accountSalesCustomer?: string;
    
    
    
    accountSalesVendor?: string;
    
    
    
    accountCustomerGA?: string;
    
    
    
    accountCustomerCos?: string;
    
    
    
    accountVendorGA?: string;
    
    
    
    accountVendorCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    managementUnit?: string;
    
}

export class PoolingEntityModel extends BaseApiModelClass< IPoolingEntityModel > implements IPoolingEntityModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    division?: string;
    
    
    
    company?: string;
    
    
    
    booksToPG?: string;
    
    
    
    target?: PoolingEntityTarget;
    
    
    
    reportingCurrency?: string;
    
    
    
    invoicingCurrency?: string;
    
    
    
    divisionResponsible?: string;
    
    
    
    divisionResponsibleDeputies?: string;
    
    
    
    divisionId?: number;
    
    
    
    companyId?: number;
    
    
    
    booksToPGId?: number;
    
    
    
    targetId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    divisionResponsibleId?: number;
    
    
    
    divisionResponsibleDeputiesIds?: number[];
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    accountCustomer?: string;
    
    
    
    accountVendor?: string;
    
    
    
    accountSalesCustomer?: string;
    
    
    
    accountSalesVendor?: string;
    
    
    
    accountCustomerGA?: string;
    
    
    
    accountCustomerCos?: string;
    
    
    
    accountVendorGA?: string;
    
    
    
    accountVendorCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    managementUnit?: string;
    
}

export enum PoolingEntityTarget {
    Global = "Global",
}

export interface IPoolingEntityUpdateModel {
    
    
    id?: number;
    
    
    
    companyId?: number;
    
    
    
    divisionId?: number;
    
    
    
    booksToPGId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    targetId?: number;
    
    
    
    divisionResponsiblePrincipalId?: number;
    
    
    
    divisionResponsibleDeputiesIds?: number[];
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    accountCustomer?: string;
    
    
    
    accountVendor?: string;
    
    
    
    accountSalesCustomer?: string;
    
    
    
    accountSalesVendor?: string;
    
    
    
    accountCustomerGA?: string;
    
    
    
    accountCustomerCos?: string;
    
    
    
    accountVendorGA?: string;
    
    
    
    accountVendorCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    vatNumber?: string;
    
    
    
    managementUnit?: string;
    
}

export class PoolingEntityUpdateModel extends BaseApiModelClass< IPoolingEntityUpdateModel > implements IPoolingEntityUpdateModel {
    
    
    id?: number;
    
    
    
    companyId?: number;
    
    
    
    divisionId?: number;
    
    
    
    booksToPGId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    targetId?: number;
    
    
    
    divisionResponsiblePrincipalId?: number;
    
    
    
    divisionResponsibleDeputiesIds?: number[];
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    etcdVendor?: string;
    
    
    
    accountCustomer?: string;
    
    
    
    accountVendor?: string;
    
    
    
    accountSalesCustomer?: string;
    
    
    
    accountSalesVendor?: string;
    
    
    
    accountCustomerGA?: string;
    
    
    
    accountCustomerCos?: string;
    
    
    
    accountVendorGA?: string;
    
    
    
    accountVendorCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    vatNumber?: string;
    
    
    
    managementUnit?: string;
    
}

export interface IPoolingEntityWithLocalUnitModels {
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    localUnits?: LocalUnitWithPrimaryCostAgreementStatusModel[];
    
}

export class PoolingEntityWithLocalUnitModels extends BaseApiModelClass< IPoolingEntityWithLocalUnitModels > implements IPoolingEntityWithLocalUnitModels {
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    localUnits?: LocalUnitWithPrimaryCostAgreementStatusModel[];
    
}

export interface IPoolingEntityWithServiceBeneficiaryUnitModels {
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnits?: ServiceBeneficiaryUnitWithServiceAgreementStatusModel[];
    
}

export class PoolingEntityWithServiceBeneficiaryUnitModels extends BaseApiModelClass< IPoolingEntityWithServiceBeneficiaryUnitModels > implements IPoolingEntityWithServiceBeneficiaryUnitModels {
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnits?: ServiceBeneficiaryUnitWithServiceAgreementStatusModel[];
    
}

export interface IPrimaryCostAccrualInflowModel {
    
    
    reportingPeriodDisplayName?: string;
    
    
    
    status?: AccrualStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    localUnitDivision?: string;
    
    
    
    localUnitCompany?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    pgCode?: string;
    
    
    
    pgName?: string;
    
    
    
    primaryCostLOC?: number;
    
    
    
    isOverheadLOC?: number;
    
    
    
    markupLOC?: number;
    
    
    
    totalLOC?: number;
    
    
    
    locCurrency?: string;
    
    
    
    totalUSD?: number;
    
    
    
    totalPoolingEntity?: number;
    
    
    
    poolingEntityCurrency?: string;
    
    
    
    chapterType?: string;
    
}

export class PrimaryCostAccrualInflowModel extends BaseApiModelClass< IPrimaryCostAccrualInflowModel > implements IPrimaryCostAccrualInflowModel {
    
    
    reportingPeriodDisplayName?: string;
    
    
    
    status?: AccrualStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    localUnitDivision?: string;
    
    
    
    localUnitCompany?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    pgCode?: string;
    
    
    
    pgName?: string;
    
    
    
    primaryCostLOC?: number;
    
    
    
    isOverheadLOC?: number;
    
    
    
    markupLOC?: number;
    
    
    
    totalLOC?: number;
    
    
    
    locCurrency?: string;
    
    
    
    totalUSD?: number;
    
    
    
    totalPoolingEntity?: number;
    
    
    
    poolingEntityCurrency?: string;
    
    
    
    chapterType?: string;
    
}

export interface IPrimaryCostAccrualItemModel {
    
    
    id?: number;
    
    
    
    reportingPeriodCodeName?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitPGDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    location?: string;
    
    
    
    chapterType?: ChapterType;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpDisplayName?: string;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    primaryCostProposal?: number;
    
    
    
    primaryCostKLoc?: number;
    
    
    
    isOverheadCalcLoc?: number;
    
    
    
    markupCalcLoc?: number;
    
    
    
    vatCalcLoc?: number;
    
    
    
    totalCalcUsd?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcPoolingCurrency?: number;
    
    
    
    costType?: string;
    
}

export class PrimaryCostAccrualItemModel extends BaseApiModelClass< IPrimaryCostAccrualItemModel > implements IPrimaryCostAccrualItemModel {
    
    
    id?: number;
    
    
    
    reportingPeriodCodeName?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitId?: number;
    
    
    
    localUnitDisplayName?: string;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitPGDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    location?: string;
    
    
    
    chapterType?: ChapterType;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpDisplayName?: string;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    primaryCostProposal?: number;
    
    
    
    primaryCostKLoc?: number;
    
    
    
    isOverheadCalcLoc?: number;
    
    
    
    markupCalcLoc?: number;
    
    
    
    vatCalcLoc?: number;
    
    
    
    totalCalcUsd?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcPoolingCurrency?: number;
    
    
    
    costType?: string;
    
}

export interface IPrimaryCostAccrualItemRestApiModel {
    
    
    id: number;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    pG_Local_ERP: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_Local_ERP: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    pooling_enabled: boolean;
    
    
    
    "primary_Cost_Original_APP_[USD]": number;
    
    
    
    "iS_Overhead_Original_APP_[USD]": number;
    
    
    
    "markup_Original_APP_[USD]": number;
    
    
    
    "vAT_Original_APP_[USD]": number;
    
    
    
    "total_Refund_Original_APP_[USD]": number;
    
    
    
    "primary_Cost_Latest_APP_[USD]": number;
    
    
    
    "iS_Overhead_Latest_APP_[USD]": number;
    
    
    
    "markup_Latest_APP_[USD]": number;
    
    
    
    "vAT_Latest_APP_[USD]": number;
    
    
    
    "total_Refund_Latest_APP_[USD]": number;
    
    
    
    primary_Cost_Reporting_Currency: number;
    
    
    
    iS_Overhead_Reporting_Currency: number;
    
    
    
    markup_Reporting_Currency: number;
    
    
    
    vAT_Reporting_Currency: number;
    
    
    
    total_Refund_Reporting_Currency: number;
    
    
    
    central_Unit_Total_Refund: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    reporting_Currency: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    central_Unit_Reporting_Currency: string;
    
    
    
    central_Unit_Invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export class PrimaryCostAccrualItemRestApiModel extends BaseApiModelClass< IPrimaryCostAccrualItemRestApiModel > implements IPrimaryCostAccrualItemRestApiModel {
    
    
    id: number;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    pG_Local_ERP: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_Local_ERP: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    pooling_enabled: boolean;
    
    
    
    "primary_Cost_Original_APP_[USD]": number;
    
    
    
    "iS_Overhead_Original_APP_[USD]": number;
    
    
    
    "markup_Original_APP_[USD]": number;
    
    
    
    "vAT_Original_APP_[USD]": number;
    
    
    
    "total_Refund_Original_APP_[USD]": number;
    
    
    
    "primary_Cost_Latest_APP_[USD]": number;
    
    
    
    "iS_Overhead_Latest_APP_[USD]": number;
    
    
    
    "markup_Latest_APP_[USD]": number;
    
    
    
    "vAT_Latest_APP_[USD]": number;
    
    
    
    "total_Refund_Latest_APP_[USD]": number;
    
    
    
    primary_Cost_Reporting_Currency: number;
    
    
    
    iS_Overhead_Reporting_Currency: number;
    
    
    
    markup_Reporting_Currency: number;
    
    
    
    vAT_Reporting_Currency: number;
    
    
    
    total_Refund_Reporting_Currency: number;
    
    
    
    central_Unit_Total_Refund: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    reporting_Currency: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    central_Unit_Reporting_Currency: string;
    
    
    
    central_Unit_Invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export interface IPrimaryCostAccrualItemUpdateModel {
    
    
    id?: number;
    
    
    
    primaryCostLoc?: number;
    
}

export class PrimaryCostAccrualItemUpdateModel extends BaseApiModelClass< IPrimaryCostAccrualItemUpdateModel > implements IPrimaryCostAccrualItemUpdateModel {
    
    
    id?: number;
    
    
    
    primaryCostLoc?: number;
    
}

export interface IPrimaryCostAccrualModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    reportingPeriodId?: number;
    
    
    
    reportingPeriodStartDate?: Date;
    
    
    
    reportingPeriodEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: AccrualStatus;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
}

export class PrimaryCostAccrualModel extends BaseApiModelClass< IPrimaryCostAccrualModel > implements IPrimaryCostAccrualModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    reportingPeriodId?: number;
    
    
    
    reportingPeriodStartDate?: Date;
    
    
    
    reportingPeriodEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: AccrualStatus;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
}

export interface IPrimaryCostAgreementModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitLocationDisplayName?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostAgreementStatus;
    
}

export class PrimaryCostAgreementModel extends BaseApiModelClass< IPrimaryCostAgreementModel > implements IPrimaryCostAgreementModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    localUnitLocationId?: number;
    
    
    
    localUnitLocationDisplayName?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostAgreementStatus;
    
}

export interface IPrimaryCostAgreementRestApiModel {
    
    
    id: number;
    
    
    
    pooling_Entity_Id: number;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Location_Id: number;
    
    
    
    local_Unit_Location: string;
    
    
    
    cIT: boolean;
    
    
    
    payment_Terms: number;
    
}

export class PrimaryCostAgreementRestApiModel extends BaseApiModelClass< IPrimaryCostAgreementRestApiModel > implements IPrimaryCostAgreementRestApiModel {
    
    
    id: number;
    
    
    
    pooling_Entity_Id: number;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Location_Id: number;
    
    
    
    local_Unit_Location: string;
    
    
    
    cIT: boolean;
    
    
    
    payment_Terms: number;
    
}

export interface IPrimaryCostAgreementRestApiModelPagedResponse {
    
    
    totalCount?: number;
    
    
    
    pageSize?: number;
    
    
    
    currentPage?: number;
    
    
    
    totalPages?: number;
    
    
    
    items?: PrimaryCostAgreementRestApiModel[];
    
}

export class PrimaryCostAgreementRestApiModelPagedResponse extends BaseApiModelClass< IPrimaryCostAgreementRestApiModelPagedResponse > implements IPrimaryCostAgreementRestApiModelPagedResponse {
    
    
    totalCount?: number;
    
    
    
    pageSize?: number;
    
    
    
    currentPage?: number;
    
    
    
    totalPages?: number;
    
    
    
    items?: PrimaryCostAgreementRestApiModel[];
    
}

export enum PrimaryCostAgreementStatus {
    Draft = "Draft",
    Active = "Active",
    Closed = "Closed",
    Withdrawn = "Withdrawn",
}

export interface IPrimaryCostAgreementUpdateModel {
    
    
    id?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
}

export class PrimaryCostAgreementUpdateModel extends BaseApiModelClass< IPrimaryCostAgreementUpdateModel > implements IPrimaryCostAgreementUpdateModel {
    
    
    id?: number;
    
    
    
    localUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
}

export interface IPrimaryCostAgreementСreateModel {
    
    
    localUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
}

export class PrimaryCostAgreementСreateModel extends BaseApiModelClass< IPrimaryCostAgreementСreateModel > implements IPrimaryCostAgreementСreateModel {
    
    
    localUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
}

export interface IPrimaryCostAnnualPlanItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAnnualPlanId?: number;
    
    
    
    agreementChapterItemId?: number;
    
    
    
    pgCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    valueUsd?: number;
    
    
    
    valueLoc?: number;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: AnnualPlanItemStatus;
    
    
    
    approvedByControllerPrincipalId?: number;
    
    
    
    approvedByControllerPrincipalDisplayName?: string;
    
    
    
    approvedByLeaderPrincipalId?: number;
    
    
    
    approvedByLeaderPrincipalDisplayName?: string;
    
    
    
    approvedByControllerAt?: Date;
    
    
    
    approvedByLeaderAt?: Date;
    
    
    
    costType?: string;
    
    
    
    costCenterLocalERP?: string;
    
    
    
    pooling?: boolean;
    
    
    
    isOverheadUSD?: number;
    
    
    
    markupUSD?: number;
    
    
    
    vatusd?: number;
    
    
    
    totalRefundUSD?: number;
    
    
    
    year?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    agreementDisplayName?: string;
    
}

export class PrimaryCostAnnualPlanItemModel extends BaseApiModelClass< IPrimaryCostAnnualPlanItemModel > implements IPrimaryCostAnnualPlanItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAnnualPlanId?: number;
    
    
    
    agreementChapterItemId?: number;
    
    
    
    pgCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    valueUsd?: number;
    
    
    
    valueLoc?: number;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: AnnualPlanItemStatus;
    
    
    
    approvedByControllerPrincipalId?: number;
    
    
    
    approvedByControllerPrincipalDisplayName?: string;
    
    
    
    approvedByLeaderPrincipalId?: number;
    
    
    
    approvedByLeaderPrincipalDisplayName?: string;
    
    
    
    approvedByControllerAt?: Date;
    
    
    
    approvedByLeaderAt?: Date;
    
    
    
    costType?: string;
    
    
    
    costCenterLocalERP?: string;
    
    
    
    pooling?: boolean;
    
    
    
    isOverheadUSD?: number;
    
    
    
    markupUSD?: number;
    
    
    
    vatusd?: number;
    
    
    
    totalRefundUSD?: number;
    
    
    
    year?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    agreementDisplayName?: string;
    
}

export interface IPrimaryCostAnnualPlanItemUpdateModel {
    
    
    id?: number;
    
    
    
    valueUsd?: number;
    
}

export class PrimaryCostAnnualPlanItemUpdateModel extends BaseApiModelClass< IPrimaryCostAnnualPlanItemUpdateModel > implements IPrimaryCostAnnualPlanItemUpdateModel {
    
    
    id?: number;
    
    
    
    valueUsd?: number;
    
}

export interface IPrimaryCostAnnualPlanModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    agreementChapterId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
}

export class PrimaryCostAnnualPlanModel extends BaseApiModelClass< IPrimaryCostAnnualPlanModel > implements IPrimaryCostAnnualPlanModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    agreementChapterId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
}

export interface IPrimaryCostAnnualPlanWidgetModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    status?: AnnualPlanItemStatus;
    
    
    
    draftCount?: number;
    
    
    
    inApprovalCount?: number;
    
    
    
    approvedCount?: number;
    
}

export class PrimaryCostAnnualPlanWidgetModel extends BaseApiModelClass< IPrimaryCostAnnualPlanWidgetModel > implements IPrimaryCostAnnualPlanWidgetModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    status?: AnnualPlanItemStatus;
    
    
    
    draftCount?: number;
    
    
    
    inApprovalCount?: number;
    
    
    
    approvedCount?: number;
    
}

export interface IPrimaryCostInvoiceInflowModel {
    
    
    quarterDisplayName?: string;
    
    
    
    year?: number;
    
    
    
    quarter?: number;
    
    
    
    status?: PrimaryCostInvoiceStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    localUnitDivision?: string;
    
    
    
    localUnitCompany?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    pgCode?: string;
    
    
    
    totalCalcLocCurrency?: string;
    
    
    
    primaryCostLoc?: number;
    
    
    
    isOverheadCalcLoc?: number;
    
    
    
    markupCalcLoc?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcInv?: number;
    
    
    
    totalCalcUsd?: number;
    
    
    
    vatCalcLoc?: number;
    
    
    
    vatCalcInv?: number;
    
    
    
    totalInclVatCalcLoc?: number;
    
    
    
    totalInclVatCalcInv?: number;
    
    
    
    totalInclVatCalcUsd?: number;
    
    
    
    totalCalcPoolingCurrency?: number;
    
    
    
    chapterType?: string;
    
}

export class PrimaryCostInvoiceInflowModel extends BaseApiModelClass< IPrimaryCostInvoiceInflowModel > implements IPrimaryCostInvoiceInflowModel {
    
    
    quarterDisplayName?: string;
    
    
    
    year?: number;
    
    
    
    quarter?: number;
    
    
    
    status?: PrimaryCostInvoiceStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    localUnitDivision?: string;
    
    
    
    localUnitCompany?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    pgCode?: string;
    
    
    
    totalCalcLocCurrency?: string;
    
    
    
    primaryCostLoc?: number;
    
    
    
    isOverheadCalcLoc?: number;
    
    
    
    markupCalcLoc?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcInv?: number;
    
    
    
    totalCalcUsd?: number;
    
    
    
    vatCalcLoc?: number;
    
    
    
    vatCalcInv?: number;
    
    
    
    totalInclVatCalcLoc?: number;
    
    
    
    totalInclVatCalcInv?: number;
    
    
    
    totalInclVatCalcUsd?: number;
    
    
    
    totalCalcPoolingCurrency?: number;
    
    
    
    chapterType?: string;
    
}

export interface IPrimaryCostInvoiceItemModel {
    
    
    id?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitPGDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    poolingEnabled?: boolean;
    
    
    
    costType?: string;
    
    
    
    chapterType?: ChapterType;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    customer?: string;
    
    
    
    customerBsGlAccount?: string;
    
    
    
    customerCostCenter?: string;
    
    
    
    primaryCostLoc?: number;
    
    
    
    isOverheadCalcLoc?: number;
    
    
    
    markupCalcLoc?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcInv?: number;
    
    
    
    totalCalcUsd?: number;
    
    
    
    vatCalcLoc?: number;
    
    
    
    vatCalcInv?: number;
    
    
    
    totalInclVatCalcLoc?: number;
    
    
    
    totalInclVatCalcInv?: number;
    
    
    
    totalInclVatCalcUsd?: number;
    
    
    
    totalCalcPoolingCurrency?: number;
    
}

export class PrimaryCostInvoiceItemModel extends BaseApiModelClass< IPrimaryCostInvoiceItemModel > implements IPrimaryCostInvoiceItemModel {
    
    
    id?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitPGDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    poolingEnabled?: boolean;
    
    
    
    costType?: string;
    
    
    
    chapterType?: ChapterType;
    
    
    
    pgId?: number;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
    
    
    localProfitCenter?: string;
    
    
    
    customer?: string;
    
    
    
    customerBsGlAccount?: string;
    
    
    
    customerCostCenter?: string;
    
    
    
    primaryCostLoc?: number;
    
    
    
    isOverheadCalcLoc?: number;
    
    
    
    markupCalcLoc?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcInv?: number;
    
    
    
    totalCalcUsd?: number;
    
    
    
    vatCalcLoc?: number;
    
    
    
    vatCalcInv?: number;
    
    
    
    totalInclVatCalcLoc?: number;
    
    
    
    totalInclVatCalcInv?: number;
    
    
    
    totalInclVatCalcUsd?: number;
    
    
    
    totalCalcPoolingCurrency?: number;
    
}

export interface IPrimaryCostInvoiceModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    reportingPeriodQuarterId?: number;
    
    
    
    quarter?: number;
    
    
    
    quarterStartDate?: Date;
    
    
    
    quarterEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostInvoiceStatus;
    
    
    
    reportingCurrencyDisplayName?: string;
    
    
    
    reportingCurrencyExchangeRate?: number;
    
    
    
    invoicingCurrencyDisplayName?: string;
    
    
    
    closingRate?: number;
    
}

export class PrimaryCostInvoiceModel extends BaseApiModelClass< IPrimaryCostInvoiceModel > implements IPrimaryCostInvoiceModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    reportingPeriodQuarterId?: number;
    
    
    
    quarter?: number;
    
    
    
    quarterStartDate?: Date;
    
    
    
    quarterEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostInvoiceStatus;
    
    
    
    reportingCurrencyDisplayName?: string;
    
    
    
    reportingCurrencyExchangeRate?: number;
    
    
    
    invoicingCurrencyDisplayName?: string;
    
    
    
    closingRate?: number;
    
}

export enum PrimaryCostInvoiceStatus {
    Draft = "Draft",
    ReadyForApproval = "ReadyForApproval",
    Approved = "Approved",
}

export interface IPrimaryCostReportInflowModel {
    
    
    quarterDisplayName?: string;
    
    
    
    year?: number;
    
    
    
    quarter?: number;
    
    
    
    status?: PrimaryCostReportStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    poolingEnabled?: boolean;
    
    
    
    localUnitDivision?: string;
    
    
    
    localUnitCompany?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    pgCode?: string;
    
    
    
    primaryCostLoc1?: number;
    
    
    
    primaryCostLoc2?: number;
    
    
    
    primaryCostLoc3?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcLocCurrency?: string;
    
    
    
    totalCalcUSD?: number;
    
}

export class PrimaryCostReportInflowModel extends BaseApiModelClass< IPrimaryCostReportInflowModel > implements IPrimaryCostReportInflowModel {
    
    
    quarterDisplayName?: string;
    
    
    
    year?: number;
    
    
    
    quarter?: number;
    
    
    
    status?: PrimaryCostReportStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    poolingEnabled?: boolean;
    
    
    
    localUnitDivision?: string;
    
    
    
    localUnitCompany?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    agileUnitDisplayName?: string;
    
    
    
    chapterDisplayName?: string;
    
    
    
    pgCode?: string;
    
    
    
    primaryCostLoc1?: number;
    
    
    
    primaryCostLoc2?: number;
    
    
    
    primaryCostLoc3?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcLocCurrency?: string;
    
    
    
    totalCalcUSD?: number;
    
}

export interface IPrimaryCostReportItemModel {
    
    
    id?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitPGDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    poolingEnabled?: boolean;
    
    
    
    costType?: string;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    primaryCostLoc1?: number;
    
    
    
    primaryCostLoc2?: number;
    
    
    
    primaryCostLoc3?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcUSD?: number;
    
}

export class PrimaryCostReportItemModel extends BaseApiModelClass< IPrimaryCostReportItemModel > implements IPrimaryCostReportItemModel {
    
    
    id?: number;
    
    
    
    agileUnitId?: number;
    
    
    
    agileUnitPGDisplayName?: string;
    
    
    
    chapterId?: number;
    
    
    
    chapterDisplayName?: string;
    
    
    
    poolingEnabled?: boolean;
    
    
    
    costType?: string;
    
    
    
    pgLocalErpCodeName?: string;
    
    
    
    costCenterErpId?: string;
    
    
    
    costCenterCfinId?: string;
    
    
    
    primaryCostLoc1?: number;
    
    
    
    primaryCostLoc2?: number;
    
    
    
    primaryCostLoc3?: number;
    
    
    
    totalCalcLoc?: number;
    
    
    
    totalCalcUSD?: number;
    
}

export interface IPrimaryCostReportItemRestApiModel {
    
    
    id: number;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    pG_Local_ERP: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_Local_ERP: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    pooling_enabled: boolean;
    
    
    
    "primary_Cost_Original_APP_[USD]": number;
    
    
    
    "iS_Overhead_Original_APP_[USD]": number;
    
    
    
    "markup_Original_APP_[USD]": number;
    
    
    
    "vAT_Original_APP_[USD]": number;
    
    
    
    "total_Refund_Original_APP_[USD]": number;
    
    
    
    "primary_Cost_Latest_APP_[USD]": number;
    
    
    
    "iS_Overhead_Latest_APP_[USD]": number;
    
    
    
    "markup_Latest_APP_[USD]": number;
    
    
    
    "vAT_Latest_APP_[USD]": number;
    
    
    
    "total_Refund_Latest_APP_[USD]": number;
    
    
    
    primary_Cost_Month_1_Reporting_Currency: number;
    
    
    
    primary_Cost_Month_2_Reporting_Currency: number;
    
    
    
    primary_Cost_Month_3_Reporting_Currency: number;
    
    
    
    primary_Cost_Reporting_Currency: number;
    
    
    
    iS_Overhead_Reporting_Currency: number;
    
    
    
    markup_Reporting_Currency: number;
    
    
    
    vAT_Reporting_Currency: number;
    
    
    
    total_Refund_Reporting_Currency: number;
    
    
    
    central_Unit_Total_Refund: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    reporting_Currency: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    invoicing_Rate: number;
    
    
    
    central_Unit_Reporting_Currency: string;
    
    
    
    central_Unit_Invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export class PrimaryCostReportItemRestApiModel extends BaseApiModelClass< IPrimaryCostReportItemRestApiModel > implements IPrimaryCostReportItemRestApiModel {
    
    
    id: number;
    
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    pG_Local_ERP: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_Local_ERP: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    pooling_enabled: boolean;
    
    
    
    "primary_Cost_Original_APP_[USD]": number;
    
    
    
    "iS_Overhead_Original_APP_[USD]": number;
    
    
    
    "markup_Original_APP_[USD]": number;
    
    
    
    "vAT_Original_APP_[USD]": number;
    
    
    
    "total_Refund_Original_APP_[USD]": number;
    
    
    
    "primary_Cost_Latest_APP_[USD]": number;
    
    
    
    "iS_Overhead_Latest_APP_[USD]": number;
    
    
    
    "markup_Latest_APP_[USD]": number;
    
    
    
    "vAT_Latest_APP_[USD]": number;
    
    
    
    "total_Refund_Latest_APP_[USD]": number;
    
    
    
    primary_Cost_Month_1_Reporting_Currency: number;
    
    
    
    primary_Cost_Month_2_Reporting_Currency: number;
    
    
    
    primary_Cost_Month_3_Reporting_Currency: number;
    
    
    
    primary_Cost_Reporting_Currency: number;
    
    
    
    iS_Overhead_Reporting_Currency: number;
    
    
    
    markup_Reporting_Currency: number;
    
    
    
    vAT_Reporting_Currency: number;
    
    
    
    total_Refund_Reporting_Currency: number;
    
    
    
    central_Unit_Total_Refund: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    reporting_Currency: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    invoicing_Rate: number;
    
    
    
    central_Unit_Reporting_Currency: string;
    
    
    
    central_Unit_Invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export interface IPrimaryCostReportItemUpdateModel {
    
    
    id?: number;
    
    
    
    primaryCostLoc1?: number;
    
    
    
    primaryCostLoc2?: number;
    
    
    
    primaryCostLoc3?: number;
    
}

export class PrimaryCostReportItemUpdateModel extends BaseApiModelClass< IPrimaryCostReportItemUpdateModel > implements IPrimaryCostReportItemUpdateModel {
    
    
    id?: number;
    
    
    
    primaryCostLoc1?: number;
    
    
    
    primaryCostLoc2?: number;
    
    
    
    primaryCostLoc3?: number;
    
}

export interface IPrimaryCostReportModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    reportingPeriodQuarterId?: number;
    
    
    
    quarter?: number;
    
    
    
    quarterStartDate?: Date;
    
    
    
    quarterEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostReportStatus;
    
    
    
    reportingCurrencyDisplayName?: string;
    
    
    
    reportingCurrencyExchangeRate?: number;
    
    
    
    invoicingCurrencyDisplayName?: string;
    
    
    
    closingRate?: number;
    
}

export class PrimaryCostReportModel extends BaseApiModelClass< IPrimaryCostReportModel > implements IPrimaryCostReportModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    primaryCostAgreementId?: number;
    
    
    
    reportingPeriodQuarterId?: number;
    
    
    
    quarter?: number;
    
    
    
    quarterStartDate?: Date;
    
    
    
    quarterEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostReportStatus;
    
    
    
    reportingCurrencyDisplayName?: string;
    
    
    
    reportingCurrencyExchangeRate?: number;
    
    
    
    invoicingCurrencyDisplayName?: string;
    
    
    
    closingRate?: number;
    
}

export enum PrimaryCostReportStatus {
    Draft = "Draft",
    ReadyForApproval = "ReadyForApproval",
    Approved = "Approved",
}

export interface IPrimaryCostReportWidgetModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    numberOfChaptersPooled?: number;
    
    
    
    numberOfChaptersOnlyReported?: number;
    
    
    
    status?: PrimaryCostReportStatus;
    
    
    
    route?: string;
    
    
    
    invoiceStatus?: PrimaryCostInvoiceStatus;
    
    
    
    hasInvoiceAttachment?: boolean;
    
}

export class PrimaryCostReportWidgetModel extends BaseApiModelClass< IPrimaryCostReportWidgetModel > implements IPrimaryCostReportWidgetModel {
    
    
    primaryCostAgreementId?: number;
    
    
    
    poolingEntity?: string;
    
    
    
    localUnitLocation?: string;
    
    
    
    numberOfChaptersPooled?: number;
    
    
    
    numberOfChaptersOnlyReported?: number;
    
    
    
    status?: PrimaryCostReportStatus;
    
    
    
    route?: string;
    
    
    
    invoiceStatus?: PrimaryCostInvoiceStatus;
    
    
    
    hasInvoiceAttachment?: boolean;
    
}

export interface IPrimaryCostYTDRestApiModel {
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    pG_Local_ERP: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_Local_ERP: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    "primary_Cost_Original_APP_[USD]": number;
    
    
    
    "iS_Overhead_Original_APP_[USD]": number;
    
    
    
    "markup_Original_APP_[USD]": number;
    
    
    
    "vAT_Original_APP_[USD]": number;
    
    
    
    "total_Refund_Original_APP_[USD]": number;
    
    
    
    "primary_Cost_Latest_APP_[USD]": number;
    
    
    
    "iS_Overhead_Latest_APP_[USD]": number;
    
    
    
    "markup_Latest_APP_[USD]": number;
    
    
    
    "vAT_Latest_APP_[USD]": number;
    
    
    
    "total_Refund_Latest_APP_[USD]": number;
    
    
    
    accrued_Primary_Cost_Reporting_Currency: number;
    
    
    
    accrued_IS_Overhead_Reporting_Currency: number;
    
    
    
    accrued_Markup_Reporting_Currency: number;
    
    
    
    accrued_VAT_Reporting_Currency: number;
    
    
    
    accrued_Total_Refund_Reporting_Currency: number;
    
    
    
    invoiced_Primary_Cost_Reporting_Currency: number;
    
    
    
    invoiced_IS_Overhead_Reporting_Currency: number;
    
    
    
    invoiced_Markup_Reporting_Currency: number;
    
    
    
    invoiced_VAT_Reporting_Currency: number;
    
    
    
    invoiced_Total_Refund_Reporting_Currency: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    reporting_Currency: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export class PrimaryCostYTDRestApiModel extends BaseApiModelClass< IPrimaryCostYTDRestApiModel > implements IPrimaryCostYTDRestApiModel {
    
    
    pooling_Entity: string;
    
    
    
    local_Unit_Division: string;
    
    
    
    local_Unit_Company: string;
    
    
    
    local_Unit_Location: string;
    
    
    
    pG_Local_ERP: string;
    
    
    
    cost_Type: string;
    
    
    
    cost_Center_ID_Local_ERP: string;
    
    
    
    cost_Center_ID_CFIN: string;
    
    
    
    function: string;
    
    
    
    subFunction: string;
    
    
    
    subFunction_Leader: string;
    
    
    
    "primary_Cost_Original_APP_[USD]": number;
    
    
    
    "iS_Overhead_Original_APP_[USD]": number;
    
    
    
    "markup_Original_APP_[USD]": number;
    
    
    
    "vAT_Original_APP_[USD]": number;
    
    
    
    "total_Refund_Original_APP_[USD]": number;
    
    
    
    "primary_Cost_Latest_APP_[USD]": number;
    
    
    
    "iS_Overhead_Latest_APP_[USD]": number;
    
    
    
    "markup_Latest_APP_[USD]": number;
    
    
    
    "vAT_Latest_APP_[USD]": number;
    
    
    
    "total_Refund_Latest_APP_[USD]": number;
    
    
    
    accrued_Primary_Cost_Reporting_Currency: number;
    
    
    
    accrued_IS_Overhead_Reporting_Currency: number;
    
    
    
    accrued_Markup_Reporting_Currency: number;
    
    
    
    accrued_VAT_Reporting_Currency: number;
    
    
    
    accrued_Total_Refund_Reporting_Currency: number;
    
    
    
    invoiced_Primary_Cost_Reporting_Currency: number;
    
    
    
    invoiced_IS_Overhead_Reporting_Currency: number;
    
    
    
    invoiced_Markup_Reporting_Currency: number;
    
    
    
    invoiced_VAT_Reporting_Currency: number;
    
    
    
    invoiced_Total_Refund_Reporting_Currency: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    reporting_Currency: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export interface IPrincipalConfigurationModel {
    
    
    key?: string;
    
    
    
    value?: string;
    
    
    
    group?: string;
    
}

export class PrincipalConfigurationModel extends BaseApiModelClass< IPrincipalConfigurationModel > implements IPrincipalConfigurationModel {
    
    
    key?: string;
    
    
    
    value?: string;
    
    
    
    group?: string;
    
}

export interface IPrincipalCreateModel {
    
    
    objectId: string;
    
}

export class PrincipalCreateModel extends BaseApiModelClass< IPrincipalCreateModel > implements IPrincipalCreateModel {
    
    
    objectId: string;
    
}

export interface IPrincipalModel {
    
    
    displayName: string;
    
    
    
    email?: string;
    
    
    
    code: string;
    
    
    
    country?: string;
    
    
    
    id?: number;
    
    
    
    value?: number;
    
    
    
    subDepartment?: string;
    
    
    
    objectId?: string;
    
}

export class PrincipalModel extends BaseApiModelClass< IPrincipalModel > implements IPrincipalModel {
    
    
    displayName: string;
    
    
    
    email?: string;
    
    
    
    code: string;
    
    
    
    country?: string;
    
    
    
    id?: number;
    
    
    
    readonly value?: number;
    
    
    
    subDepartment?: string;
    
    
    
    objectId?: string;
    
}

export interface IPrincipalPickerModel {
    
    
    graphNextLink?: string;
    
    
    
    principals: PrincipalModel[];
    
}

export class PrincipalPickerModel extends BaseApiModelClass< IPrincipalPickerModel > implements IPrincipalPickerModel {
    
    
    graphNextLink?: string;
    
    
    
    principals: PrincipalModel[];
    
}

export interface IPrincipalRoleItem {
    
    
    objectUid?: string;
    
    
    
    roleName?: string;
    
    
    
    link?: string;
    
}

export class PrincipalRoleItem extends BaseApiModelClass< IPrincipalRoleItem > implements IPrincipalRoleItem {
    
    
    objectUid?: string;
    
    
    
    roleName?: string;
    
    
    
    link?: string;
    
}

export interface IPrincipalRoleItemExtended {
    
    
    principalId?: number;
    
    
    
    principalDisplayName?: string;
    
    
    
    objectUid?: string;
    
    
    
    roleName?: string;
    
    
    
    link?: string;
    
}

export class PrincipalRoleItemExtended extends BaseApiModelClass< IPrincipalRoleItemExtended > implements IPrincipalRoleItemExtended {
    
    
    principalId?: number;
    
    
    
    principalDisplayName?: string;
    
    
    
    objectUid?: string;
    
    
    
    roleName?: string;
    
    
    
    link?: string;
    
}

export interface IProblemDetails {
    
    
    type?: string;
    
    
    
    title?: string;
    
    
    
    status?: number;
    
    
    
    detail?: string;
    
    
    
    instance?: string;
    
}

export class ProblemDetails extends BaseApiModelClass< IProblemDetails > implements IProblemDetails {
    
    
    type?: string;
    
    
    
    title?: string;
    
    
    
    status?: number;
    
    
    
    detail?: string;
    
    
    
    instance?: string;
    
}

export interface IQuarterModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
}

export class QuarterModel extends BaseApiModelClass< IQuarterModel > implements IQuarterModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
}

export interface IReportingPeriodDashboardModel {
    
    
    id?: number;
    
    
    
    codeName?: string;
    
    
    
    isCurrent?: boolean;
    
}

export class ReportingPeriodDashboardModel extends BaseApiModelClass< IReportingPeriodDashboardModel > implements IReportingPeriodDashboardModel {
    
    
    id?: number;
    
    
    
    codeName?: string;
    
    
    
    isCurrent?: boolean;
    
}

export enum ReportingPeriodEventType {
    Creation = "Creation",
    Deadline = "Deadline",
    Email = "Email",
}

export interface IReportingPeriodModel {
    
    
    id?: number;
    
    
    
    codeName?: string;
    
    
    
    displayName?: string;
    
    
    
    startDate?: Date;
    
    
    
    endDate?: Date;
    
    
    
    isCurrent?: boolean;
    
}

export class ReportingPeriodModel extends BaseApiModelClass< IReportingPeriodModel > implements IReportingPeriodModel {
    
    
    id?: number;
    
    
    
    codeName?: string;
    
    
    
    displayName?: string;
    
    
    
    startDate?: Date;
    
    
    
    endDate?: Date;
    
    
    
    isCurrent?: boolean;
    
}

export interface IReportingPeriodPrimaryCostAccrual {
    
    
    reportingPeriodId?: number;
    
    
    
    reportingPeriodDisplayName?: string;
    
}

export class ReportingPeriodPrimaryCostAccrual extends BaseApiModelClass< IReportingPeriodPrimaryCostAccrual > implements IReportingPeriodPrimaryCostAccrual {
    
    
    reportingPeriodId?: number;
    
    
    
    reportingPeriodDisplayName?: string;
    
}

export interface IReportingPeriodQuarterDashboardModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
    
    
    isCurrent?: boolean;
    
}

export class ReportingPeriodQuarterDashboardModel extends BaseApiModelClass< IReportingPeriodQuarterDashboardModel > implements IReportingPeriodQuarterDashboardModel {
    
    
    id?: number;
    
    
    
    displayName?: string;
    
    
    
    isCurrent?: boolean;
    
}

export interface IReportingPeriodYearWithAccruals {
    
    
    reportingPeriodYear?: number;
    
    
    
    accrualsReportingPeriod?: ReportingPeriodPrimaryCostAccrual[];
    
}

export class ReportingPeriodYearWithAccruals extends BaseApiModelClass< IReportingPeriodYearWithAccruals > implements IReportingPeriodYearWithAccruals {
    
    
    reportingPeriodYear?: number;
    
    
    
    accrualsReportingPeriod?: ReportingPeriodPrimaryCostAccrual[];
    
}

export interface IReportingScheduleEvent {
    
    
    id?: number;
    
    
    
    reportingPeriodId?: number;
    
    
    
    date?: Date;
    
    
    
    completedAt?: Date;
    
    
    
    createdAt?: Date;
    
    
    
    createdByPrincipalId?: number;
    
    
    
    modifiedAt?: Date;
    
    
    
    modifiedByPrincipalId?: number;
    
}

export class ReportingScheduleEvent extends BaseApiModelClass< IReportingScheduleEvent > implements IReportingScheduleEvent {
    
    
    id?: number;
    
    
    
    reportingPeriodId?: number;
    
    
    
    date?: Date;
    
    
    
    completedAt?: Date;
    
    
    
    createdAt?: Date;
    
    
    
    createdByPrincipalId?: number;
    
    
    
    modifiedAt?: Date;
    
    
    
    modifiedByPrincipalId?: number;
    
}

export interface IReportingScheduleEventModel {
    
    
    reportingPeriodId?: number;
    
    
    
    messageTypeId?: MessageTypeEnum;
    
    
    
    type?: ReportingPeriodEventType;
    
    
    
    date?: Date;
    
}

export class ReportingScheduleEventModel extends BaseApiModelClass< IReportingScheduleEventModel > implements IReportingScheduleEventModel {
    
    
    reportingPeriodId?: number;
    
    
    
    messageTypeId?: MessageTypeEnum;
    
    
    
    type?: ReportingPeriodEventType;
    
    
    
    date?: Date;
    
}

export interface IReportingScheduleModel {
    
    
    messageType?: MessageTypeEnum;
    
    
    
    messageTypeCodeName?: string;
    
    
    
    messageTypeDisplayName?: string;
    
    
    
    roleId?: number;
    
    
    
    roleDisplayName?: string;
    
    
    
    type?: ReportingPeriodEventType;
    
    
    
    events?: ReportingScheduleEvent[];
    
}

export class ReportingScheduleModel extends BaseApiModelClass< IReportingScheduleModel > implements IReportingScheduleModel {
    
    
    messageType?: MessageTypeEnum;
    
    
    
    messageTypeCodeName?: string;
    
    
    
    messageTypeDisplayName?: string;
    
    
    
    roleId?: number;
    
    
    
    roleDisplayName?: string;
    
    
    
    type?: ReportingPeriodEventType;
    
    
    
    events?: ReportingScheduleEvent[];
    
}

export interface IRevenueDataModel {
    
    
    reportingPeriodCodeName?: string;
    
    
    
    type?: RevenuesDataType;
    
    
    
    value?: number;
    
    
    
    pgCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    legalOrgUnitCodeName?: string;
    
}

export class RevenueDataModel extends BaseApiModelClass< IRevenueDataModel > implements IRevenueDataModel {
    
    
    reportingPeriodCodeName?: string;
    
    
    
    type?: RevenuesDataType;
    
    
    
    value?: number;
    
    
    
    pgCodeName?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    legalOrgUnitCodeName?: string;
    
}

export enum RevenuesDataType {
    Accruals = "Accruals",
    Invoicing = "Invoicing",
    YTD_Nominal = "YTD_Nominal",
    YTD_RF = "YTD_RF",
    YTD_Budget = "YTD_Budget",
}

export interface IRoleMemberModel {
    
    
    objectUniqueId?: string;
    
    
    
    roleId?: number;
    
    
    
    principalId?: number;
    
    
    
    principalEmail?: string;
    
    
    
    principalDisplayName?: string;
    
    
    
    isSystem?: boolean;
    
}

export class RoleMemberModel extends BaseApiModelClass< IRoleMemberModel > implements IRoleMemberModel {
    
    
    objectUniqueId?: string;
    
    
    
    roleId?: number;
    
    
    
    principalId?: number;
    
    
    
    principalEmail?: string;
    
    
    
    principalDisplayName?: string;
    
    
    
    isSystem?: boolean;
    
}

export enum SchedulerStatus {
    ServiceNotStarted = "ServiceNotStarted",
    WaitingForDatabase = "WaitingForDatabase",
    SchedulingJobs = "SchedulingJobs",
    FailedToStart = "FailedToStart",
    SchedulingPostponedJobs = "SchedulingPostponedJobs",
    Starting = "Starting",
    Started = "Started",
    ShuttingDown = "ShuttingDown",
    ShutDown = "ShutDown",
}

export interface IServiceAccrualItemModel {
    
    
    id?: number;
    
    
    
    pgCode?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    chapterType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
}

export class ServiceAccrualItemModel extends BaseApiModelClass< IServiceAccrualItemModel > implements IServiceAccrualItemModel {
    
    
    id?: number;
    
    
    
    pgCode?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    chapterType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
}

export interface IServiceAccrualItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    pgId?: number;
    
    
    
    serviceAgreementId?: number;
    
    
    
    agreementPGItemId?: number;
    
    
    
    pgDisplayName?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    location?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCalcPoolingCurrency?: number;
    
}

export class ServiceAccrualItemRow extends BaseApiModelClass< IServiceAccrualItemRow > implements IServiceAccrualItemRow {
    
    
    poolingEntityId?: number;
    
    
    
    pgId?: number;
    
    
    
    serviceAgreementId?: number;
    
    
    
    agreementPGItemId?: number;
    
    
    
    pgDisplayName?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    location?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    totalCalcPoolingCurrency?: number;
    
}

export interface IServiceAccrualModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAgreementId?: number;
    
    
    
    reportingPeriodId?: number;
    
    
    
    reportingPeriodStartDate?: Date;
    
    
    
    reportingPeriodEndDate?: Date;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: ServiceAccrualStatus;
    
}

export class ServiceAccrualModel extends BaseApiModelClass< IServiceAccrualModel > implements IServiceAccrualModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAgreementId?: number;
    
    
    
    reportingPeriodId?: number;
    
    
    
    reportingPeriodStartDate?: Date;
    
    
    
    reportingPeriodEndDate?: Date;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: ServiceAccrualStatus;
    
}

export interface IServiceAccrualOutflowModel {
    
    
    reportingPeriodDisplayName?: string;
    
    
    
    status?: ServiceAccrualStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitDivision?: string;
    
    
    
    serviceBeneficiaryUnitCompany?: string;
    
    
    
    serviceBeneficiaryUnitLocation?: string;
    
    
    
    pgCode?: string;
    
    
    
    pgName?: string;
    
    
    
    costType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    locCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
    
    
    uniqueId?: string;
    
}

export class ServiceAccrualOutflowModel extends BaseApiModelClass< IServiceAccrualOutflowModel > implements IServiceAccrualOutflowModel {
    
    
    reportingPeriodDisplayName?: string;
    
    
    
    status?: ServiceAccrualStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitDivision?: string;
    
    
    
    serviceBeneficiaryUnitCompany?: string;
    
    
    
    serviceBeneficiaryUnitLocation?: string;
    
    
    
    pgCode?: string;
    
    
    
    pgName?: string;
    
    
    
    costType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    locCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
    
    
    uniqueId?: string;
    
}

export enum ServiceAccrualStatus {
    Draft = "Draft",
    Approved = "Approved",
}

export interface IServiceAgreementCreateModel {
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
    
    
    statusId?: number;
    
}

export class ServiceAgreementCreateModel extends BaseApiModelClass< IServiceAgreementCreateModel > implements IServiceAgreementCreateModel {
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
    
    
    statusId?: number;
    
}

export interface IServiceAgreementModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    serviceBeneficiaryUnitDisplayName?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostAgreementStatus;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
}

export class ServiceAgreementModel extends BaseApiModelClass< IServiceAgreementModel > implements IServiceAgreementModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    poolingEntityId?: number;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    serviceBeneficiaryUnitDisplayName?: string;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: PrimaryCostAgreementStatus;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
}

export interface IServiceAgreementUpdateModel {
    
    
    id?: number;
    
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
    
    
    statusId?: number;
    
}

export class ServiceAgreementUpdateModel extends BaseApiModelClass< IServiceAgreementUpdateModel > implements IServiceAgreementUpdateModel {
    
    
    id?: number;
    
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    poolingEntityId?: number;
    
    
    
    paymentTerms?: number;
    
    
    
    cit?: boolean;
    
    
    
    statusId?: number;
    
}

export interface IServiceAnnualPlanItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAnnualPlanId?: number;
    
    
    
    agreementPGItemId?: number;
    
    
    
    valueUsd?: number;
    
    
    
    valueLoc?: number;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: AnnualPlanItemStatus;
    
    
    
    pgCodeName?: string;
    
    
    
    approvedByControllerPrincipalDisplayName?: string;
    
    
    
    approvedByManagerPrincipalDisplayName?: string;
    
    
    
    costType?: string;
    
    
    
    year?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    agreementDisplayName?: string;
    
}

export class ServiceAnnualPlanItemModel extends BaseApiModelClass< IServiceAnnualPlanItemModel > implements IServiceAnnualPlanItemModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAnnualPlanId?: number;
    
    
    
    agreementPGItemId?: number;
    
    
    
    valueUsd?: number;
    
    
    
    valueLoc?: number;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: AnnualPlanItemStatus;
    
    
    
    pgCodeName?: string;
    
    
    
    approvedByControllerPrincipalDisplayName?: string;
    
    
    
    approvedByManagerPrincipalDisplayName?: string;
    
    
    
    costType?: string;
    
    
    
    year?: string;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    agreementDisplayName?: string;
    
}

export interface IServiceAnnualPlanItemUpdateModel {
    
    
    id?: number;
    
    
    
    valueUsd?: number;
    
}

export class ServiceAnnualPlanItemUpdateModel extends BaseApiModelClass< IServiceAnnualPlanItemUpdateModel > implements IServiceAnnualPlanItemUpdateModel {
    
    
    id?: number;
    
    
    
    valueUsd?: number;
    
}

export interface IServiceAnnualPlanModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAgreementId?: number;
    
    
    
    agreementPGId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
}

export class ServiceAnnualPlanModel extends BaseApiModelClass< IServiceAnnualPlanModel > implements IServiceAnnualPlanModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAgreementId?: number;
    
    
    
    agreementPGId?: number;
    
    
    
    financialYearId?: number;
    
    
    
    validFrom?: Date;
    
    
    
    validTo?: Date;
    
    
    
    isCurrent?: boolean;
    
    
    
    localCurrencyDisplayName?: string;
    
    
    
    localCurrencyExchangeRate?: number;
    
}

export interface IServiceBeneficiaryUnitCreateModel {
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
}

export class ServiceBeneficiaryUnitCreateModel extends BaseApiModelClass< IServiceBeneficiaryUnitCreateModel > implements IServiceBeneficiaryUnitCreateModel {
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
}

export interface IServiceBeneficiaryUnitLocationCreateModel {
    
    
    serviceBeneficiaryUnitId?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    localUnitControllerPrincipalId?: number;
    
    
    
    localUnitInvoiceReceiverPrincipalId?: number;
    
    
    
    localUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalIds?: number[];
    
    
    
    beneficiaryUnitLocationFaoContactPrincipalIds?: number[];
    
}

export class ServiceBeneficiaryUnitLocationCreateModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationCreateModel > implements IServiceBeneficiaryUnitLocationCreateModel {
    
    
    serviceBeneficiaryUnitId?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    localUnitControllerPrincipalId?: number;
    
    
    
    localUnitInvoiceReceiverPrincipalId?: number;
    
    
    
    localUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalIds?: number[];
    
    
    
    beneficiaryUnitLocationFaoContactPrincipalIds?: number[];
    
}

export interface IServiceBeneficiaryUnitLocationModel {
    
    
    id?: number;
    
    
    
    serviceBeneficiaryUnitId?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    localUnitControllerPrincipalId?: number;
    
    
    
    localUnitControllerPrincipalDisplayName?: string;
    
    
    
    localUnitInvoiceReceiverPrincipalId?: number;
    
    
    
    localUnitInvoiceReceiverPrincipalDisplayName?: string;
    
    
    
    localUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    localUnitControllerDeputyPrincipalDisplayNames?: string;
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalIds?: number[];
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalDisplayNames?: string;
    
    
    
    faoContactPrincipalIds?: number[];
    
    
    
    faoContactPrincipalDisplayNames?: string;
    
}

export class ServiceBeneficiaryUnitLocationModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationModel > implements IServiceBeneficiaryUnitLocationModel {
    
    
    id?: number;
    
    
    
    serviceBeneficiaryUnitId?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    localUnitControllerPrincipalId?: number;
    
    
    
    localUnitControllerPrincipalDisplayName?: string;
    
    
    
    localUnitInvoiceReceiverPrincipalId?: number;
    
    
    
    localUnitInvoiceReceiverPrincipalDisplayName?: string;
    
    
    
    localUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    localUnitControllerDeputyPrincipalDisplayNames?: string;
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalIds?: number[];
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalDisplayNames?: string;
    
    
    
    faoContactPrincipalIds?: number[];
    
    
    
    faoContactPrincipalDisplayNames?: string;
    
}

export interface IServiceBeneficiaryUnitLocationPGCreateModel {
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
}

export class ServiceBeneficiaryUnitLocationPGCreateModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationPGCreateModel > implements IServiceBeneficiaryUnitLocationPGCreateModel {
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
}

export interface IServiceBeneficiaryUnitLocationPGModel {
    
    
    id?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    poNumberId?: number;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
    
    
    orgUnitDisplayName?: string;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    costType?: ChapterType;
    
}

export class ServiceBeneficiaryUnitLocationPGModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationPGModel > implements IServiceBeneficiaryUnitLocationPGModel {
    
    
    id?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    poNumberId?: number;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
    
    
    orgUnitDisplayName?: string;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
    
    
    costType?: ChapterType;
    
}

export interface IServiceBeneficiaryUnitLocationPGUpdateModel {
    
    
    id?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
}

export class ServiceBeneficiaryUnitLocationPGUpdateModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationPGUpdateModel > implements IServiceBeneficiaryUnitLocationPGUpdateModel {
    
    
    id?: number;
    
    
    
    orgUnitId?: number;
    
    
    
    localAccount?: string;
    
    
    
    cfinAccount?: string;
    
    
    
    localAccountSales?: string;
    
    
    
    cfinAccountSales?: string;
    
    
    
    localAccountGA?: string;
    
    
    
    localAccountCos?: string;
    
    
    
    cfinAccountGA?: string;
    
    
    
    cfinAccountCos?: string;
    
    
    
    localCostObjectSales?: string;
    
    
    
    localCostObjectGA?: string;
    
    
    
    localCostObjectCos?: string;
    
}

export interface IServiceBeneficiaryUnitLocationPgPONumberCreateModel {
    
    
    serviceBeneficiaryUnitLocationPgId?: number;
    
    
    
    poNumber?: string;
    
}

export class ServiceBeneficiaryUnitLocationPgPONumberCreateModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationPgPONumberCreateModel > implements IServiceBeneficiaryUnitLocationPgPONumberCreateModel {
    
    
    serviceBeneficiaryUnitLocationPgId?: number;
    
    
    
    poNumber?: string;
    
}

export interface IServiceBeneficiaryUnitLocationPgPONumberModel {
    
    
    id?: number;
    
    
    
    financialYearId?: number;
    
    
    
    financialYearDisplayName?: string;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
}

export class ServiceBeneficiaryUnitLocationPgPONumberModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationPgPONumberModel > implements IServiceBeneficiaryUnitLocationPgPONumberModel {
    
    
    id?: number;
    
    
    
    financialYearId?: number;
    
    
    
    financialYearDisplayName?: string;
    
    
    
    poNumberGA?: string;
    
    
    
    poNumberCos?: string;
    
    
    
    poNumberSales?: string;
    
}

export interface IServiceBeneficiaryUnitLocationPgPONumberUpdateModel {
    
    
    poNumberId?: number;
    
    
    
    poNumber?: string;
    
}

export class ServiceBeneficiaryUnitLocationPgPONumberUpdateModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationPgPONumberUpdateModel > implements IServiceBeneficiaryUnitLocationPgPONumberUpdateModel {
    
    
    poNumberId?: number;
    
    
    
    poNumber?: string;
    
}

export interface IServiceBeneficiaryUnitLocationUpdateModel {
    
    
    id?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    localUnitControllerPrincipalId?: number;
    
    
    
    localUnitInvoiceReceiverPrincipalId?: number;
    
    
    
    localUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalIds?: number[];
    
    
    
    beneficiaryUnitLocationFaoContactPrincipalIds?: number[];
    
}

export class ServiceBeneficiaryUnitLocationUpdateModel extends BaseApiModelClass< IServiceBeneficiaryUnitLocationUpdateModel > implements IServiceBeneficiaryUnitLocationUpdateModel {
    
    
    id?: number;
    
    
    
    location?: string;
    
    
    
    vatNumber?: string;
    
    
    
    tcd?: string;
    
    
    
    etcdCustomer?: string;
    
    
    
    localUnitControllerPrincipalId?: number;
    
    
    
    localUnitInvoiceReceiverPrincipalId?: number;
    
    
    
    localUnitControllerDeputyPrincipalIds?: number[];
    
    
    
    localUnitInvoiceReceiverDeputyPrincipalIds?: number[];
    
    
    
    beneficiaryUnitLocationFaoContactPrincipalIds?: number[];
    
}

export interface IServiceBeneficiaryUnitModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    legalOrgUnitFullName?: string;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    mgtOrgUnitCodeName?: string;
    
    
    
    mgtOrgUnitFullName?: string;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    reportingCurrencyCodeName?: string;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    invoicingCurrencyCodeName?: string;
    
}

export class ServiceBeneficiaryUnitModel extends BaseApiModelClass< IServiceBeneficiaryUnitModel > implements IServiceBeneficiaryUnitModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    legalOrgUnitCodeName?: string;
    
    
    
    legalOrgUnitFullName?: string;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    mgtOrgUnitCodeName?: string;
    
    
    
    mgtOrgUnitFullName?: string;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    reportingCurrencyCodeName?: string;
    
    
    
    invoicingCurrencyId?: number;
    
    
    
    invoicingCurrencyCodeName?: string;
    
}

export interface IServiceBeneficiaryUnitUpdateModel {
    
    
    id?: number;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
}

export class ServiceBeneficiaryUnitUpdateModel extends BaseApiModelClass< IServiceBeneficiaryUnitUpdateModel > implements IServiceBeneficiaryUnitUpdateModel {
    
    
    id?: number;
    
    
    
    legalOrgUnitId?: number;
    
    
    
    mgtOrgUnitId?: number;
    
    
    
    reportingCurrencyId?: number;
    
    
    
    invoicingCurrencyId?: number;
    
}

export interface IServiceBeneficiaryUnitWithServiceAgreementStatusModel {
    
    
    serviceAgreementId?: number;
    
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    serviceBeneficiaryUnitDisplayName?: string;
    
    
    
    serviceAgreementStatus?: PrimaryCostAgreementStatus;
    
}

export class ServiceBeneficiaryUnitWithServiceAgreementStatusModel extends BaseApiModelClass< IServiceBeneficiaryUnitWithServiceAgreementStatusModel > implements IServiceBeneficiaryUnitWithServiceAgreementStatusModel {
    
    
    serviceAgreementId?: number;
    
    
    
    serviceBeneficiaryUnitLocationId?: number;
    
    
    
    serviceBeneficiaryUnitDisplayName?: string;
    
    
    
    serviceAgreementStatus?: PrimaryCostAgreementStatus;
    
}

export interface IServiceInvoiceItemModel {
    
    
    id?: number;
    
    
    
    pgCode?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    chapterType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
    
    
    poNumber?: string;
    
    
    
    invoiceReference?: string;
    
}

export class ServiceInvoiceItemModel extends BaseApiModelClass< IServiceInvoiceItemModel > implements IServiceInvoiceItemModel {
    
    
    id?: number;
    
    
    
    pgCode?: string;
    
    
    
    pgDisplayName?: string;
    
    
    
    costType?: ChapterType;
    
    
    
    chapterType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    localBsGlAccount?: string;
    
    
    
    localPlGlAccount?: string;
    
    
    
    poNumber?: string;
    
    
    
    invoiceReference?: string;
    
}

export interface IServiceInvoiceModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAgreementId?: number;
    
    
    
    reportingPeriodQuarterId?: number;
    
    
    
    quarter?: number;
    
    
    
    quarterStartDate?: Date;
    
    
    
    quarterEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: ServiceInvoiceStatus;
    
    
    
    reportingCurrencyDisplayName?: string;
    
    
    
    reportingCurrencyExchangeRate?: number;
    
    
    
    invoicingCurrencyDisplayName?: string;
    
    
    
    closingRate?: number;
    
}

export class ServiceInvoiceModel extends BaseApiModelClass< IServiceInvoiceModel > implements IServiceInvoiceModel {
    
    
    id?: number;
    
    
    
    uniqueId?: string;
    
    
    
    serviceAgreementId?: number;
    
    
    
    reportingPeriodQuarterId?: number;
    
    
    
    quarter?: number;
    
    
    
    quarterStartDate?: Date;
    
    
    
    quarterEndDate?: Date;
    
    
    
    statusId?: number;
    
    
    
    statusDisplayName?: ServiceInvoiceStatus;
    
    
    
    reportingCurrencyDisplayName?: string;
    
    
    
    reportingCurrencyExchangeRate?: number;
    
    
    
    invoicingCurrencyDisplayName?: string;
    
    
    
    closingRate?: number;
    
}

export interface IServiceInvoiceOutflowModel {
    
    
    reportingPeriodQuarterDisplayName?: string;
    
    
    
    status?: ServiceInvoiceStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitDivision?: string;
    
    
    
    serviceBeneficiaryUnitCompany?: string;
    
    
    
    serviceBeneficiaryUnitLocation?: string;
    
    
    
    pgCode?: string;
    
    
    
    pgName?: string;
    
    
    
    costType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    locCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
}

export class ServiceInvoiceOutflowModel extends BaseApiModelClass< IServiceInvoiceOutflowModel > implements IServiceInvoiceOutflowModel {
    
    
    reportingPeriodQuarterDisplayName?: string;
    
    
    
    status?: ServiceInvoiceStatus;
    
    
    
    poolingEntityDisplayName?: string;
    
    
    
    serviceBeneficiaryUnitDivision?: string;
    
    
    
    serviceBeneficiaryUnitCompany?: string;
    
    
    
    serviceBeneficiaryUnitLocation?: string;
    
    
    
    pgCode?: string;
    
    
    
    pgName?: string;
    
    
    
    costType?: string;
    
    
    
    localCostObject?: string;
    
    
    
    serviceFee?: number;
    
    
    
    serviceFeeCurrency?: string;
    
    
    
    serviceFeeLoc?: number;
    
    
    
    locCurrency?: string;
    
    
    
    serviceFeeUsd?: number;
    
}

export enum ServiceInvoiceStatus {
    Draft = "Draft",
    Approved = "Approved",
}

export interface IServiceYTDRestApiModel {
    
    
    pooling_Entity: string;
    
    
    
    service_Beneficiary_Unit_Division: string;
    
    
    
    service_Beneficiary_Unit_Company: string;
    
    
    
    service_Beneficiary_Unit_Location: string;
    
    
    
    cost_Type: string;
    
    
    
    pG: string;
    
    
    
    pG_Manager: string;
    
    
    
    pG_Controller: string;
    
    
    
    "aPP_[USD]": number;
    
    
    
    accrued_Service_Fee_Invoicing_Currency: number;
    
    
    
    invoiced_Service_Fee_Invoicing_Currency: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export class ServiceYTDRestApiModel extends BaseApiModelClass< IServiceYTDRestApiModel > implements IServiceYTDRestApiModel {
    
    
    pooling_Entity: string;
    
    
    
    service_Beneficiary_Unit_Division: string;
    
    
    
    service_Beneficiary_Unit_Company: string;
    
    
    
    service_Beneficiary_Unit_Location: string;
    
    
    
    cost_Type: string;
    
    
    
    pG: string;
    
    
    
    pG_Manager: string;
    
    
    
    pG_Controller: string;
    
    
    
    "aPP_[USD]": number;
    
    
    
    accrued_Service_Fee_Invoicing_Currency: number;
    
    
    
    invoiced_Service_Fee_Invoicing_Currency: number;
    
    
    
    reporting_Period: string;
    
    
    
    financial_Year: string;
    
    
    
    invoicing_Currency: string;
    
    
    
    budget_Rate: number;
    
    
    
    budget_Rate_Year: number;
    
    
    
    budget_Rate_Currency: string;
    
}

export interface ITaskModel {
    
    
    id?: number;
    
    
    
    description?: string;
    
    
    
    dueDate?: Date;
    
    
    
    createdDate?: Date;
    
    
    
    messageType?: MessageTypeEnum;
    
    
    
    objectUniqueId?: string;
    
    
    
    groupObjectUniqueId?: string;
    
    
    
    objectHierarchy?: string;
    
}

export class TaskModel extends BaseApiModelClass< ITaskModel > implements ITaskModel {
    
    
    id?: number;
    
    
    
    description?: string;
    
    
    
    dueDate?: Date;
    
    
    
    createdDate?: Date;
    
    
    
    messageType?: MessageTypeEnum;
    
    
    
    objectUniqueId?: string;
    
    
    
    groupObjectUniqueId?: string;
    
    
    
    objectHierarchy?: string;
    
}

export interface IUpdateDbConfigurationModel {
    
    
    group?: string;
    
    
    
    key?: string;
    
    
    
    value?: string;
    
}

export class UpdateDbConfigurationModel extends BaseApiModelClass< IUpdateDbConfigurationModel > implements IUpdateDbConfigurationModel {
    
    
    group?: string;
    
    
    
    key?: string;
    
    
    
    value?: string;
    
}

export interface IYearWithLocationsSidebarModel {
    
    
    year?: number;
    
    
    
    locationsWithAgileUnits?: LocationsWithAgileUnitsSidebarModel[];
    
}

export class YearWithLocationsSidebarModel extends BaseApiModelClass< IYearWithLocationsSidebarModel > implements IYearWithLocationsSidebarModel {
    
    
    year?: number;
    
    
    
    locationsWithAgileUnits?: LocationsWithAgileUnitsSidebarModel[];
    
}

export interface IYearWithQuartersModel {
    
    
    year?: number;
    
    
    
    quarters?: QuarterModel[];
    
}

export class YearWithQuartersModel extends BaseApiModelClass< IYearWithQuartersModel > implements IYearWithQuartersModel {
    
    
    year?: number;
    
    
    
    quarters?: QuarterModel[];
    
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}